export const result = [
  [53.85, 8.98],
  [39.35, 22.95],
  [42.17, 9.87],
  [44.59, 37.92],
  [41.7, -83.48],
  [34.87, 136.94],
  [24.83, 67],
  [57.7, 11.95],
  [47.83, 35.17],
  [39.45, -0.33],
  [40.95, 28.9],
  [-5.95, 106.92],
  [38.22, 15.64],
  [46.48, -59.08],
  [34.46, 133.44],
  [49.49, -66.66],
  [52.88, -16.35],
  [40.96, 28.89],
  [62.4, -110.82],
  [39.28, -76.61],
  [55.3, -6.28],
  [53.63, -0.19],
  [45.98, -73.17],
  [-4.2, 152.18],
  [23.36, 116.71],
  [39.08, 26.88],
  [34.18, 129.3],
  [-21.29, 149.28],
  [56.6, 1.86],
  [59.97, 29.75],
  [38.27, 24.77],
  [66.02, 12.63],
  [76.32, 74.28],
  [10.4, -75.52],
  [45.51, -73.55],
  [40.65, 28.3],
  [40.47, 50.32],
  [25.53, 57.55],
  [49.87, -3.78],
  [1.07, 104.13],
  [61.93, 5.11],
  [69.06, 33.06],
  [6.3, 3.35],
  [54.3, -133.22],
  [45.27, -66.07],
  [50.79, -1.3],
  [49.12, -53.6],
  [49.08, 140.27],
  [57.67, 2.27],
  [50.17, -2.97],
  [56.63, -7.28],
  [55.21, 12.17],
  [-6.58, -160.15],
  [35.89, -5.32],
  [30.48, 122.51],
  [58.32, -5.13],
  [42.67, -80.13],
  [3.92, 6.65],
  [66.17, -65.69],
  [6.78, 117.68],
  [49.72, -4.57],
  [46.88, -70.95],
  [-2.22, 113.92],
  [49.02, -123.17],
  [21.31, -157.86],
  [42.34, -83.03],
  [5.42, 100.33],
  [49.51, 8.44],
  [47.6, -122.33],
  [50.33, 155.75],
  [68.97, 33.08],
  [49.3, -65.05],
  [62.88, 8.49],
  [37.79, 138.32],
  [49.47, -127.27],
  [43.13, -79.18],
  [46.95, -55.12],
  [41.88, 16.17],
  [5.2, 120.08],
  [-20.15, 57.48],
  [45.18, -66.1],
  [47.62, -70.08],
  [36.78, 24.03],
  [59.61, 5.77],
  [50.35, -0.95],
  [38, 24.76],
  [25.23, 56.52],
  [3.93, 108.15],
  [29.87, 32.47],
  [40.41, 29.09],
  [39.56, 2.64],
  [44.63, 37.64],
  [48.72, -3.98],
  [56.46, 10.04],
  [49.02, -68.16],
  [50.47, -0.02],
  [22.58, 120.28],
  [41.15, 29.05],
  [29.92, -90.09],
  [36.93, 27.28],
  [22.13, -80.45],
  [21.93, 91.38],
  [46.62, 142.77],
  [53.71, -0.81],
  [40.89, 29.19],
  [40.45, 26.93],
  [54.32, 10.13],
  [21.93, 91.38],
  [18.41, -77.11],
  [41.15, 29.05],
  [40.42, 27.92],
  [40.98, 28.95],
  [41, 28.96],
  [55, 11.9],
  [47.03, -61.88],
  [51.42, 2.62],
  [1.23, 103.59],
  [36, 27],
  [46.03, -73.12],
  [2.14, 104.5],
  [43.15, 51.6],
  [47.63, -122.33],
  [50.9, -1.41],
  [69.73, 30.05],
  [42.4, -82.83],
  [35.88, 14.5],
  [6.44, 3.39],
  [10.58, 107.02],
  [59, -2.98],
  [51.51, -2.71],
  [56, 3],
  [50.76, -1.54],
  [1.05, 118.15],
  [38.31, 26.26],
  [60.16, 24.94],
  [43.16, -79.19],
  [-1.27, 116.82],
  [-33.86, 151.21],
  [51.67, -5.21],
  [1.17, 103.98],
  [0.72, 104.17],
  [51.35, 4.28],
  [37.92, 23.6],
  [41.67, 130.12],
  [-18.29, 147.7],
  [62.18, 5.64],
  [27.64, 34.01],
  [22.32, 91.82],
  [42.65, 131.08],
  [46.82, -71.2],
  [53.33, 8.48],
  [51.7, 3.29],
  [48.57, -68.69],
  [51.86, 12.4],
  [59.88, 30.2],
  [1.07, 103.68],
  [-37.65, 176.17],
  [35.14, 33.93],
  [48.87, -5.17],
  [-4.06, 39.72],
  [33.62, 130.41],
  [40.15, 26.4],
  [51.26, 1.8],
  [1.33, 104.47],
  [32.3, -64.78],
  [1.07, 103.53],
  [52.46, 4.6],
  [49.27, -5.78],
  [49.3, -123.11],
  [50.6, 0.38],
  [59.97, 30.17],
  [40.76, 29.37],
  [36.14, -5.35],
  [54.85, 10.52],
  [-34.75, -57.83],
  [5.13, 73.5],
  [70.98, 24.58],
  [46.07, -73.12],
  [50.7, 0.6],
  [49.31, -123.1],
  [53.54, 9.78],
  [37.94, 23.64],
  [56.47, -2.98],
  [48.33, -70.87],
  [41, 39.12],
  [-5.92, 106],
  [48.48, -68.51],
  [43.66, -3.76],
  [-5.51, 105.3],
  [45.9, -122.73],
  [46.34, 30.64],
  [40.95, 28.88],
  [-3.3, 114.57],
  [39.28, -76.61],
  [49.18, -123.9],
  [40.41, 29.09],
  [46.55, -72.08],
  [53.71, 7.53],
  [33.27, 131.51],
  [41.31, 19.45],
  [27.5, -13.9],
  [54.37, 10.14],
  [53.55, 8.58],
  [35.92, 140.68],
  [54.65, 19.9],
  [53.9, 9.13],
  [42.03, 83.13],
  [38.3, 21.8],
  [36.84, 30.6],
  [53.91, 9.17],
  [49.83, -66.37],
  [35.13, 128.7],
  [55.46, 10.52],
  [51.82, 4.65],
  [38.98, 1.72],
  [37.98, 24.2],
  [70.28, 44.34],
  [10.25, -64.6],
  [43.05, 17.43],
  [40.98, 28.95],
  [-2.57, -44.38],
  [54.3, -133.95],
  [41.28, 29.03],
  [49.73, -3.86],
  [51.26, 4.39],
  [40.93, 28.84],
  [54.23, -131],
  [-15.94, -142.31],
  [34.69, 135.2],
  [55.97, 8.12],
  [40.64, -74.19],
  [48.35, -69.27],
  [43.6, -8.68],
  [50.17, -66.42],
  [6.93, 79.86],
  [-36.85, 174.78],
  [41.43, 28.88],
  [70.63, 29.72],
  [25.36, 56.37],
  [40.98, -74.05],
  [59.87, 30.23],
  [42.52, 155.72],
  [21.4, 72.15],
  [42.08, -83.12],
  [26.5, 50.2],
  [19.41, 59.67],
  [-4.07, 39.68],
  [63.38, -19.27],
  [3.47, 6.85],
  [64.14, -21.89],
  [70.98, 24.58],
  [42.75, -79.25],
  [40.41, 29.08],
  [51.32, 3.22],
  [48.96, -123.77],
  [40.41, 29.09],
  [45.4, -73.57],
  [48.38, -4.48],
  [9.36, -79.9],
  [40.77, 29.58],
  [49.87, -4.34],
  [63.62, 8.57],
  [41.31, 19.45],
  [41, 28.96],
  [40.66, 29.25],
  [45.14, -66.02],
  [53.89, 9.15],
  [37.5, 23.47],
  [-21.1, 55.52],
  [-3.17, -59.98],
  [47.59, -59.75],
  [38.1, 24.77],
  [54.52, 10.33],
  [54.85, 10.52],
  [35.32, -6.82],
  [40.96, 28.89],
  [37.94, 23.64],
  [56.45, 43.71],
  [68.42, 16],
  [40.84, 29.29],
  [-6.02, 105.97],
  [33.93, 130.93],
  [10.41, 107.14],
  [44.97, -74.9],
  [5.81, -55.16],
  [48.43, -123.42],
  [-39.07, 174.08],
  [45.49, -73.51],
  [33.33, 128.25],
  [52.11, 156.15],
  [45.34, 36.67],
  [54.32, 10.13],
  [47.22, -1.55],
  [36.72, 36.18],
  [31.45, 121.08],
  [37.94, 23.64],
  [53.45, -3],
  [11.94, 121.95],
  [57.05, 9.94],
  [51.02, -4.64],
  [21.33, -158.11],
  [1.21, 103.92],
  [41.18, 29.05],
  [-27.25, 153.25],
  [22.32, 91.82],
  [53.53, 9.95],
  [41.85, -82.55],
  [22.29, 114.16],
  [53.09, 7.37],
  [56.02, 3.43],
  [22.99, 116.54],
  [62.97, 7.03],
  [12.55, 43.48],
  [37.07, 126.17],
  [-29.87, 31.03],
  [51.26, 4.39],
  [50.48, 126.45],
  [14.6, 120.87],
  [35.89, 14.51],
  [41.8, -82.9],
  [-5.82, 116.37],
  [55.05, 10.62],
  [48.98, -123.17],
  [55.7, 10.97],
  [29.63, -89.95],
  [26.5, 128],
  [47.12, 39.41],
  [37.89, -24.74],
  [53.44, -3],
  [47.12, 39.41],
  [40.95, 28.67],
  [51.15, 1.68],
  [24.99, 121.31],
  [13.73, 121.03],
  [39.62, 19.95],
  [-37.83, 144.92],
  [-6.82, 39.32],
  [1.17, 105.16],
  [41.41, 41.43],
  [54.32, 9.67],
  [40.41, 29.09],
  [-1.78, -81.27],
  [50.63, -126.71],
  [52.93, 5.03],
  [-46.82, -75.12],
  [59.99, 25.6],
  [60.4, 5.32],
  [57.43, 11.6],
  [53.68, -132.22],
  [-5.93, 106],
  [45.13, 36.69],
  [43.93, -76.5],
  [30.12, -51.23],
  [33.95, 130.97],
  [35.43, 139.65],
  [-38.33, 144.89],
  [49.67, 0.18],
  [59.97, 30.17],
  [68.23, 14.57],
  [13.7, 100.57],
  [58.14, 8],
  [40.96, 28.89],
  [41.2, -8.75],
  [40.84, 29.29],
  [62.48, 6.15],
  [51.45, 4],
  [36.11, -5.31],
  [48.53, -68.66],
  [-6.97, 110.42],
  [-33.92, 18.44],
  [40.98, 28.95],
  [1.73, 102.38],
  [1.38, 103.98],
  [48.44, -123.39],
  [57.15, -2.07],
  [22.29, 114.16],
  [48.44, -89.18],
  [-33.91, 18.44],
  [38.16, 119.21],
  [51.4, 4.18],
  [51.63, 2.18],
  [48.5, -69.02],
  [46.67, 141.85],
  [44.1, 9.83],
  [40.64, 22.92],
  [41, 28.96],
  [50.4, -3.51],
  [42.82, -66.87],
  [38.76, 26.92],
  [23.72, 120.03],
  [55.23, -5.58],
  [50.63, 0.53],
  [1.76, 102.87],
  [57.35, -4.38],
  [62.37, 6.03],
  [-2.98, 113.04],
  [10.33, 123.93],
  [51.23, 2.92],
  [-6.05, 106.9],
  [52, 3.9],
  [46.3, -72.57],
  [37.78, 141.72],
  [41.13, -66.05],
  [54.72, 20.52],
  [35.08, 129.04],
  [58.72, 13.83],
  [41.99, 35.15],
  [42.5, 27.47],
  [39.62, 19.95],
  [-41.87, -73.83],
  [22.32, 91.82],
  [53.92, 7.82],
  [38.13, 13.36],
  [62.8, 20.06],
  [34.7, 134.83],
  [41.18, 29.05],
  [29.11, -90.21],
  [54.29, 9.67],
  [18.83, 105.77],
  [54.93, 10.83],
  [44.33, -56.02],
  [-3.68, -72.23],
  [48.68, -122.67],
  [49.58, -65.88],
  [54.05, 13.78],
  [49.31, -123.12],
  [36.72, -4.43],
  [-21.09, 52.62],
  [29.92, -90.09],
  [47.19, 39.69],
  [41.1, 29.05],
  [1.35, 104.23],
  [-20.78, 115.53],
  [29.18, -89.25],
  [-0.23, 117.57],
  [49.21, -63.67],
  [37.75, 23.43],
  [45.34, 36.67],
  [20.69, 107.18],
  [59.35, 24.05],
  [53.87, 10.67],
  [26.45, 56.12],
  [5.12, -5.9],
  [63.45, -20.27],
  [40.94, 28.87],
  [-8.16, 114.43],
  [26.7, 34.01],
  [60.07, 6.55],
  [13.71, 121.05],
  [43.13, -65.88],
  [51.43, 3.48],
  [-25.48, -48.53],
  [38.07, 25],
  [54.19, 12.09],
  [-45.02, -60.08],
  [-6.08, 106.9],
  [22.02, 91.46],
  [54.32, 10.13],
  [58.45, -78.1],
  [46.67, 141.85],
  [54.24, -130.62],
  [51.68, 2.18],
  [31.17, 32.33],
  [40.15, 26.4],
  [62.73, 7.17],
  [62.53, -73.87],
  [30.07, 32.57],
  [46.77, -84.96],
  [51.34, 3.85],
  [29.92, -89.05],
  [36.13, -5.35],
  [-17.49, 140.84],
  [5.51, 125.49],
  [47.63, -122.33],
  [34.81, 137.21],
  [63.67, -68.5],
  [54.3, -130.32],
  [51.63, -5.18],
  [48.68, -123.4],
  [38.25, 21.74],
  [10.2, -64.63],
  [-38.78, -62.29],
  [49.28, -123.11],
  [41.27, 29.03],
  [45.33, 28.85],
  [73, -91],
  [40.41, 29.09],
  [40.96, 28.89],
  [32.08, -81.09],
  [43.88, 13.45],
  [51.42, 3.6],
  [33.72, 135.35],
  [32.69, -117.15],
  [45.4, -73.63],
  [59.88, 30.22],
  [46.04, -73.12],
  [31.25, 121.5],
  [55.08, 14.72],
  [47.57, -59.12],
  [40.96, 28.89],
  [1.24, 103.96],
  [40.76, 28.67],
  [54.18, 10.09],
  [-0.87, 119.85],
  [57.75, 10.69],
  [-34.57, -58.35],
  [72.26, 39.62],
  [54.28, -130.35],
  [-1.53, -48.75],
  [21.93, 91.38],
  [37.88, 25.55],
  [41.46, -70.6],
  [25.12, 121.25],
  [39.36, 22.94],
  [33.96, 132.19],
  [40.47, 27.16],
  [50.2, -2.05],
  [53, 60],
  [-33.36, -60.07],
  [48.77, -123.2],
  [47.56, -52.71],
  [34.73, 10.77],
  [46.07, -73.08],
  [14.6, -61.06],
  [53.9, 9.13],
  [4.12, 7],
  [10.38, 107.12],
  [1.38, 103.98],
  [40.15, 26.4],
  [44.11, 9.83],
  [47.12, 39.41],
  [61.78, 2.83],
  [49.7, -128.84],
  [54.23, 13.7],
  [45.53, -73.53],
  [3.99, 9.61],
  [41.26, 29.07],
  [47.48, -70.23],
  [40.03, 26.32],
  [23.1, 113.23],
  [53.9, 9.13],
  [57.88, -6.63],
  [35.5, 139.77],
  [69.65, 18.96],
  [47.28, -53.98],
  [38.3, 21.8],
  [50.03, -3.8],
  [47.19, 39.69],
  [22.32, 91.82],
  [57.68, -2],
  [45.1, 147.89],
  [56.99, 9.29],
  [59.97, 30.17],
  [13.08, 100.88],
  [31.2, 29.89],
  [60.52, 28.19],
  [18.65, -91.85],
  [42.1, 11.78],
  [47.43, -70.43],
  [30.49, 114.25],
  [37.94, 23.64],
  [68.97, 33.08],
  [22.69, 114.57],
  [59.35, 10.58],
  [43.53, 16.46],
  [46.05, -73.12],
  [40.4, 27.32],
  [36.29, 30.19],
  [53.86, 4.82],
  [47.62, -61.5],
  [26.5, -87.67],
  [36.02, 32.82],
  [35.51, 129.38],
  [39.42, 2.23],
  [-23.84, 151.27],
  [-4.97, 10.74],
  [17.7, 83.3],
  [43.21, 47.51],
  [-32.68, -60.72],
  [51.3, 3.83],
  [46.01, -73.18],
  [48.29, -125.92],
  [49.89, -3.7],
  [50.23, 7.59],
  [36.78, 28.27],
  [41.17, 29.09],
  [78.75, 16],
  [-42.74, -65.05],
  [33.77, -118.25],
  [38.38, 26.15],
  [42.24, -8.72],
  [50.9, -1.41],
  [40.02, 26.3],
  [61.1, 5.5],
  [46.2, -72.83],
  [57.7, 11.95],
  [25.16, 121.39],
  [37.03, 27.43],
  [54.2, 4.77],
  [52.2, 4.22],
  [-34.33, -58.49],
  [34.06, 128.13],
  [36.84, 30.62],
  [36.05, 32.9],
  [48.87, -67.54],
  [38.32, 26.3],
  [-25.5, -48.52],
  [52.21, 2.24],
  [58.05, 14.32],
  [15.93, 56.71],
  [44.97, -74.87],
  [38.43, 15.9],
  [56.17, 44.21],
  [52.27, -128.68],
  [34.57, 137.75],
  [35.64, 139.79],
  [45.35, 36.47],
  [37.94, 23.64],
  [60.85, 5.07],
  [12.05, -61.75],
  [3.93, 98.75],
  [51.35, 4.29],
  [5.52, 5.73],
  [50.53, -1.24],
  [46.67, 142.75],
  [-4.07, 39.68],
  [43.1, 131.89],
  [-35.17, -56.55],
  [36.48, 22.95],
  [-20.68, 116.69],
  [54.22, -130.33],
  [62.73, 7.17],
  [35.12, 129.04],
  [16.7, -62.22],
  [10.7, 122.57],
  [55.62, 13.01],
  [-28.81, 33.33],
  [61.01, 4.62],
  [38.75, 22.87],
  [41, 28.96],
  [-5.51, 105.3],
  [-30.38, -51.06],
  [-37.85, 144.91],
  [59.98, 23.48],
  [48.08, -5.82],
  [36.72, -4.43],
  [39.62, 19.95],
  [7.07, -14.03],
  [47.63, -122.33],
  [52.48, 1.95],
  [48.94, -123.7],
  [50.72, 0.93],
  [21.1, 72.65],
  [51.45, 3.58],
  [33.75, 133.5],
  [39.25, 23],
  [18.57, -72.7],
  [79.05, 10.09],
  [51.05, 1.82],
  [6.93, 79.86],
  [50.52, -0.82],
  [36.13, -5.44],
  [25.37, 55.38],
  [63.75, 11.3],
  [46.32, -72.56],
  [34.24, 132.54],
  [35.88, 14.52],
  [55.2, -132.82],
  [51.26, 4.39],
  [37.93, 23.63],
  [-4.08, 39.66],
  [53.18, 5.43],
  [54.48, 13.58],
  [37.75, 23.43],
  [34.67, 138.95],
  [19.3, -81.38],
  [49.3, -123.15],
  [53.08, 7.38],
  [49.25, -64.18],
  [-35.03, 117.9],
  [39.45, 26.2],
  [19.12, 37.33],
  [58, 3],
  [47.2, 38.95],
  [30.27, 131.47],
  [1.27, 103.83],
  [54.12, 7.47],
  [54.65, 19.9],
  [54.92, 11.36],
  [37.75, 23.43],
  [40.84, 29.29],
  [48.39, -89.21],
  [37.28, 13.53],
  [49.3, -123.09],
  [50.8, -1.1],
  [10.35, 107.05],
  [32.71, -117.14],
  [53.72, -6.31],
  [51.43, 1.89],
  [54.67, 12.62],
  [52.97, 4.78],
  [45.18, 36.51],
  [45.83, 47.97],
  [37.97, 23.57],
  [44.1, 39.07],
  [32.2, 119.2],
  [37.95, 21.15],
  [45.55, -73.53],
  [49.29, -123.19],
  [34.68, 10.79],
  [54.61, -5.9],
  [40.85, 14.28],
  [-6.11, 106.89],
  [49.31, -123.21],
  [48.35, -89.22],
  [45.13, 36.69],
  [39.37, 22.93],
  [45.62, 13.67],
  [-35.02, -54.89],
  [38.39, 26.42],
  [31.44, 123.54],
  [66.52, 12.98],
  [52.78, -133.45],
  [52.45, 4.07],
  [40.93, 24.41],
  [39.28, -76.61],
  [54.32, 10.13],
  [-37.25, -56.92],
  [33.9, 35.52],
  [56.7, -2.47],
  [29.97, 32.55],
  [63.09, 7.46],
  [10.32, 123.92],
  [53.88, 9.13],
  [49.3, -123.08],
  [51.23, 2.92],
  [49.65, -3.65],
  [43.4, -1.67],
  [49.66, 0.16],
  [-8.75, 13.27],
  [40.81, 28.91],
  [40.88, 29.19],
  [50.4, -3.51],
  [41, 28.96],
  [54.32, 9.67],
  [47.79, -71.23],
  [1.27, 103.83],
  [48.65, -2.03],
  [44.66, -63.56],
  [35.89, 14.51],
  [3.07, 109.77],
  [49.32, -67.6],
  [53.59, 6.67],
  [22.59, 120.31],
  [40.96, 28.89],
  [46.38, -55.65],
  [-8.17, 114.43],
  [4.05, 9.7],
  [53.78, 9.42],
  [28.48, -16.23],
  [23.03, 70.22],
  [45.43, 12.33],
  [51.4, 4.2],
  [55.43, 13.83],
  [37.94, 23.64],
  [52.53, 4.27],
  [4.02, 4.02],
  [55.4, 154.38],
  [37.75, 23.43],
  [25.07, -77.32],
  [22.24, 113.58],
  [59.91, 10.73],
  [-29.88, 31],
  [48.17, -4.43],
  [35.95, 14.85],
  [-32.05, 115.68],
  [37.94, 23.64],
  [37.88, 23.55],
  [5.82, 118.12],
  [64.53, 40.5],
  [1.1, 103.57],
  [60, 26.27],
  [34.49, 133.73],
  [51.26, 4.39],
  [33.27, 131.51],
  [18.44, -93.18],
  [56.08, 92.77],
  [34.37, 22.13],
  [4.22, 7.38],
  [44.65, -63.58],
  [28.49, -13.86],
  [47.19, 39.69],
  [34.33, 137.32],
  [-0.25, 117.57],
  [51.9, 4.48],
  [59.42, 10.5],
  [47.15, 39.55],
  [54.62, 10.62],
  [41.7, -83.48],
  [46.18, 144.62],
  [36.75, 24.54],
  [28.13, -15.43],
  [42.96, -82.42],
  [57.69, -2],
  [47.55, -122.53],
  [4.48, 118.62],
  [22.59, 120.31],
  [44.42, 8.92],
  [56.8, 8.87],
  [47.55, -122.53],
  [14.58, 120.97],
  [44.53, 14.47],
  [4.47, 8.42],
  [1.05, 103.45],
  [-8.72, 13.32],
  [-23.84, 151.27],
  [-38.17, 144.87],
  [50.15, -5.07],
  [11.93, 79.83],
  [46.88, -2.13],
  [3.93, 4.75],
  [43.18, 79.2],
  [-37.83, 144.92],
  [33.95, 130.95],
  [51.29, 1.84],
  [63.44, 10.4],
  [42.82, 10.33],
  [39.17, 23.48],
  [43.67, -7.6],
  [46.37, -72.43],
  [53.48, 4.67],
  [15.84, -87.95],
  [78.23, 15.6],
  [14.87, 120.22],
  [1.27, 103.83],
  [40.15, 26.4],
  [36.28, 30.23],
  [22.97, 120.17],
  [19.08, -104.3],
  [40.19, 26.37],
  [9.93, 123.95],
  [45.34, 36.67],
  [42.5, 27.47],
  [49.55, -124.16],
  [-14.38, 40.7],
  [65.47, 12.21],
  [31.69, 121.81],
  [33.77, -118.21],
  [37.98, 24.42],
  [60.7, -46.03],
  [-38.78, -62.29],
  [29.92, -90.09],
  [43.28, -61.22],
  [62.43, 6.37],
  [42.88, -79.25],
  [38.7, 17.08],
  [51.9, 3.42],
  [42.8, -10.05],
  [4, 108.25],
  [36.95, 26.98],
  [-33.04, 137.59],
  [-26.23, -48.63],
  [50.21, -66.38],
  [35.44, 139.66],
  [47.58, -122.37],
  [40.63, 28.48],
  [29.18, -89.26],
  [-32.72, 16.45],
  [49.89, 3.15],
  [22.29, 114.16],
  [47.63, -52.92],
  [49.16, -123.51],
  [43.1, 131.89],
  [51.9, 4.48],
  [31.25, 32.31],
  [50.2, -2.17],
  [59.42, 10.5],
  [39.2, -76.47],
  [39.28, -76.61],
  [40.37, 28.88],
  [45.34, 36.67],
  [51.32, 3.22],
  [71.82, 32.38],
  [36.59, 36.19],
  [48.88, -63.97],
  [35.89, 14.51],
  [12.43, -15.32],
  [36.4, 118.4],
  [55.63, 21.15],
  [41.12, 29.08],
  [55.76, 49.03],
  [60.1, 5.39],
  [44.46, 12.25],
  [37.75, 23.43],
  [46.4, -72.38],
  [21.93, 91.38],
  [32.77, 22.65],
  [30.43, -9.63],
  [47.19, 39.69],
  [50.95, 156.95],
  [44.47, -63.5],
  [53.45, -3],
  [46.33, -72.55],
  [29.85, -89.98],
  [51.75, 4.17],
  [37.44, 24.95],
  [40.77, 29.92],
  [40.74, 13.94],
  [45.64, 47.71],
  [3.5, 5.5],
  [40.02, 26.3],
  [63.67, 9.41],
  [-32.91, 151.76],
  [44.74, 37.79],
  [50, 8.43],
  [51.42, 1.48],
  [49.22, -58.75],
  [37.94, 23.64],
  [63.16, 7.95],
  [50.67, -126.85],
  [40.78, 29.71],
  [42.3, -83.08],
  [24.99, 55.06],
  [36.84, 30.6],
  [50.03, -125.24],
  [-5.87, 105.75],
  [56.94, -7.43],
  [38.34, 21.84],
  [-33.88, -58.43],
  [55.6, 10.84],
  [52.46, 4.6],
  [38.99, 117.73],
  [-2.4, -44.28],
  [60.38, 5.3],
  [14.78, 42.95],
  [21.77, 91.71],
  [49.2, -123.12],
  [-12.02, -77.2],
  [44.3, 8.48],
  [36.59, 36.19],
  [42.02, -66.74],
  [59.08, 10.97],
  [52.17, 3.74],
  [51.45, 3.7],
  [6.32, 3.34],
  [53.77, 6.45],
  [59.87, 30.23],
  [58.75, -8.1],
  [40.84, 28.91],
  [1.05, 103.65],
  [54.23, 12.05],
  [13.68, 100.5],
  [45.28, 14.57],
  [16.17, -95.2],
  [55, 150],
  [53.88, 9.13],
  [10.22, -64.63],
  [29.87, 32.55],
  [24.53, 54.38],
  [10.32, 123.92],
  [52.47, 4.6],
  [49.56, -67.19],
  [63.68, 9.67],
  [40.78, 29.6],
  [14.82, 120.29],
  [41, 28.96],
  [22.85, 120.17],
  [41, 28.96],
  [53.55, 9.98],
  [37.94, 23.64],
  [34.62, 134.98],
  [-29.59, 160.23],
  [69.03, 41.16],
  [40.81, 14.29],
  [36.76, 34.65],
  [4.23, 4.53],
  [54.69, -5.7],
  [46.8, -71.2],
  [1.2, 103.58],
  [59.97, 30.17],
  [-8.58, 116.08],
  [37.57, 24.27],
  [52.87, 3.98],
  [-6.97, 110.42],
  [50.03, 9.03],
  [34.78, 126.38],
  [74.32, 19.84],
  [49.67, -136.78],
  [46.43, -72.27],
  [41, 28.96],
  [29.35, 47.93],
  [38.43, 15.9],
  [51.63, 2.32],
  [57.68, -3.05],
  [15.73, -88.6],
  [35.68, 140],
  [43, -82.42],
  [46.36, 48.04],
  [47.12, 39.41],
  [63.71, 22.7],
  [62.73, 7.17],
  [43.19, -79.2],
  [23.1, 113.23],
  [40.65, 29.27],
  [4.21, 8.07],
  [40.78, 30.4],
  [10.66, 107.02],
  [55.68, 10.19],
  [38.31, 26.26],
  [62.68, 123.23],
  [57.81, -6.8],
  [54.32, 10.13],
  [57.3, 10.92],
  [47.42, -70.4],
  [54.78, 155.38],
  [31.38, 121.57],
  [21.77, -86.57],
  [1.13, 103.92],
  [50, -3.08],
  [39.53, 20.22],
  [40.69, -74.14],
  [48.83, -123.34],
  [-33.33, -60.17],
  [43.77, -77.58],
  [44.63, 33.57],
  [33.6, -7.6],
  [-2.35, -79.98],
  [43.1, 131.87],
  [37.97, 23.57],
  [54.33, 9.73],
  [-19.67, 63.42],
  [59.97, 30.17],
  [53.4, 5.32],
  [46.5, -84.37],
  [18.48, -67.38],
  [34, 128.17],
  [40.95, 27.5],
  [53.92, 7.85],
  [-5.22, 114.41],
  [44.63, 33.57],
  [54.16, 9.38],
  [33.72, 130.27],
  [5.59, 5.38],
  [13.67, 121.05],
  [45.51, -73.55],
  [41.15, 29.05],
  [41.15, 29.05],
  [10.41, 107.14],
  [56.45, -5.62],
  [22.64, 90.82],
  [50.95, 1.85],
  [59.87, 30.23],
  [43.56, 10.31],
  [29.75, -93.33],
  [50.39, -1.43],
  [45.17, 36.56],
  [-21.29, 149.28],
  [60.4, -0.97],
  [37.1, 25.38],
  [56.93, 11.43],
  [57.25, 37.83],
  [-18.13, 178.43],
  [63.1, -19.38],
  [38.9, 16.6],
  [22.32, 91.82],
  [40.11, 26.37],
  [25.42, 55.45],
  [54.88, 10.42],
  [55.08, 14.68],
  [43.72, 15.78],
  [53.9, 11.46],
  [44.66, -63.57],
  [40.41, 29.09],
  [54.32, 13.1],
  [26.56, -97.43],
  [12.4, -19.18],
  [64.83, 11.62],
  [53.62, 7.16],
  [55.35, -131.66],
  [26.83, -79.25],
  [51.37, -55.58],
  [37.68, 23.59],
  [-6, 106.85],
  [41.12, 29.08],
  [4.75, 6.08],
  [30, 122.1],
  [60.85, 5.07],
  [53.98, -128.68],
  [53.88, 9.13],
  [51.92, 3.73],
  [-19.26, 146.83],
  [36.52, 1.32],
  [-37, 144],
  [48.81, -68.38],
  [68.97, 33.08],
  [35.32, -6.82],
  [69.3, 41.63],
  [55.68, 11.09],
  [53.33, 8.49],
  [22.67, 69],
  [25.25, 55.05],
  [43.75, -65.32],
  [29.05, 49.76],
  [1.68, 101.45],
  [40.71, -74.01],
  [43.13, -6.17],
  [40.71, -74.01],
  [69.83, 20.78],
  [60.42, -3.8],
  [36.73, 27.7],
  [22.14, 91.72],
  [54.98, 39.05],
  [49.28, -123.18],
  [41, 28.96],
  [12.92, 74.8],
  [43.59, 28.75],
  [31.25, 121.5],
  [49.29, -123.19],
  [59.87, 30.23],
  [10.93, 108.1],
  [38.8, 15.24],
  [4.63, 5.42],
  [66.23, 12.52],
  [48.33, -70.87],
  [-2.53, 140.72],
  [55.92, 10.34],
  [45.28, -73.92],
  [51.65, 1.64],
  [37.75, 23.43],
  [25.37, 55.38],
  [52.18, 3.75],
  [22.32, 91.82],
  [60.09, 5.97],
  [54.72, 20.52],
  [49.16, -122.97],
  [40.97, 28.97],
  [54.65, -1.1],
  [65.73, 24.57],
  [42.8, 132.88],
  [48.87, -123.63],
  [-5.93, 106],
  [58.97, 5.72],
  [47.7, -87.5],
  [34.48, 35.83],
  [50.45, -126.02],
  [59.77, 5.78],
  [13.73, 121.04],
  [53.1, 1.43],
  [52.34, 3.17],
  [1.05, 103.67],
  [45.34, 36.67],
  [57, 18.58],
  [20.9, -17.05],
  [36.58, 14.87],
  [46.42, -72.38],
  [40.86, 29.12],
  [50.9, 1.51],
  [13.13, 123.73],
  [22.48, 113.87],
  [54.1, 7.83],
  [58.62, 16.25],
  [27.88, 50.36],
  [-19.92, 35.09],
  [49.23, -123.4],
  [1.33, 104.25],
  [46.36, 48.04],
  [54.95, 20.37],
  [47.19, 39.69],
  [68.16, 39.74],
  [4.08, 5.42],
  [59.99, 29.77],
  [59.45, 24.76],
  [46.36, 48.04],
  [3.8, 98.72],
  [46.73, -92.15],
  [40.77, 29.72],
  [49.04, -123.3],
  [1.27, 103.83],
  [10.23, 107.03],
  [55.68, 11.09],
  [42.5, 27.47],
  [10.7, 122.57],
  [-23.84, 151.27],
  [1.35, 104.6],
  [18.9, 72.82],
  [45.51, -73.55],
  [49.93, -3.53],
  [-5.51, 105.3],
  [58.88, 3.95],
  [34.22, 163.77],
  [47.82, -173.02],
  [53.87, 10.67],
  [58.02, 7.48],
  [41.48, 28.95],
  [53.25, 8.47],
  [43.13, -79.2],
  [24.83, 67],
  [14.59, -17.32],
  [58.12, 23.98],
  [30.47, -91.2],
  [51.35, 4.25],
  [41.12, 29.08],
  [30.22, 122.62],
  [1.11, 104.19],
  [53.55, 8.58],
  [56.5, -1.12],
  [22.29, 114.16],
  [49.15, -64.12],
  [47.32, 138.93],
  [4.89, -1.75],
  [44.67, -63.6],
  [46.08, -47.67],
  [29.97, 32.55],
  [-37.65, 176.17],
  [45.02, -74.66],
  [51.5, -0.07],
  [55.9, -6.11],
  [51.8, 4.9],
  [54.77, -0.8],
  [21.93, 91.38],
  [40.77, 29.43],
  [53.65, 5.4],
  [52.26, 8.34],
  [69.65, 18.96],
  [-4.75, 11.78],
  [36.3, 30.48],
  [51.78, 3.33],
  [49.12, -123.07],
  [50.77, 159.48],
  [41.37, 28.98],
  [52.4, 4.87],
  [51.33, 3.82],
  [37.84, 23.48],
  [63.07, 8.23],
  [49.98, -5.85],
  [44.6, 33.58],
  [47.33, 3.08],
  [46, 38.5],
  [25.96, -97.39],
  [-4.78, 11.83],
  [4, 98.9],
  [5.22, -4.03],
  [47.21, 38.95],
  [51.22, 1.7],
  [41, 28.96],
  [45.22, 29.76],
  [43.18, -67.18],
  [40.55, -69.14],
  [40.98, 28.95],
  [35.58, 140.13],
  [5.81, 118.08],
  [1.27, 103.83],
  [50.7, 0.83],
  [21.31, -157.86],
  [8, 125],
  [41.94, 36.46],
  [41.12, 29.08],
  [25.14, 121.75],
  [44.3, 75.98],
  [53.63, 7.75],
  [45.62, -73.48],
  [47.93, -122.49],
  [40.66, 29.01],
  [46.27, -72.71],
  [45.57, -73.5],
  [3, 101.4],
  [40.76, 29.76],
  [25.59, 55.58],
  [41.15, 29.05],
  [53.74, -0.28],
  [55.47, 8.43],
  [54.33, -130.28],
  [4.12, 4.97],
  [10.27, -64.7],
  [48.83, -67.57],
  [37.74, -25.68],
  [-24.23, 113.39],
  [60.82, 5],
  [45.15, 36.51],
  [54.72, 20.52],
  [-43.61, 172.73],
  [31.29, 121.75],
  [41, 28.96],
  [59.64, 10.63],
  [49.15, -55.32],
  [-33.04, 17.99],
  [38.13, 15.58],
  [49.12, -123.17],
  [36.23, 33.98],
  [53.64, 0.46],
  [54.33, 10.15],
  [-36.85, 174.78],
  [40.41, 29.09],
  [37.72, -25.63],
  [42.98, -82.43],
  [13.72, 73.08],
  [13.75, 121.05],
  [-22.66, -40.24],
  [38.26, 21.52],
  [32.95, 22.17],
  [-70.56, -8.93],
  [76.88, 70.18],
  [49.45, 11.05],
  [57.93, -5.72],
  [43.1, 131.89],
  [46.85, -70.98],
  [37.94, 23.64],
  [41.18, 29.05],
  [41.19, -8.7],
  [49.18, -122.9],
  [43.1, 131.89],
  [57.93, 18.8],
  [18.47, -66.12],
  [47.55, -52.71],
  [21.47, 39.17],
  [50.33, -4.15],
  [-4.67, 55.47],
  [31.25, 121.5],
  [-11.57, 116.39],
  [69.65, 18.96],
  [-22.96, 14.51],
  [54.83, 10.98],
  [40.15, 26.4],
  [54.57, 13.66],
  [45.35, 36.47],
  [3.54, 6.19],
  [41.4, -70.62],
  [-12.45, 130.84],
  [-4.97, 10.74],
  [13.49, -61.57],
  [50.98, 1.3],
  [-9.73, 61.31],
  [62.31, 6.95],
  [1.2, 104.08],
  [70.88, 18.63],
  [71.88, -80.87],
  [54.56, 10.74],
  [37.57, 22.8],
  [49.63, -5.65],
  [47.63, -122.33],
  [67.28, 14.37],
  [45.33, 28.85],
  [55.56, 9.75],
  [59.35, 143.17],
  [43.56, 10.31],
  [36.8, 34.64],
  [36.77, 3.05],
  [37.97, 23.57],
  [62.28, 7.18],
  [3.77, 98.67],
  [53.65, 5.4],
  [59.98, 6.02],
  [59.98, 26.2],
  [50.66, 0.16],
  [5.95, 119.83],
  [49.8, -3.32],
  [50.68, 156.12],
  [47.19, 39.69],
  [16.08, -24.97],
  [43.22, 79.21],
  [68.23, 14.57],
  [48.33, -123.33],
  [51.8, 4.02],
  [54.17, 12.08],
  [54.85, 5.8],
  [53.36, 7.19],
  [46.82, -71.18],
  [49.5, -66],
  [49.2, -123.12],
  [1.13, 103.92],
  [40.96, 28.89],
  [47.19, 39.69],
  [31.82, 34.65],
  [37.9, 23],
  [37.44, 24.94],
  [39.35, 22.95],
  [20.87, 106.67],
  [3.8, 98.72],
  [40.97, 27.97],
  [1.17, 104],
  [36.12, -5.38],
  [36.97, -76.33],
  [27.75, -91.09],
  [49.95, -5.7],
  [48.37, 14.02],
  [36.8, 34.64],
  [45.32, -73.9],
  [53.36, 7.19],
  [38, 141.52],
  [58.97, 5.73],
  [40.65, -8.71],
  [50.58, 0.37],
  [49.13, -4.63],
  [47.43, -44.95],
  [49.02, -66.98],
  [48.12, -122.75],
  [47.79, -54.14],
  [56.47, 3.41],
  [42.37, -71.05],
  [46.63, 142.9],
  [22.62, 117.17],
  [-33.97, 151.22],
  [49.17, -67.17],
  [22.59, 120.31],
  [12, 48],
  [-15.93, 112.77],
  [1.19, 103.43],
  [2.46, 7.45],
  [51.26, 4.39],
  [49.24, -64.75],
  [50.6, 0.35],
  [51.9, 4.48],
  [41.52, -90.5],
  [-5.87, 13.03],
  [46.94, 32.02],
  [39.57, 2.63],
  [42.8, 132.88],
  [51.02, 1.35],
  [27.93, 121.17],
  [-7.17, 112.67],
  [40.03, 26.07],
  [54.73, 1.13],
  [50.28, -125.2],
  [47.53, -61.57],
  [9.4, -13.73],
  [44.3, 8.48],
  [56.08, 11.02],
  [6.33, 118.13],
  [1.35, 104.23],
  [54.5, 10.36],
  [32.38, -117.33],
  [56.15, 11.17],
  [23.03, 70.22],
  [53.68, -0.55],
  [53.7, 7.8],
  [40.64, 22.92],
  [53.91, 9.17],
  [60.99, 35.51],
  [40.93, 28.87],
  [54.32, 10.13],
  [-0.26, 117.57],
  [1.17, 103.96],
  [-4.03, 116.03],
  [4.25, 103.17],
  [-17.58, 178.68],
  [44.13, 28.79],
  [49.66, 0.16],
  [45.63, -73.48],
  [12.42, -70.14],
  [13.38, 121.17],
  [10.18, -64.79],
  [39.86, -75.22],
  [46.92, -70.88],
  [48.9, -5.2],
  [37.75, 23.43],
  [33.75, -118.28],
  [55.9, 14.66],
  [33.51, 129.66],
  [48.38, -4.48],
  [11.53, 43.15],
  [59, 2],
  [53.9, 9.16],
  [54.15, -4.47],
  [54.96, 11.85],
  [49.18, -2.12],
  [58.97, 5.74],
  [37.94, 23.64],
  [45.3, -73.93],
  [29.01, -89.34],
  [37.87, 119.25],
  [71.72, 45.3],
  [-33.67, -59.63],
  [40.96, 28.89],
  [20.9, 70.37],
  [56.46, 10.04],
  [36.84, 30.61],
  [46.92, -70.89],
  [39.53, 2.62],
  [59.13, 10.23],
  [45.13, -87.42],
  [39.62, 19.95],
  [53.86, 8.71],
  [63, 7.12],
  [40.4, 29.07],
  [42.1, 11.77],
  [47.92, -65.27],
  [35.12, 129.04],
  [41.15, 29.05],
  [1.42, 104.62],
  [38.02, 24.42],
  [47.73, -60.42],
  [46.27, -84.15],
  [46.18, -123.85],
  [6.28, 3.22],
  [59.97, 30.17],
  [14.69, -17.43],
  [40.41, 29.08],
  [49.81, -3.4],
  [33.75, -118.28],
  [46.15, 47.82],
  [37.44, 24.94],
  [23.36, 116.71],
  [57.27, 16.57],
  [63.8, 8.67],
  [41.29, 36.33],
  [70.17, 20.92],
  [25.1, 66.72],
  [65.85, 13.19],
  [48.52, -122.62],
  [61.29, 35.54],
  [39.02, 23.13],
  [41.45, 31.78],
  [10.3, 123.92],
  [35.9, 14.52],
  [29.75, -95.33],
  [47.57, -122.62],
  [10.19, -64.78],
  [41.18, 29.05],
  [30.68, 122.57],
  [50.55, -3.5],
  [12.25, 109.18],
  [54.59, -1.17],
  [31.25, 121.5],
  [-12.02, -77.19],
  [66.15, -65.72],
  [27.17, 123.08],
  [34.63, 33],
  [37.43, 24.95],
  [10.18, -64.8],
  [59.38, 22.2],
  [40.88, 29.21],
  [41.28, 29.03],
  [58.32, 6.25],
  [1.08, 104.03],
  [-5.88, 106],
  [22.29, 114.16],
  [64.53, 40.5],
  [1.27, 103.83],
  [36.14, -5.35],
  [68.43, 17.43],
  [25.28, 51.53],
  [68.97, 33.08],
  [-4.75, 11.78],
  [58.31, -134.42],
  [59.33, 18.08],
  [2.87, 4.87],
  [49.58, 142.2],
  [-20.16, 57.5],
  [46.32, -72.56],
  [25.47, 55.49],
  [48.38, -123.34],
  [-16.95, 145.77],
  [58.13, 12.12],
  [51.51, -0.06],
  [41.12, 29.08],
  [40.2, 26.42],
  [58.93, 6.1],
  [51.87, 3.45],
  [42.65, 131.08],
  [5.41, 5.48],
  [41.15, 29.05],
  [34.69, 135.2],
  [41, 28.96],
  [40.4, 27.3],
  [58.34, -6.86],
  [35.89, -5.32],
  [10.77, 106.72],
  [41.12, 29.08],
  [1.19, 103.57],
  [60.03, 20.36],
  [-1.27, 116.82],
  [51.8, -55.6],
  [39.12, 23.75],
  [34.24, 10.19],
  [47.25, -122.42],
  [39.6, -31.13],
  [68.8, 16.54],
  [-35.16, -55.48],
  [41.26, 31.43],
  [35.44, 139.66],
  [-23.84, 151.27],
  [43.68, 7.28],
  [1.36, 103.55],
  [-18, 122.21],
  [44.87, 13.85],
  [62.6, 6.45],
  [45.62, -73.48],
  [55.47, 8.37],
  [45.17, 36.51],
  [33.97, 135.92],
  [50.8, -1.1],
  [-20.32, 118.58],
  [43.56, 10.31],
  [58.7, 18.12],
  [26.52, -78.77],
  [43.02, 3.06],
  [39.45, -0.33],
  [35.34, 25.15],
  [38.02, 24.42],
  [50.93, 1.31],
  [49.95, -5.07],
  [47.77, -54],
  [51.44, 3.64],
  [3.07, 6.95],
  [47.55, -52.58],
  [50.67, 2.23],
  [46.67, 141.85],
  [61.79, -120.71],
  [-20.85, 116.2],
  [46.48, -72.24],
  [9.38, -13.72],
  [54.32, -130.32],
  [54.37, 10.11],
  [51.39, 3.57],
  [10.22, -64.63],
  [54.25, -0.01],
  [61.47, 35.13],
  [35.33, 33.32],
  [50.8, -1.1],
  [21.93, 91.38],
  [57.68, -2],
  [37.6, -0.98],
  [3.93, 98.82],
  [60.06, -3.95],
  [-22.88, -43.12],
  [51.4, 3.17],
  [51.04, 2.35],
  [18.57, -72.4],
  [41.12, 29.08],
  [-6.11, 106.89],
  [45.55, 13.72],
  [46.92, 70.88],
  [47.68, -53.22],
  [59.63, -151.5],
  [57.78, -152.4],
  [45.13, 36.69],
  [49.3, -65.48],
  [46.93, -61.82],
  [4.21, 6.98],
  [46.05, -73.12],
  [34.72, -76.7],
  [40.6, 18.88],
  [36.82, 28.3],
  [-32.37, 18.17],
  [43.6, -4.91],
  [10.32, 123.92],
  [55.33, 12.46],
  [59.78, 5.52],
  [-20.15, 57.48],
  [-22.28, 166.46],
  [20.73, 79.49],
  [37.7, 24.07],
  [37.03, 27.44],
  [47.81, -122.39],
  [12.12, -68.93],
  [10.32, 123.92],
  [37.94, 23.64],
  [50.71, -127.49],
  [45.93, -73.22],
  [45.35, 36.62],
  [51.5, 0.13],
  [40.2, 26.4],
  [54.32, -130.92],
  [53.52, 8.58],
  [59, -2.98],
  [61.6, 5.03],
  [44.11, 9.83],
  [13.68, 53.69],
  [40.78, 29.61],
  [40.02, 26.18],
  [49.25, -68.13],
  [50.57, -2.43],
  [51.04, 2.35],
  [61.2, -48.1],
  [39.15, 23.83],
  [35.51, 129.38],
  [48.77, -123.45],
  [67.29, 14.39],
  [68.8, 16],
  [49.3, -123.07],
  [46.47, 30.9],
  [21.97, 113.21],
  [42.8, 132.88],
  [59.94, 30.28],
  [38.32, 26.3],
  [40.98, 29.02],
  [49.15, 36.48],
  [40.71, -74.01],
  [45.51, -73.55],
  [49.93, -124.85],
  [63.29, 8.15],
  [57.12, 8.58],
  [31.25, 32.3],
  [10.32, 123.92],
  [53.62, 7.16],
  [39.17, 23.48],
  [37.8, 24.08],
  [13.75, 121.05],
  [53.33, 8.48],
  [-0.88, -89.6],
  [47.56, -52.7],
  [54.32, 10.13],
  [46.73, 38.28],
  [36.75, 22.57],
  [41.35, 2.17],
  [14.93, 42.88],
  [53.55, 8.58],
  [71.13, 26.22],
  [37.94, 23.64],
  [10.75, 106.75],
  [42.4, -8.7],
  [24.63, -81.05],
  [49.2, -7.18],
  [-14.28, -170.69],
  [48.87, -123.62],
  [10.65, -61.52],
  [50.38, -2.05],
  [0.65, 101.62],
  [1.07, 103.57],
  [47.3, -2.12],
  [51.92, 3.18],
  [19.73, -155.07],
  [25.43, 119.85],
  [49.44, -65.49],
  [38.44, 27.16],
  [38.93, 23.07],
  [59.32, 5.32],
  [48.85, -65.58],
  [38.78, 26.97],
  [49.02, -123.15],
  [6.66, 122.53],
  [43.1, 131.89],
  [54.64, -5.87],
  [36.76, 137.22],
  [44.87, 13.85],
  [64.55, 5.2],
  [21.95, 69.15],
  [39.49, 20.26],
  [25.27, 55.29],
  [60.16, -1.14],
  [43.53, -7.03],
  [10.32, -75.52],
  [49.28, -123.3],
  [54.52, 13.63],
  [33.72, 135.35],
  [-1.25, 116.78],
  [32.01, 120.82],
  [46.82, -71.2],
  [50.5, 0.33],
  [14.55, 120.88],
  [-20.15, 57.48],
  [39.35, 22.95],
  [1.17, 103.39],
  [13.77, 109.23],
  [46.03, 143.33],
  [61.3, 35.65],
  [37.95, 23.62],
  [40.9, 3.72],
  [55.68, 11.09],
  [50.6, -127.08],
  [58.62, -3.53],
  [53.12, 5.55],
  [43.56, 10.31],
  [48.96, -63.92],
  [40.92, 149.07],
  [60.28, 28.73],
  [49.3, -123.05],
  [33.93, 130.93],
  [18.96, 58.89],
  [-6.98, 112.7],
  [55.68, 11.09],
  [44.85, -87.35],
  [54.7, 20.45],
  [5.81, 118.08],
  [-12.05, -77.14],
  [42.8, 132.88],
  [36.13, -5.44],
  [9.6, 110.68],
  [9.18, 92.84],
  [51.8, 4.02],
  [23.53, 117.8],
  [23.7, -15.92],
  [61.37, -117.71],
  [16.17, -95.18],
  [64.24, -15.19],
  [55.49, 9.58],
  [1.23, 103.65],
  [50.99, 1.24],
  [8, -80],
  [30.63, 122.06],
  [10.38, -61.53],
  [54.37, 10.15],
  [53.88, 9.15],
  [51.45, 3.58],
  [36.13, -5.44],
  [53.47, 9.99],
  [55.43, 13.83],
  [60.55, -145.77],
  [1.27, 103.83],
  [55.08, 14.72],
  [40.66, 29.25],
  [-19.05, 178.25],
  [6.33, 92.93],
  [53.04, 4.12],
  [42.42, 18.77],
  [44.88, -81.55],
  [33.42, -138.83],
  [49.3, -123.08],
  [41.82, 3.1],
  [30, 125],
  [1.17, 103.5],
  [48.5, 135.17],
  [40.41, 29.09],
  [-21.19, 149.42],
  [42.07, -83.14],
  [42.8, 132.88],
  [53.55, 8.58],
  [49.86, -5.81],
  [30, 122.1],
  [25.78, -80.19],
  [29.97, 32.55],
  [13.77, 109.23],
  [33.13, 136.82],
  [53.11, 4.33],
  [39.15, 23.83],
  [-20.15, 57.44],
  [42.88, -79.23],
  [-12.27, 49.3],
  [53.33, 7.17],
  [-3.33, 114.58],
  [60.4, 5.02],
  [46.36, 48.04],
  [39.35, 22.95],
  [43.27, -79.84],
  [-28.28, 38.83],
  [41.27, 29.07],
  [54.09, 12.14],
  [-33.97, 151.22],
  [43.8, -55.53],
  [56.15, 10.22],
  [47.58, -59.14],
  [59.93, 30.29],
  [44.38, 8.92],
  [-34.59, -58.38],
  [35.38, 119.54],
  [50.44, -0.41],
  [35.12, 129.04],
  [41.15, 29.03],
  [21.47, -71.15],
  [22.81, 70.05],
  [49.91, -3.37],
  [37.76, -122.34],
  [-18.13, 178.43],
  [39.58, -75.59],
  [46.7, -84.79],
  [55.1, 10.23],
  [51.83, -131.95],
  [69.32, 16.13],
  [35.44, 139.66],
  [30.05, -90.68],
  [37.94, 23.64],
  [41.45, 31.78],
  [-2.39, -54.7],
  [33.97, 130.89],
  [22.32, 91.82],
  [31.76, 120.96],
  [55.1, 10.23],
  [55, -7.31],
  [58.7, -2.93],
  [56.15, 10.22],
  [-28.03, 13.63],
  [64.14, -21.89],
  [37.93, 23.63],
  [39.17, 23.48],
  [22.32, 91.82],
  [19.23, -83.03],
  [57.22, 16.5],
  [10.15, -64.84],
  [58.2, -6.38],
  [54.72, 20.52],
  [51.82, 3.42],
  [50.71, -0.93],
  [55.94, -4.72],
  [51.38, -127.87],
  [36.13, -5.44],
  [50.59, -0.99],
  [36.12, -5.38],
  [68.16, 39.74],
  [5.02, 119.77],
  [57.5, -1.78],
  [52.46, 4.6],
  [34.06, 133.01],
  [47.1, -55.75],
  [60.2, 5.58],
  [48.97, -123.14],
  [29.6, -89.85],
  [44.3, -82.3],
  [50.37, -0.75],
  [3.62, 6.27],
  [63.12, 7.57],
  [36.67, -8.88],
  [57.18, 11.52],
  [48.68, -123.4],
  [37.75, 23.43],
  [47.32, -122.5],
  [42.73, -73.69],
  [35.51, 129.38],
  [22.32, 91.82],
  [-33.5, -60.01],
  [38.38, 26.15],
  [49.3, -123.58],
  [34.35, 134.05],
  [42.92, 131.47],
  [41.87, -66.3],
  [53.87, 8.7],
  [30.47, -91.18],
  [49.31, -123.1],
  [-16.92, 145.77],
  [41.35, 2.17],
  [45.35, -83.23],
  [45.17, 36.56],
  [60.42, 6.63],
  [51.9, 4.48],
  [44.14, 28.64],
  [48.43, -123.19],
  [49.03, -123.65],
  [-33.78, 25.68],
  [60.05, 28.35],
  [-22.96, 14.51],
  [-5.27, 133.06],
  [54.53, 18.55],
  [35.58, 140.13],
  [39.75, -75.5],
  [69.25, 35.16],
  [21.93, 91.38],
  [19.05, -104.33],
  [36.4, 22.38],
  [56.95, 24.08],
  [60.15, -1.14],
  [66.92, 12.67],
  [-6.11, 106.89],
  [36.95, 26.99],
  [49.31, -123.2],
  [39.17, 23.48],
  [18.43, -93.2],
  [45.28, 37.37],
  [50.34, -6.8],
  [49.01, -123.16],
  [41, 28.96],
  [49.49, 0.14],
  [45.34, -73.88],
  [25.18, 56.36],
  [52.5, 5.43],
  [-2.54, 112.96],
  [-3.25, -84.52],
  [29.14, -89.26],
  [39.12, 23.75],
  [30.71, 32.34],
  [50.81, 1.01],
  [50.88, 1.1],
  [-2.28, -79.92],
  [54.72, 20.52],
  [36.63, 29.1],
  [32.33, -64.75],
  [30.71, 32.34],
  [25.47, 55.49],
  [5.63, 0.01],
  [36.42, 25.45],
  [30, -90.41],
  [49.7, -65.72],
  [45.52, -73.53],
  [60.43, 22.22],
  [41, 28.96],
  [51.34, 3.82],
  [17.52, -62.98],
  [3.3, 5.38],
  [48.27, -69.4],
  [40.97, 28.93],
  [-0.02, 109.35],
  [39.98, 26.23],
  [-20.15, 57.48],
  [49.28, -123.19],
  [62.37, 6.03],
  [45.43, 12.33],
  [-10.85, 142.37],
  [9.5, -13.72],
  [42.53, -79.73],
  [45.35, 36.47],
  [59.7, 28.43],
  [41.12, 29.07],
  [49.28, -122.85],
  [55.96, 12.02],
  [24.99, 55.06],
  [39.83, 3.14],
  [38.31, 21.79],
  [47.19, 39.69],
  [65.33, -26.33],
  [59.4, 10.48],
  [10.24, 123.89],
  [26.5, 123.99],
  [44.67, -61.18],
  [42.1, 14.72],
  [31.25, 121.5],
  [-5.96, 105.97],
  [3.58, 5.22],
  [47.63, -122.33],
  [-5.55, 114.57],
  [38.03, 23.5],
  [57.5, 7.97],
  [6.32, 3.4],
  [38.76, 26.92],
  [14.78, 42.95],
  [16.8, 41.9],
  [-33.61, -59.69],
  [49.57, -66.25],
  [37.98, 24.73],
  [59.63, 152.08],
  [-20.47, 57.69],
  [41.92, -83.33],
  [6.44, 3.39],
  [1.7, 101.46],
  [32.82, 35.01],
  [56.72, 10.12],
  [37.94, 23.64],
  [-20.75, 164.27],
  [-45.81, 170.63],
  [-33.92, 18.43],
  [49, -123.59],
  [36.57, 31.77],
  [39.9, -75.13],
  [62.17, -17.57],
  [40.42, 26.68],
  [50.95, 1.07],
  [59.97, 30.17],
  [40.45, 27.13],
  [55.75, 21.08],
  [36.57, 30.62],
  [50.15, -12.59],
  [40.77, 29.59],
  [46.19, -72.88],
  [46.4, -72.37],
  [17, 82.28],
  [6.44, 3.39],
  [46.88, 70.93],
  [53.62, 7.16],
  [54.52, 13.63],
  [41, 28.96],
  [50.43, -0.92],
  [12.95, 74.71],
  [32.38, 28.14],
  [40.42, 22.6],
  [37.55, 129.11],
  [52.58, 155.67],
  [2.92, 105.32],
  [53.27, -4.07],
  [5.2, 120.08],
  [54.05, -5.34],
  [48.5, -68.63],
  [51.14, -4.93],
  [61.35, -24.78],
  [52.47, 2.03],
  [36.43, 21.73],
  [53.17, 5.4],
  [51.48, 0.57],
  [-8.18, 124.43],
  [-4.73, 11.8],
  [44.65, -63.58],
  [21.93, 91.38],
  [53.71, -0.73],
  [41.12, 29.08],
  [22.32, 91.82],
  [49.13, -123.85],
  [71.88, -80.9],
  [37.75, 23.43],
  [41.16, 29.05],
  [22.32, 91.82],
  [51.85, 4.63],
  [48.23, -61.07],
  [50, -4.4],
  [24.48, 118.54],
  [42.88, -9.27],
  [68.97, 33.08],
  [58.87, 9.42],
  [52.2, -5.82],
  [51.8, 4.65],
  [48.08, -6.4],
  [40.45, 27.13],
  [-33.05, -59.04],
  [58.02, 38.87],
  [44.65, -63.58],
  [53.45, 6.82],
  [69.96, 20.99],
  [-12.45, 130.84],
  [48.63, -125.45],
  [37.94, 23.64],
  [36.84, 30.6],
  [31.82, 34.65],
  [49.82, -4.13],
  [53.87, 1.02],
  [47.19, 39.69],
  [40.23, 26.52],
  [22.32, 91.82],
  [32.05, 118.78],
  [20.87, 106.67],
  [39.65, 25.74],
  [6.93, 79.86],
  [41.28, 29.05],
  [47.73, -53.07],
  [-20.55, 164.25],
  [50.51, -0.11],
  [75.67, 75.67],
  [-41.18, 146.35],
  [50.4, -3.51],
  [-28.41, 33.08],
  [37.95, 21.15],
  [47.08, 37.53],
  [-41.29, 174],
  [17.7, 83.3],
  [38.23, -85.77],
  [-34.85, 18.92],
  [36.59, 36.19],
  [36.25, -3.02],
  [57.4, 21.56],
  [65.6, -24.02],
  [47.37, 149.93],
  [22.32, 91.82],
  [37.94, 23.64],
  [37.94, 23.64],
  [57.68, -2.95],
  [16.83, -24.83],
  [45.64, -73.48],
  [0.75, 104.23],
  [58.73, -5.08],
  [46.05, -73.12],
  [39.58, 19.87],
  [50.63, 0.67],
  [55.87, 10.57],
  [41, 28.96],
  [3.48, 5.58],
  [37.94, 23.64],
  [-5.77, -170.4],
  [47.95, -126.33],
  [49.33, -0.75],
  [47.84, -69.83],
  [47.63, -122.33],
  [48.37, -4.47],
  [1.07, 103.68],
  [35.22, 139.78],
  [31.92, 120.25],
  [31.82, 34.65],
  [20.68, 38.27],
  [-32.77, -71.52],
  [53.38, -129.27],
  [43.5, 16.33],
  [44.62, 33.53],
  [50.1, -66.21],
  [31.25, 32.3],
  [45.17, 36.54],
  [-22.95, 14.5],
  [44.42, 8.92],
  [38.31, 21.79],
  [37.94, 23.64],
  [39.62, 19.95],
  [61.85, 6.08],
  [14.05, 48.8],
  [34.73, 139.37],
  [9.42, -79.93],
  [28, -93],
  [22.12, 113.75],
  [53.67, 5.62],
  [53.53, 9.95],
  [48.32, -123.48],
  [22.22, -17.22],
  [54.35, -131.09],
  [4.42, 7.83],
  [68.78, 16.53],
  [44, -77.88],
  [-18.65, -173.99],
  [-5.95, 106],
  [50.53, -5.62],
  [44.99, -74.78],
  [51.8, 3.33],
  [50.15, -66.45],
  [50.9, 1.13],
  [34.51, 33.37],
  [45.34, 36.67],
  [35.61, 140.11],
  [41.35, 2.17],
  [35.44, 139.66],
  [53.82, 8.9],
  [44.22, -64.31],
  [59.33, 18.08],
  [35.78, -5.8],
  [-0.29, 117.66],
  [18.55, -72.35],
  [52.61, -9.1],
  [51.43, 6.75],
  [48.96, -125.55],
  [53.9, 9.13],
  [42.88, -78.88],
  [61.29, -149.9],
  [50.37, -2.49],
  [-1.47, 116.8],
  [55.1, 14.7],
  [38.75, 26.9],
  [60.72, 33.55],
  [46.24, -72.79],
  [45.68, -62.72],
  [53.9, 9.13],
  [47.88, -69.78],
  [38.73, -27.05],
  [-4.07, 39.68],
  [27.79, 121.18],
  [46.04, -73.12],
  [37.43, 23.69],
  [34.2, 25],
  [43.25, 146.03],
  [39.47, 26.22],
  [26.52, -77.08],
  [47.19, 39.69],
  [22.77, 113.61],
  [1.21, 104.03],
  [53.52, 8.57],
  [38.5, 15.55],
  [45.85, 47.65],
  [60.27, 6.32],
  [37.73, -25.65],
  [13.7, 120.99],
  [44.83, -80.13],
  [49.28, -123.07],
  [68.23, 14.57],
  [10.67, 122.95],
  [44.65, -63.58],
  [33.72, 135.35],
  [1.25, 104.12],
  [53.02, 158.63],
  [39.2, 133.65],
  [53.02, 158.63],
  [55.93, 14.32],
  [36.2, -5.3],
  [-14.53, 40.67],
  [45.15, 36.51],
  [55.47, 10.53],
  [55.45, 8.46],
  [56.22, -5.67],
  [43.48, -8.24],
  [9.48, 99.88],
  [32.23, -76.75],
  [6.14, 1.29],
  [3.6, 104.3],
  [45.78, 13.22],
  [4.07, 6.3],
  [40.76, 29.76],
  [23.1, 113.23],
  [40.15, 26.4],
  [54.65, -0.95],
  [39.43, -0.72],
  [49.93, -3.13],
  [6.81, 122.02],
  [55.45, 8.42],
  [29.75, -95.33],
  [4.69, 7.16],
  [25.48, 53.13],
  [41.13, 30.68],
  [50.97, 152.43],
  [49.32, -123.14],
  [58.97, 5.73],
  [55.1, 14.7],
  [1.68, 101.45],
  [49.2, -5.62],
  [42.93, 10.55],
  [51.9, 4.35],
  [40.97, 28.9],
  [53.33, 8.48],
  [40.02, 26.18],
  [53.57, 8.55],
  [54.37, 10.14],
  [22.27, 113.95],
  [39.35, 22.95],
  [-6.11, 106.89],
  [51.34, 4.3],
  [11.87, 109.12],
  [34.2, 135.13],
  [22.59, 120.31],
  [51.53, -6],
  [-33.18, 28.4],
  [33.95, 130.97],
  [49.43, -4.67],
  [63.28, 8.14],
  [41.52, -70.67],
  [37.94, 23.64],
  [10.18, -64.79],
  [34.4, 133.95],
  [54.15, -4.47],
  [3.8, 98.72],
  [53.55, 8.58],
  [34.24, 128.69],
  [59.33, 6.03],
  [54.32, 10.13],
  [34.03, 132.55],
  [40.4, 26.68],
  [4.68, 7.15],
  [39.17, 25.68],
  [-1.55, -48.75],
  [-20.64, 56.63],
  [-3.71, 114.47],
  [-0.22, 117.57],
  [25.78, -80.19],
  [41.18, 29.05],
  [36.73, -9.13],
  [47.02, -86.02],
  [33.95, 130.97],
  [53.75, 0.54],
  [34.65, 33.01],
  [42.83, -9.67],
  [-22.55, -40.07],
  [49.29, -122.87],
  [54.32, 10.13],
  [53.9, 9.13],
  [65.48, 12.21],
  [55.91, 154.21],
  [4.94, -1.57],
  [37.52, 24.05],
  [53.9, -166.54],
  [3.87, -77.08],
  [38.25, 15.63],
  [42.88, -79.25],
  [49.01, -123.17],
  [49.01, -123.13],
  [53.36, 7.19],
  [53.89, 10.7],
  [45.57, -73.5],
  [28.87, -89.38],
  [53.85, 8.87],
  [61.13, 21.49],
  [12.12, -61.67],
  [54.24, -130.35],
  [54.37, 10.11],
  [50.7, 0.62],
  [2.18, 102.25],
  [54.28, -130.37],
  [53.9, 9.13],
  [55.08, 14.72],
  [33.95, 130.97],
  [41.42, 29.19],
  [45.56, 73.52],
  [39.7, 132.65],
  [55.71, 21.14],
  [54.32, -130.34],
  [44.56, -75.74],
  [45.78, 47.55],
  [49.18, -123.89],
  [21.93, 91.38],
  [47.31, 138.93],
  [6.22, 119.83],
  [13.2, 80.4],
  [43.75, -81.73],
  [59.33, 18.08],
  [-4.83, 11.76],
  [44, -77.88],
  [40.96, 28.89],
  [51.33, 3.82],
  [-4.57, -81.31],
  [42.43, -62.23],
  [54.15, -132.03],
  [27.82, -96.99],
  [-39.48, 176.92],
  [45.34, 36.67],
  [54.09, 12.14],
  [39.12, 23.75],
  [38.38, 26.15],
  [56.37, 10.88],
  [31.28, 32.33],
  [40.98, 28.94],
  [46.75, 36.78],
  [40.92, 24.42],
  [49.32, -122.68],
  [10.32, -75.52],
  [57.59, 9.97],
  [44.1, 28.65],
  [-7.15, 112.65],
  [3.55, 6.7],
  [53.88, 14.27],
  [-6.8, 112.78],
  [50.18, -1.78],
  [29.79, -95.07],
  [63.08, 7.45],
  [41.37, 19.42],
  [44.1, 39.07],
  [30.27, 32.45],
  [9.51, -13.71],
  [24.27, -74.93],
  [1.08, 103.55],
  [10.27, -64.71],
  [35.44, 139.66],
  [40.72, 29.8],
  [25.12, 121.24],
  [49.31, -123.08],
  [49.15, -123],
  [68.57, 14.91],
  [48.52, -122.62],
  [46.84, -71.13],
  [39.53, 20.22],
  [13.73, 121.03],
  [49.28, -123.1],
  [64.53, 40.5],
  [51.13, 1.52],
  [36.52, 1.32],
  [62.48, 6.15],
  [31.2, 29.89],
  [-19.99, 115.31],
  [38.98, 23.18],
  [46.68, -71.88],
  [37.94, 23.64],
  [57.59, 9.97],
  [57.7, 11.95],
  [44.14, 28.64],
  [38.02, 24],
  [48.4, -123.42],
  [9.17, 125.5],
  [50.69, 0.96],
  [53.55, 8.58],
  [2.56, 4.75],
  [29.92, -90.09],
  [35.03, 136.87],
  [14.06, 120.49],
  [10.93, 108.28],
  [48.78, -123.23],
  [43.56, 10.31],
  [1.27, 103.83],
  [49.92, -6.04],
  [4.42, 7.15],
  [67.28, 14.38],
  [40.95, 27.5],
  [40.69, 28.32],
  [41.64, -70.92],
  [45.63, -122.73],
  [53.02, 158.63],
  [29.93, -89.99],
  [37.97, 23.57],
  [3.17, 113.03],
  [-69.4, 76.2],
  [45.78, 47.55],
  [50.97, 1.37],
  [49.29, -123.08],
  [54.47, 9.05],
  [58.57, -88.4],
  [50.37, -0.48],
  [59.12, 37.94],
  [47.32, -70.51],
  [16.2, -68.48],
  [56.52, 20.98],
  [48.85, -67.55],
  [28.15, -15.42],
  [44.45, 12.23],
  [69.33, -133.77],
  [6.44, 3.39],
  [45.28, 47.75],
  [20.9, -17.05],
  [12.62, 45.07],
  [10.65, -61.52],
  [73, 127],
  [-3.38, 114.24],
  [22.59, 120.31],
  [52.17, -128.1],
  [35.42, 26.93],
  [50.86, 1.41],
  [69.43, -133.05],
  [40.2, 26.4],
  [14.51, 120.62],
  [43.56, 10.31],
  [50.6, -127.08],
  [54.15, 12.12],
  [45.1, 47.68],
  [51.37, 3.92],
  [27.95, -82.44],
  [50.72, -127.48],
  [49.33, -123.23],
  [48.08, -123.47],
  [-8.74, 116.05],
  [25.09, -43.61],
  [43.47, -3.8],
  [49.64, -1.61],
  [37.78, 24.13],
  [37.95, 21.15],
  [55.78, 161.25],
  [53.33, 8.48],
  [49.52, -123.47],
  [37.65, 23.95],
  [-33.97, 151.22],
  [47.58, -52.69],
  [15, -86.5],
  [-41.5, -73],
  [35.59, 132.85],
  [-25.5, -48.5],
  [54.39, 10.2],
  [49.72, -5.07],
  [45.55, 13.74],
  [48.35, 70.88],
  [54.72, 20.52],
  [48.96, -67.66],
  [36.14, -5.35],
  [51.37, 3.12],
  [40.82, 28.86],
  [49.77, -66.81],
  [22, 38],
  [47.57, -52.52],
  [47.97, -6.64],
  [68.8, 16.54],
  [45.32, -73.92],
  [50.72, 0.75],
  [40.85, 14.28],
  [12.17, -75.63],
  [62.28, 5.07],
  [49.28, -123.11],
  [37.35, 23.47],
  [38.01, 22.75],
  [22.78, 70.04],
  [35.82, 14.54],
  [10.22, -64.63],
  [62.73, 7.17],
  [51.8, 4.9],
  [10.18, -64.83],
  [47.12, 39.41],
  [38.32, 26.25],
  [22.62, 120.22],
  [54.53, 10.48],
  [35.52, 35.77],
  [6.27, 3.34],
  [-22.93, -43.83],
  [40.65, 27.67],
  [49.98, -5.27],
  [46.72, -71.38],
  [53.35, -6.23],
  [-2.22, 113.92],
  [48.39, -4.47],
  [-33.88, -58.42],
  [70.05, 19.47],
  [68.67, 15.91],
  [53.9, 9.13],
  [49.31, -123.08],
  [36.8, 34.63],
  [37.94, 23.64],
  [57.05, -135.33],
  [9.93, -82.97],
  [-33.64, -60.56],
  [49.3, -123.07],
  [48.84, -123.35],
  [46.28, -60.15],
  [30.39, -81.56],
  [45.49, -73.52],
  [40.85, 29.17],
  [47.98, -65.22],
  [51.82, 3.37],
  [22.75, -74.22],
  [31.06, 122.77],
  [59.92, 26.18],
  [51.96, 1.31],
  [62.37, 6.42],
  [37.82, 24.57],
  [-8.17, 114.43],
  [40.29, 51.42],
  [58.35, -5.7],
  [57.11, 23.88],
  [40.85, 14.28],
  [56.83, -1.81],
  [40.84, 29.29],
  [50.77, -1.3],
  [49.31, -123.05],
  [40.82, 28.95],
  [45.3, -73.92],
  [5.2, 120.08],
  [20.83, 63.55],
  [41.6, -71.35],
  [1.27, 103.83],
  [-0.25, 117.57],
  [50.18, -3.48],
  [64.14, -21.89],
  [58.45, -5.03],
  [46.36, 48.04],
  [49.52, -123.48],
  [45.22, -74.05],
  [12.1, -83.99],
  [18, 89],
  [23.35, 116.7],
  [26.52, -78.77],
  [21.93, 91.38],
  [46.07, -73.47],
  [45.08, -83.1],
  [16.84, 108.06],
  [22.27, 91.8],
  [23.02, 113.53],
  [42.8, 132.88],
  [55.55, 9.73],
  [68.8, 16.54],
  [-34.7, 23.48],
  [22.22, 91.72],
  [51.12, 1.7],
  [45.08, 47.69],
  [48, -134.67],
  [49.3, -123.05],
  [-5.32, 106.39],
  [40.86, 29.2],
  [58.1, 6.8],
  [41.18, 29.05],
  [25.37, 55.38],
  [47.55, -52.7],
  [-17.83, 178.67],
  [-4.38, 120.01],
  [42.44, -62.24],
  [40.95, 28.88],
  [19.5, 94],
  [53.55, 8.58],
  [6.26, 3.21],
  [62.37, 6.03],
  [-24.05, -46.35],
  [-32.35, -50.3],
  [42.8, 132.88],
  [47.15, 39.5],
  [54.03, -2.92],
  [49.93, -5.54],
  [46.5, -84.37],
  [37.95, 23.64],
  [-23.93, -46.33],
  [78.58, 21.83],
  [45.31, 36.5],
  [10.19, 64.77],
  [43.53, -7.03],
  [77.67, 14.25],
  [39.2, 8.4],
  [63.44, 10.4],
  [56, 3],
  [57.68, -2.98],
  [54.32, 10.13],
  [60.4, 5.32],
  [68.97, 33.08],
  [40, 135],
  [-8.65, 119.3],
  [40.96, 28.68],
  [42.92, 131.47],
  [40.96, 28.89],
  [25.07, -77.32],
  [11.91, 109.14],
  [45.32, -73.9],
  [59.01, -32.93],
  [41.45, 31.78],
  [9.87, 108.03],
  [37.99, 139.24],
  [60.5, 32.78],
  [36.27, 33.87],
  [49, 123.15],
  [40.32, 26.6],
  [-23.87, -46.37],
  [22.5, 113.84],
  [-28.97, 32.15],
  [-3.97, 122.58],
  [50.72, -1.98],
  [78.08, 14.22],
  [36.73, 27.69],
  [49.63, -4.02],
  [62.63, 7.07],
  [40.87, 29.18],
  [49.32, -123.87],
  [47.79, -54.03],
  [35.22, 131.82],
  [71.38, 40.1],
  [34.65, 139.17],
  [42.88, -79.25],
  [-0.24, 117.66],
  [13.47, 123.28],
  [53.93, 10.85],
  [34.51, 134.29],
  [-4.78, 11.83],
  [50.49, -0.87],
  [37.84, -76.16],
  [43.88, -60.2],
  [48.39, -4.47],
  [7.75, 109.23],
  [46.32, -72.53],
  [31.32, 30.06],
  [48.13, -69.72],
  [54.18, 7.89],
  [48.77, -123.45],
  [43.56, -5.7],
  [68.97, 33.08],
  [1.17, 103.43],
  [23.03, 70.22],
  [48.35, -123.3],
  [14.52, 120.61],
  [6.43, 3.38],
  [-10.68, 142.53],
  [51.26, 4.39],
  [64.47, 4.72],
  [37.1, 25.38],
  [44.85, -87.35],
  [-20.32, 118.58],
  [13.77, 109.23],
  [64.14, -21.89],
  [46.28, 47.95],
  [59.7, 28.43],
  [50.48, 0.17],
  [10.18, -64.79],
  [46.82, -71.2],
  [-8.17, 114.44],
  [29.9, -90.12],
  [1, 5.08],
  [3.22, 3.32],
  [3.88, 5.37],
  [54.36, 18.66],
  [13.16, -61.23],
  [64.14, -21.89],
  [49.28, -123.11],
  [40.77, -74],
  [38.25, 21.74],
  [53.33, -2.95],
  [48.65, -2.03],
  [37.78, 20.9],
  [47.6, -70.11],
  [14.58, 120.97],
  [53.24, 8.47],
  [59.92, 20.22],
  [51.62, -9.76],
  [17.59, 83.51],
  [10.32, 123.92],
  [48.94, 44.74],
  [-8.33, 124.35],
  [45.64, -73.48],
  [1.25, 104.1],
  [50.9, -1.38],
  [1.05, 103.6],
  [39.62, 19.95],
  [49.8, -64.35],
  [58.49, -2.98],
  [41.67, 50.67],
  [55.58, -5.15],
  [-35.05, -57.16],
  [-45.66, -63.81],
  [15.36, 108.99],
  [40.41, 29.08],
  [-5.92, 105.8],
  [59.87, 30.23],
  [-18.29, 147.7],
  [41.27, 21.02],
  [1.05, 103.62],
  [18.82, 105.72],
  [-32.75, -60.72],
  [-6, 106.86],
  [50.38, -0.75],
  [41.72, 12.3],
  [47.19, 39.69],
  [36.1, 31.57],
  [31.25, 121.5],
  [10.63, 103.5],
  [46.02, -122.83],
  [4.05, 9.7],
  [22.23, 91.73],
  [59.97, 30.17],
  [49.04, -123.11],
  [36.13, -5.44],
  [38.36, 22.67],
  [36.84, 30.6],
  [51.26, 3.83],
  [51.03, 1.28],
  [56.15, 10.22],
  [39.45, 26.07],
  [10.93, -66.58],
  [30.01, -90.73],
  [46.12, -72.95],
  [3.67, 7.02],
  [1.1, 103.53],
  [34.64, 138.13],
  [40.15, 26.4],
  [53.92, 8.72],
  [1.07, 104.5],
  [39.59, 24.26],
  [9.97, 76.23],
  [-7.11, 112.67],
  [53.52, 9.92],
  [48.65, -2.03],
  [51.4, 3.57],
  [42.88, -79.23],
  [22.23, 91.75],
  [49.73, -61.74],
  [49.19, -123.9],
  [53.87, 8.7],
  [51.45, 3.57],
  [40.78, 28.32],
  [27.63, -82.56],
  [55, 11.9],
  [-6.77, 111.95],
  [58.83, -3.68],
  [40.96, 28.89],
  [8.44, -13.47],
  [54.22, -130.42],
  [50.03, -66.79],
  [62.35, 6.25],
  [37.94, 23.64],
  [43.07, -73.12],
  [60.92, 34.19],
  [48.6, -68.45],
  [52.42, 9.7],
  [60.15, -1.14],
  [45.7, -73.43],
  [2.77, 6.66],
  [49.29, -123.07],
  [38.33, 21.76],
  [54.17, 12.08],
  [40.75, 28.6],
  [48.75, -122.5],
  [40.41, 29.08],
  [41.12, 29.08],
  [-10, 127],
  [55.87, -0.92],
  [68.97, 33.08],
  [56.9, 17.28],
  [54.85, 10.52],
  [24.82, 66.97],
  [49.17, -123.91],
  [57.72, 10.6],
  [43.2, 27.92],
  [41.08, 1.27],
  [54.87, -3.38],
  [6.44, 3.39],
  [53.97, 9.25],
  [49.87, -124.55],
  [36.97, 24.72],
  [35.51, 139.75],
  [31.82, 34.65],
  [62.68, -60.75],
  [37.03, 27.44],
  [-32.48, -58.23],
  [29.75, -95.33],
  [49.5, -66],
  [40.41, 29.08],
  [64.53, 40.5],
  [37.95, 23.55],
  [47.19, 39.69],
  [41.14, 16.87],
  [53.36, 7.19],
  [29.6, -89.85],
  [47.08, 39.23],
  [60.15, 5.43],
  [41.26, 29.08],
  [37.22, 24.57],
  [56.15, 10.2],
  [10.17, 107.08],
  [-8.17, 114.43],
  [52.17, 3.05],
  [1.15, 103.93],
  [34.6, 138.23],
  [-5.83, 13.42],
  [14.8, 42.95],
  [43.1, 131.89],
  [54.1, -130.17],
  [38.07, 23.58],
  [41.12, 29.08],
  [40.3, 26.6],
  [30.73, -91.47],
  [53.57, -0.05],
  [54.28, 9.65],
  [59.15, 37.83],
  [37.75, 23.43],
  [44.22, -66.84],
  [1.12, 103.5],
  [55.33, 13.13],
  [54.68, 20.13],
  [21.93, 91.38],
  [44.37, -64.3],
  [45.55, -73.52],
  [-18.13, 178.43],
  [1.22, 104.58],
  [48.83, -123.35],
  [40.46, 19.49],
  [43.99, -76.49],
  [4.05, 9.7],
  [54.38, 10.18],
  [-23.83, 151.26],
  [51.83, 5.83],
  [48.17, -4.43],
  [1.13, 103.93],
  [40.42, 26.83],
  [33.84, 132.55],
  [51.07, 5.19],
  [40.93, 28.88],
  [40.77, 29.43],
  [3.92, 5.42],
  [51.89, 1.56],
  [50.73, -1.21],
  [69.08, 15.95],
  [37.62, 24.33],
  [-20.32, 118.58],
  [50.93, -4.92],
  [53.9, 9.15],
  [36.27, 23.23],
  [24.13, 120.38],
  [36.38, 28.35],
  [60.07, 38],
  [35.33, 139],
  [-23.8, -45.37],
  [13.43, 144.66],
  [46.05, -73.12],
  [-42.74, -65.05],
  [51.42, 3.06],
  [26.16, 50.76],
  [53.88, 9.13],
  [48.27, -69.13],
  [-20.15, 57.48],
  [36.85, -76.32],
  [36.76, 34.64],
  [47.53, -52.98],
  [40.42, 29.09],
  [46.1, -122.93],
  [40.35, 27.97],
  [41.52, -70.67],
  [22.8, 70.04],
  [50.13, -0.58],
  [47.35, -53.95],
  [21.93, 91.38],
  [53.57, 8.6],
  [50.97, 1.03],
  [5.3, 1.4],
  [-32.06, 115.75],
  [48.33, -123.35],
  [53.55, 9.98],
  [49.02, -123.15],
  [50.76, -1.29],
  [13.52, 100.98],
  [34.75, 127.75],
  [49.32, 123.13],
  [40.04, 26.32],
  [40.83, -74.28],
  [60.52, 6.72],
  [53, -3],
  [49.98, -125.22],
  [39.17, 26.33],
  [45.25, -81.65],
  [41.28, -70.1],
  [10.72, 122.57],
  [41.23, 9.17],
  [53.9, 11.45],
  [45.28, 14.57],
  [8.48, -13.19],
  [45.42, -73.7],
  [55.1, 14.7],
  [47.28, -2.21],
  [14.58, 120.97],
  [64.32, -22.08],
  [35.2, 24.9],
  [50.34, -0.92],
  [68.83, 15.47],
  [22.14, 91.73],
  [51.9, 4.48],
  [-39.97, 173.29],
  [47.49, -58.89],
  [41.92, 8.74],
  [-35.67, -55.78],
  [29.97, 32.55],
  [20.97, 107.05],
  [57.67, 11.69],
  [-41.13, 146.87],
  [1.27, 103.83],
  [53.55, 9.98],
  [45.35, 36.47],
  [-33.92, 18.43],
  [24.28, 120.52],
  [49.02, -123.14],
  [36.74, 27.73],
  [40.71, 28.79],
  [10.86, 79.85],
  [49.93, 8.09],
  [11.7, 79.77],
  [53.45, 6.83],
  [68.39, 14.42],
  [50.37, -3.4],
  [47.13, 39.5],
  [46, 38.5],
  [-27.33, -56.22],
  [64.14, -21.89],
  [33.25, 126.55],
  [68.68, 11.23],
  [37.95, 23.62],
  [28.63, -96.57],
  [51.4, -57.15],
  [40.85, 29.29],
  [40.96, 28.89],
  [43.48, -79.62],
  [51.63, -3.83],
  [10.24, 107.03],
  [22.32, 91.82],
  [-17.83, 178.67],
  [47.6, -122.34],
  [38.91, 1.44],
  [-12.45, 130.84],
  [50.79, 0.86],
  [48.87, -123.1],
  [41.6, -82.58],
  [39.48, 20.27],
  [46.32, -72.55],
  [56.7, 8.22],
  [47.62, -122.51],
  [37.94, 23.64],
  [51.33, 3.82],
  [48.58, -125.4],
  [53.89, 9.18],
  [-37.83, 144.92],
  [44.47, -65.6],
  [68.97, 33.08],
  [51.17, 4.48],
  [41.15, 29.05],
  [37.1, 25.38],
  [18.49, -77.66],
  [56.15, 10.22],
  [47.55, -122.53],
  [33.96, 130.89],
  [40.77, 29.54],
  [46.72, -92.08],
  [22.24, 113.58],
  [45.15, 47.7],
  [1, 4],
  [20.35, -78.08],
  [-1.83, 109.98],
  [22.22, 91.72],
  [59.28, -3.97],
  [40.95, 28.9],
  [49.28, -123.08],
  [52.44, 3.99],
  [-10.06, 143.03],
  [-12.66, 141.87],
  [43.67, -4.39],
  [62.44, 6.28],
  [52.46, 4.6],
  [59.02, 6.31],
  [48.89, 123.06],
  [45.62, -61.36],
  [33.33, 131.87],
  [59.93, 29.7],
  [43.25, 9.47],
  [3.88, -77.07],
  [35, 123],
  [45.13, 36.69],
  [45.25, 36.5],
  [47.1, 39.3],
  [53.32, 7.33],
  [56.29, 43.96],
  [46.33, -60.02],
  [-33.62, -59.71],
  [33.05, -16.33],
  [66.2, 13.02],
  [38.02, -166.42],
  [14.68, -92.4],
  [5.2, 120.08],
  [31.39, 121.98],
  [31.23, 29.74],
  [48.72, -125.5],
  [3.88, 5.6],
  [68.67, 15.92],
  [-8.13, 114.41],
  [46.33, -72.53],
  [51.57, 1.82],
  [45, -66.95],
  [-12.05, -77.14],
  [38.92, 119.2],
  [-33.63, 6.97],
  [52.77, 1.9],
  [46.17, -72.93],
  [-37.65, 176.18],
  [43.1, 131.89],
  [69.76, 19.12],
  [45.34, 36.67],
  [51.37, 4.14],
  [49.22, -123.82],
  [12.19, -69.03],
  [34.01, 134.59],
  [48.57, 44.15],
  [54.32, 10.13],
  [49.5, -54.88],
  [59.4, 6.08],
  [51.41, 3.6],
  [50.42, -0.42],
  [49.3, -123.13],
  [52.44, 3.97],
  [40.77, 29.6],
  [45.1, 147.89],
  [31.25, 121.5],
  [22.32, 91.82],
  [50.75, -1.15],
  [67.35, 8.97],
  [25.63, 122.07],
  [35.58, 140.13],
  [37.92, 24.57],
  [3.82, 7.07],
  [53.02, 158.63],
  [47.52, -6.95],
  [50.15, -5.05],
  [59.77, 30.78],
  [14.77, -60.88],
  [38.07, 23.8],
  [40.64, 22.92],
  [-29.87, 31.03],
  [60.67, 17.13],
  [59.27, -1.68],
  [22.59, 120.31],
  [52.52, 4.33],
  [1.27, 104.2],
  [38.42, 27.1],
  [59.38, 5.19],
  [35.12, 129.04],
  [46.27, 47.95],
  [-2.62, -80.2],
  [-20.68, 116.69],
  [29.83, 122.2],
  [40.71, -74.01],
  [48.57, 44.15],
  [64.53, 40.5],
  [34.32, 133.83],
  [37.95, 23.61],
  [68.97, 33.08],
  [43.56, -5.7],
  [22.02, 88.08],
  [22.32, 91.82],
  [20.85, 106.75],
  [40.88, 29.19],
  [42.28, -83.08],
  [3.3, 6.51],
  [18.58, -72.38],
  [55.34, -131.65],
  [22.32, 91.82],
  [56.85, 11.8],
  [21.31, -157.86],
  [24.02, 59.37],
  [53.34, 7.19],
  [47.62, -70.13],
  [1.22, 103.92],
  [49.47, -123.76],
  [25.23, 56.52],
  [40.97, 28.93],
  [68.97, 33.08],
  [-19.83, 34.83],
  [57.59, 9.97],
  [42.88, -79.25],
  [25.04, 66.71],
  [48.35, 70.88],
  [-13.8, -76.29],
  [45.22, 12.28],
  [37.1, 137.03],
  [13.72, 121.03],
  [53.35, -6.23],
  [51.86, -128.49],
  [51.43, 3.58],
  [49.57, -66.06],
  [10.26, 107.02],
  [59.21, 38.48],
  [55.98, -3.18],
  [22.29, 114.16],
  [-5.93, 106],
  [54.32, 10.13],
  [47.48, -70.22],
  [-34.85, 138.57],
  [-33.97, 25.63],
  [34.72, 26.77],
  [37.1, 13.93],
  [40.75, 29.84],
  [22.5, 120.35],
  [59.92, 29.77],
  [37.91, 23.55],
  [53.78, 7.9],
  [43.43, -4.05],
  [41.65, -70.28],
  [59.03, 11.03],
  [54.23, 7.62],
  [55.35, 49.83],
  [3.07, 105.03],
  [53.87, 8.7],
  [37.93, 23.63],
  [52.47, 4.6],
  [40.87, 29.24],
  [47.98, -69.73],
  [6.33, -10.85],
  [-34.33, 18.08],
  [37.94, 23.64],
  [57.67, -2.5],
  [43.36, -8.4],
  [1.43, 103.1],
  [46.78, 47.77],
  [10.25, -64.56],
  [37.94, 23.64],
  [21.93, 91.38],
  [39.85, 19.43],
  [53.33, 8.48],
  [44.06, -77],
  [36.09, 120.33],
  [38.38, 26.15],
  [53.9, 9.13],
  [-44.38, 171.25],
  [38.76, 26.92],
  [37.23, 15.19],
  [55.56, 9.75],
  [54.32, -130.35],
  [54.27, -146.13],
  [40.19, 26.37],
  [20.89, -16.99],
  [39.1, 117.17],
  [69.67, 18.73],
  [36.53, 24.77],
  [-51.72, -72.52],
  [41.17, 29.62],
  [45.84, -84.61],
  [53.57, 8.53],
  [20.02, -75.82],
  [36.85, 28.28],
  [50.72, -1],
  [18.93, 72.83],
  [35.08, 129],
  [53.9, 9.13],
  [14.87, 42.15],
  [40.03, 26.07],
  [53.42, 14.55],
  [47.85, -69.82],
  [-21.64, 115.11],
  [41.19, -8.7],
  [38.79, 118.4],
  [43.1, 131.89],
  [51.58, 1.13],
  [29.92, -90.09],
  [38.57, 23.28],
  [44.65, -63.58],
  [50.03, -3.43],
  [-20.16, 57.5],
  [40.99, 28.97],
  [40.96, 28.89],
  [25.8, 55.95],
  [43.13, -79.19],
  [24.28, 120.53],
  [36.44, 28.23],
  [9.42, -79.87],
  [22.49, 89.6],
  [22.11, 91.8],
  [-23.93, -46.33],
  [24.83, 67],
  [58.93, 5.59],
  [45.62, -75.42],
  [-34.85, 138.57],
  [37.83, 24.48],
  [36.52, -6.29],
  [1.27, 103.83],
  [37.03, 27.44],
  [5.22, -4.04],
  [37.94, 23.64],
  [47.12, 39.41],
  [6.9, 122.07],
  [40.76, 29.46],
  [47.19, 39.69],
  [46.07, -73.05],
  [50.43, -1.75],
  [-8.5, 119.88],
  [60.4, 5.32],
  [40.95, 28.88],
  [50.53, -0.26],
  [-4.75, 11.78],
  [37.97, 23.57],
  [60.2, -1.05],
  [37.03, 27.44],
  [56.85, -5.13],
  [51.39, 4.18],
  [36.95, 26.98],
  [37.03, 27.44],
  [69.17, 17.98],
  [50.77, -1.09],
  [51.18, 1.44],
  [44.24, -76.09],
  [57.47, 11.28],
  [42.28, -83.11],
  [62.14, -74.68],
  [46.63, 32.61],
  [-45.86, -67.48],
  [38.32, 26.25],
  [12.73, 101.17],
  [58.2, -6.38],
  [37.78, 20.9],
  [-4.07, 39.68],
  [37.97, 23.57],
  [9.63, -82.66],
  [36.63, 29.1],
  [37.97, 23.57],
  [35.48, 23.63],
  [47.64, -70.07],
  [38.3, 21.8],
  [-31.55, 89.07],
  [58.12, -3.02],
  [42.1, 14.72],
  [45.15, -66.05],
  [51.4, 1.8],
  [59.87, 30.23],
  [34.73, 10.77],
  [25.27, 55.29],
  [1.27, 103.83],
  [40.45, 27.13],
  [41, 28.96],
  [53.53, 49.4],
  [39.35, 22.95],
  [37.54, 25.16],
  [37.27, 9.88],
  [51.43, 1.38],
  [49.12, -67.57],
  [45.34, 36.67],
  [-4.78, 11.81],
  [69.02, 16.48],
  [-34.53, 22.38],
  [45.32, -73.92],
  [49.27, -123.71],
  [35.48, -3.93],
  [49.78, -4],
  [50.05, -3.92],
  [-12.66, 141.87],
  [47.18, 39.61],
  [53.9, 9.13],
  [-34.96, 17.63],
  [36.2, 29.9],
  [36.14, -5.35],
  [41.01, 28.99],
  [48.26, -69.14],
  [62.73, 7.16],
  [6.32, 3.28],
  [60.23, 21.78],
  [53.33, 7.24],
  [12.1, -68.93],
  [50.11, -1.93],
  [0.09, 109.11],
  [46.06, -73.13],
  [51.43, 6.75],
  [29.07, 48.15],
  [64.7, 40.53],
  [49.3, -123.05],
  [0.78, 127.37],
  [0.73, 104.15],
  [54.41, 6.21],
  [62.37, 6.03],
  [36.17, 28],
  [53.43, 14.58],
  [56.73, 16.67],
  [46.63, 32.61],
  [36.78, -1.63],
  [62.6, 6.45],
  [59.41, 10.49],
  [36.63, 29.1],
  [1.29, 103.71],
  [59.87, 30.23],
  [53.9, 9.13],
  [43.56, 10.31],
  [52.8, 154.17],
  [-35.67, -55.78],
  [51.45, 3.58],
  [-4.82, -37.03],
  [57.58, -6.37],
  [50.7, -6.3],
  [35.51, 129.38],
  [51.26, 3.84],
  [33.65, -76.58],
  [45.74, -62.69],
  [41.28, 28.97],
  [4.17, 4.62],
  [44.14, 28.64],
  [62.31, 6.97],
  [3.8, 98.72],
  [30.38, -21.55],
  [37.87, -71.25],
  [34.69, 135.2],
  [50.79, -1.32],
  [40.68, -74.07],
  [49.31, -123.08],
  [34.49, 133.73],
  [8.9, 122.3],
  [53.57, 0.55],
  [54.32, -130.32],
  [49.65, -126.09],
  [50.9, -1.41],
  [39.35, 22.95],
  [49.12, -123.2],
  [67.62, 14.63],
  [40.8, 28.96],
  [28.15, -15.42],
  [40.96, 28.89],
  [40.88, 29.19],
  [47.12, 39.41],
  [47.14, 39.52],
  [31.7, 32.57],
  [60.95, 17.17],
  [37.94, 23.64],
  [49.21, -123.59],
  [10.41, 107.14],
  [59.88, 30.22],
  [14.62, 120.88],
  [15.69, -88.62],
  [37.78, 20.9],
  [52.8, 2.33],
  [33.27, 131.51],
  [5.42, 100.33],
  [22.44, 69.84],
  [40.98, 28.95],
  [10.63, 107.83],
  [40.82, 29.18],
  [34.46, 133.44],
  [66.2, 13.02],
  [41.47, 29.05],
  [40.89, 29.19],
  [36.15, -5.3],
  [37.34, -123.11],
  [44.74, 37.79],
  [54.15, 12.1],
  [54.68, -5.68],
  [49.3, -123.05],
  [46.02, -73.17],
  [12.02, 51.45],
  [4.24, 8.04],
  [8.98, 125.33],
  [37.23, 26.75],
  [55.57, 6.4],
  [-33.98, -59.19],
  [50.04, -125.25],
  [49.15, -123.88],
  [20.87, 106.68],
  [57.63, 18.28],
  [4.9, -1.72],
  [36.92, 27.27],
  [22.28, 91.73],
  [43.37, -8.49],
  [49.02, -123.15],
  [36.44, 28.23],
  [55.7, 15.68],
  [54.21, 9.54],
  [49.28, -123.17],
  [45.58, 137.83],
  [41.31, 19.45],
  [40.15, 26.4],
  [-50.43, -59.15],
  [52.46, 4.6],
  [13.73, 121.03],
  [29.52, 35.02],
  [35.4, 26.92],
  [48.45, 141.47],
  [46.05, -72.08],
  [29.96, -90.04],
  [48.58, -123.52],
  [60.43, 22.22],
  [35.34, 25.15],
  [76.59, 21.14],
  [26.14, -80.12],
  [17.68, -64.75],
  [44.11, 9.83],
  [44.7, -75.5],
  [22.27, 91.82],
  [0.78, 127.37],
  [51.4, 3.06],
  [19.82, -70.7],
  [1.45, 104.65],
  [37.25, 27.63],
  [9.36, -79.91],
  [20.87, 106.67],
  [27.8, 127.95],
  [54.93, 10.83],
  [38.67, 118.65],
  [37.97, 23.5],
  [36.13, -5.44],
  [40.95, 28.9],
  [61.6, 4.97],
  [54.29, -130.37],
  [67.45, 14.73],
  [46.51, -84.35],
  [34.18, 129.3],
  [50.37, -0.69],
  [51.21, 1.44],
  [48.13, -69.74],
  [30.34, -88.58],
  [50.16, -2.18],
  [27.8, -97.4],
  [30.4, 130.74],
  [53.43, -129.32],
  [19.7, 109.33],
  [1.1, 103.53],
  [32.82, 35.01],
  [-4.76, 11.82],
  [35.45, 139.98],
  [9.77, 123.53],
  [40.91, -54.59],
  [18.41, -69.32],
  [54.15, -4.47],
  [34.24, 132.54],
  [51.45, 3.58],
  [44.68, -75.52],
  [46.36, 48.04],
  [45.05, -74.55],
  [-33.12, -60.5],
  [48.44, -89.18],
  [47.19, 39.69],
  [45.63, -122.72],
  [50.43, -0.02],
  [40.41, 29.09],
  [40.64, 22.92],
  [69.08, 15.95],
  [19.93, 106.42],
  [35.66, 34.44],
  [50, 8.28],
  [23.67, 119.67],
  [38.31, 21.79],
  [50.37, -4.14],
  [29.82, -93.34],
  [61.92, 4.92],
  [-0.29, 117.68],
  [49.35, -6.06],
  [53.6, 0.02],
  [32.8, 16.05],
  [38.31, 15.25],
  [49.29, -123.1],
  [45.35, 36.47],
  [-32.73, -60.73],
  [42.81, 132.89],
  [-33.07, -60.52],
  [40.96, 28.89],
  [37.94, 23.64],
  [61.23, 7.68],
  [46.43, -72.33],
  [2.83, 1.75],
  [6.98, -58.03],
  [22.32, 91.82],
  [34.04, 131.8],
  [51.24, 1.67],
  [41.45, 31.78],
  [48.76, -123.06],
  [38.76, 26.92],
  [21.93, 91.38],
  [1.35, 104.23],
  [37.94, 23.64],
  [41.15, 29.05],
  [46.67, -71.8],
  [18.55, 72.9],
  [40.6, 18.88],
  [29.62, -95.02],
  [10.19, -64.79],
  [38.73, 26.88],
  [31.39, 121.98],
  [14.83, 42.94],
  [63.43, 10.4],
  [36.83, -2.47],
  [4.89, -1.75],
  [36.12, 22.35],
  [47.19, 39.69],
  [55.8, -4.87],
  [59.27, -6.55],
  [46.51, -84.35],
  [40.84, 29.25],
  [29.87, 121.55],
  [57.12, 8.58],
  [45.13, 36.69],
  [-46.35, -64.44],
  [51.47, 0.25],
  [22.33, 91.73],
  [36.13, -5.44],
  [49.07, -123.27],
  [48.85, 12.76],
  [54.52, 13.63],
  [40.96, 28.89],
  [62.11, -6.72],
  [38.76, 26.92],
  [10.49, 119.68],
  [44, -82.52],
  [57.93, 8.89],
  [47.21, 38.95],
  [54.57, 11.93],
  [30.33, -81.65],
  [60.43, 22.22],
  [26.94, 169.82],
  [58.22, 22.52],
  [37.35, 23.47],
  [37.62, 23.75],
  [54.53, 18.52],
  [45.3, -73.92],
  [48.36, -69.27],
  [40.1, 26.38],
  [52.64, 158.82],
  [51.59, 2.1],
  [43.4, -1.67],
  [55.27, 9.8],
  [51.09, 4.33],
  [51, 1.18],
  [48.65, -2.03],
  [50.68, 7.75],
  [62.4, 6.53],
  [-5.93, 106],
  [51.28, 4.28],
  [36.65, 26.6],
  [40.8, 29.43],
  [21.47, 39.17],
  [45.07, 47.68],
  [41.27, 29.03],
  [53.87, 8.7],
  [48.52, -69.05],
  [55.86, 9.86],
  [47.58, -122.37],
  [59.73, -6.15],
  [45.43, 12.33],
  [46.57, -87.38],
  [1.18, 103.84],
  [53.07, -5.38],
  [36.92, 30.68],
  [67.5, 86.67],
  [62.73, 7.17],
  [51.33, -4.2],
  [18.25, 56.7],
  [49.37, -123.32],
  [49.31, -123.12],
  [35.51, 129.38],
  [36.3, 30.15],
  [48.34, -123.3],
  [13.15, 100.8],
  [1.19, 103.88],
  [44.14, 28.64],
  [-0.42, 117.22],
  [-20.16, 57.5],
  [1.28, 104.15],
  [49.65, -116.91],
  [16.38, -62.02],
  [46.2, 47.88],
  [52.93, 5.03],
  [14.55, 120.9],
  [58.53, 22.23],
  [53.44, -3.01],
  [51.05, 1.45],
  [40.42, 26.68],
  [34.6, 135.3],
  [41.16, 29.05],
  [41.82, 140.68],
  [38.2, 20.48],
  [41.18, 29.05],
  [53.22, 159.65],
  [28.99, 123.73],
  [53.02, 158.63],
  [68.97, 33.08],
  [33.57, 35.37],
  [49.29, -123.17],
  [22.32, 91.82],
  [21.25, 91.8],
  [47.35, -3.17],
  [50.79, -1.07],
  [18.07, -63.1],
  [36.84, 30.6],
  [-29.87, 31.03],
  [13.27, 80.35],
  [35.2, 24.9],
  [37.35, 23.47],
  [-41.28, 174.77],
  [40.15, 26.4],
  [39.53, 20.22],
  [44.82, -75.3],
  [47.12, 39.41],
  [42.28, -83.12],
  [50.13, -2.53],
  [63.8, 8.68],
  [21.68, 72.29],
  [-12.05, -77.14],
  [12.58, 43.33],
  [8.95, -79.57],
  [40.44, 29.11],
  [50.79, -1.29],
  [60.4, 5.32],
  [42.32, -83.04],
  [-45.81, 170.63],
  [25.36, 56.37],
  [12.27, -71.95],
  [40.15, 26.4],
  [51.04, 2.35],
  [34.42, 134.57],
  [1.27, 103.83],
  [44.74, 37.79],
  [51.4, 2.92],
  [45.17, 36.52],
  [44.07, 34.44],
  [29.12, -94.92],
  [38.02, 23.54],
  [62.77, -92.08],
  [43.83, -49.8],
  [47.12, 39.41],
  [40.98, 28.94],
  [49.1, -123.08],
  [-19.34, 150.58],
  [51.42, 4.38],
  [21.93, 91.38],
  [-19.26, 146.82],
  [36.62, 24.9],
  [60.34, 28.72],
  [29.6, -89.85],
  [29.83, 122.2],
  [47.66, -122.38],
  [50.04, -66.79],
  [37.94, 23.64],
  [33.27, 131.51],
  [39.9, 26],
  [57.5, -1.77],
  [38.53, 21.08],
  [33.95, 130.95],
  [49.15, 36.48],
  [46.67, 141.85],
  [37.44, 24.94],
  [-23.93, -46.33],
  [45.22, 12.28],
  [62.17, 5.93],
  [0.48, 9],
  [47.12, 39.42],
  [47.21, 38.95],
  [59.87, 30.23],
  [59.87, 30.23],
  [51.63, 3.7],
  [64.53, 40.5],
  [52.75, 4.14],
  [59.31, -19.14],
  [53.8, 0.53],
  [22.3, 114.02],
  [63.3, 19.14],
  [51.25, 4.34],
  [10.25, 107.03],
  [59.97, 30.17],
  [54.32, 10.13],
  [37.6, -0.98],
  [-6.97, 110.42],
  [22.57, 114.44],
  [45.83, -73.28],
  [37.95, 21.15],
  [36.95, 26.98],
  [30.92, -162.48],
  [60.05, 5.52],
  [69.4, 86.17],
  [51.32, 3.22],
  [48.57, -126.05],
  [50.15, 7.72],
  [-32.62, 27.12],
  [41.16, 29.05],
  [43.1, 131.89],
  [1.27, 103.83],
  [4.95, 66.62],
  [47.19, 39.69],
  [45.35, 36.47],
  [40.98, 28.96],
  [38.03, 23.5],
  [53.35, -6.18],
  [55.87, 12.85],
  [36.72, 25.27],
  [40.15, -8.87],
  [53.92, 8.72],
  [37.16, -11.69],
  [38.25, 21.74],
  [37.95, 23.63],
  [38.95, -82.1],
  [44.42, 8.92],
  [41.29, 29.01],
  [53.88, 9.15],
  [48.38, -69.09],
  [1.28, 103.93],
  [6.3, 3.4],
  [50.63, 0.28],
  [54.5, 13.86],
  [37.8, 23.62],
  [51.33, 4.27],
  [60.19, 21.59],
  [38.38, 26.15],
  [5.87, -55.09],
  [38.91, 1.44],
  [22.1, 91.75],
  [56.17, 44.21],
  [1.72, 101.43],
  [54.37, 10.15],
  [48.39, -4.47],
  [12.58, -70.09],
  [53.58, 0.15],
  [54.85, 10.52],
  [52.13, -128.13],
  [40.12, 26.39],
  [-5.98, 105.98],
  [58.97, 5.73],
  [63.97, -124.2],
  [10.41, 107.14],
  [69.32, 16.13],
  [63.45, 10.2],
  [1.25, 124.83],
  [46.49, 30.75],
  [6.35, 99.8],
  [47.09, 39.24],
  [49.31, -123.16],
  [37.78, 20.9],
  [54.32, 10.13],
  [29.07, 48.15],
  [34.69, 135.2],
  [61.08, 6.58],
  [49.19, -122.92],
  [-33.85, 18.44],
  [38.92, 121.65],
  [20.9, 107.12],
  [44.11, 9.83],
  [58.14, 12.12],
  [10.68, 122.94],
  [40.15, 26.4],
  [50.45, -3.4],
  [34.68, -76.67],
  [36.13, -5.44],
  [48.33, -69.32],
  [51.45, 4.03],
  [40.96, 28.89],
  [42.83, -79.25],
  [13.15, -61.23],
  [52.64, 2.98],
  [41, 29.02],
  [40.84, 29.29],
  [41.3, 29.38],
  [42.15, 41.66],
  [53.6, 8.36],
  [22.78, 70.07],
  [30.47, 121.93],
  [57.59, 6.69],
  [-2.45, -44.29],
  [32.91, 132.25],
  [40.96, 28.92],
  [1.36, 103.55],
  [64.38, -21.47],
  [38.44, 27.16],
  [6.78, -58.17],
  [40.83, -74],
  [4.17, 73.5],
  [46.66, -71.79],
  [69.82, 18.62],
  [39.23, -39.75],
  [64.14, -21.89],
  [71.3, 60.75],
  [46.37, -56.97],
  [44.87, 13.78],
  [51.18, 1.45],
  [59.7, -0.12],
  [49.18, -0.35],
  [43.32, 15.11],
  [51.05, 2.37],
  [36.08, 32.83],
  [56.08, 92.77],
  [19.1, 108.62],
  [44.85, 36.62],
  [40.13, -74.82],
  [-33.13, -60.49],
  [54.28, -130.35],
  [50.73, 1.62],
  [33.54, -34.11],
  [37.97, 23.57],
  [14.9, -23.52],
  [54.53, 10.48],
  [40.66, 29.25],
  [19.22, -92.08],
  [44.22, -76.51],
  [6.36, 3.32],
  [1.12, 103.5],
  [47.09, 39.24],
  [56.05, 12.69],
  [6.35, -10.78],
  [59.7, 28.43],
  [-20.78, 115.53],
  [40.97, 28.9],
  [-34.18, 22.17],
  [42.98, 47.5],
  [45.5, -73.52],
  [56, 2.17],
  [70.63, 29.72],
  [43.1, 131.89],
  [6.65, 76.6],
  [47.19, 39.69],
  [50.3, -2.18],
  [37.68, 26.93],
  [53.33, 8.48],
  [43.15, -79.18],
  [3.93, 97.03],
  [47.12, 39.41],
  [1.07, 103.57],
  [44.66, -63.56],
  [36.23, 33.98],
  [-20.15, 57.48],
  [54.97, 11.51],
  [3.85, -77.09],
  [45.3, -73.93],
  [46.32, 30.66],
  [58.1, 153.07],
  [22.55, -89.67],
  [8.76, 78.19],
  [73.9, 17.28],
  [51.92, 4.23],
  [43.12, -79.19],
  [1.72, 101.43],
  [69.63, 18.95],
  [2.88, 105.28],
  [21.72, 72.58],
  [63.11, 7.73],
  [34.43, 133.67],
  [49.02, -123.15],
  [41.2, -67.37],
  [74.29, 27.5],
  [33.95, 130.95],
  [54.32, 10.13],
  [42.08, -83.1],
  [37.3, 26.75],
  [-19.92, 35.09],
  [-33.19, 151.7],
  [53.9, 9.13],
  [39.57, 2.63],
  [-1.65, 105.78],
  [47.93, -69.55],
  [53.34, 8.49],
  [41.18, 29.05],
  [43.56, 10.31],
  [39.12, 23.75],
  [24.8, 66.98],
  [38.75, 26.9],
  [10.32, 123.92],
  [35.28, -2.93],
  [53.33, 4.53],
  [42.31, -83.08],
  [45.27, 36.42],
  [42.92, 131.47],
  [48.55, -68.64],
  [-33.34, 115.65],
  [49.88, -4.32],
  [62.82, 6.55],
  [46.34, -72.56],
  [37.15, 26.85],
  [53.55, 8.58],
  [53.51, 4.09],
  [53, 4.78],
  [47.96, -65.8],
  [47.19, 39.69],
  [18.47, -66.12],
  [-33.26, -60.26],
  [44.27, 8.45],
  [33.95, 130.95],
  [18.43, -93.2],
  [34.45, 133.74],
  [40.69, -72.95],
  [11, 124.6],
  [54.02, 9.3],
  [49, -123.59],
  [42.62, -70.66],
  [50.45, -0.49],
  [46.88, -70.93],
  [30.28, 124.77],
  [56.54, -61.67],
  [53.67, -0.23],
  [41.65, 41.66],
  [22.12, 91.74],
  [48.62, -125.18],
  [47.12, 39.41],
  [54.37, 10.15],
  [54.33, 9.72],
  [54.3, -130.36],
  [-4.13, 123.1],
  [39.83, 26.07],
  [45.45, 36.72],
  [53.46, -133.41],
  [29.61, -95.02],
  [38.25, 21.74],
  [48.39, -4.47],
  [1.14, 103.78],
  [-20.32, -40.32],
  [53.55, 8.58],
  [51.9, 4.48],
  [41.28, -70.1],
  [-0.36, 104.47],
  [-6.02, 105.95],
  [49.96, 1.19],
  [41, 28.96],
  [7.83, 98.42],
  [53.51, 9.95],
  [42.28, -83.12],
  [48.69, -123.41],
  [42.8, 10.32],
  [58.67, -4.83],
  [60.17, 37.63],
  [37.29, 25.09],
  [38.97, -75.12],
  [41, 28.96],
  [-2.28, -79.91],
  [51.8, 3.33],
  [31.38, 31.8],
  [40.28, -123.03],
  [36.45, 28.23],
  [54.72, 20.52],
  [62.21, 6.48],
  [56.05, 12.69],
  [48.75, 44.5],
  [51.26, 4.39],
  [48.84, -123.33],
  [49.19, -123.95],
  [39.62, 19.95],
  [13.13, 100.88],
  [51.42, 2.62],
  [-1.55, -48.75],
  [37.05, 25.48],
  [25.28, 51.53],
  [62.37, 6.03],
  [54.32, 10.14],
  [44.3, 8.48],
  [43.1, 131.89],
  [53.23, 8.47],
  [43.23, -79.85],
  [51.13, 3.77],
  [60.63, 28.57],
  [50.12, -5.97],
  [11.95, 45],
  [46.97, 142.73],
  [34.88, 136.96],
  [-34.16, -58.97],
  [33.47, -13.95],
  [37.94, 23.64],
  [45.4, -73.8],
  [35.12, 129.04],
  [42.15, 41.66],
  [10.32, 123.92],
  [51.33, 3.82],
  [5.44, 100.35],
  [30.33, -81.65],
  [49.9, -5.9],
  [54.34, 10.17],
  [62.48, 6.15],
  [8.45, -13.47],
  [48.4, -69.22],
  [-7.7, 108.98],
  [38.92, 118.51],
  [-8.22, 76.8],
  [51.4, 1.38],
  [51.29, 1.84],
  [48.14, -69.73],
  [3.32, 3.88],
  [41.35, 2.17],
  [1.27, 103.83],
  [33.9, 130.67],
  [1.27, 103.28],
  [49.96, -3.01],
  [53.04, 4.85],
  [-23.96, -46.29],
  [10.33, -75.54],
  [32.32, -64.83],
  [70.93, 25.85],
  [49.29, -123.1],
  [48.33, -69.32],
  [45.02, -74.62],
  [54.3, -130.35],
  [74.52, 19.02],
  [41.3, 36.34],
  [42.28, -83.12],
  [38.88, 118.64],
  [55.52, 9.65],
  [53.88, 9.13],
  [38.02, 24],
  [38.73, -9.12],
  [-18.4, -153.23],
  [57.43, 10.53],
  [40.02, 26.28],
  [41, 28.96],
  [29.68, -95],
  [31.14, 32.32],
  [-46.42, -60.73],
  [10.96, -74.77],
  [10.31, 123.94],
  [33.12, -8.63],
  [22.59, 120.31],
  [54.02, 4.23],
  [47.5, -129.5],
  [56.6, 12.13],
  [51.9, 4.48],
  [53.6, 8.36],
  [62.01, -6.77],
  [44.42, 8.82],
  [33.62, 130.41],
  [49.28, -123.03],
  [53.58, 8.53],
  [51.4, 2.58],
  [54.17, 9.43],
  [-4.78, 11.83],
  [37.94, 23.64],
  [46.67, -55.73],
  [45.17, -83.25],
  [58.97, 5.73],
  [40.38, 49.85],
  [49.66, -5.67],
  [44.69, -63.62],
  [53.68, 8.04],
  [-5.87, 105.96],
  [-53.22, -56.06],
  [-3.73, 128.08],
  [39.28, -76.61],
  [54.81, 9.44],
  [55.95, 6.3],
  [55.46, 12.2],
  [36.84, 30.6],
  [9.5, -13.72],
  [59.82, 30.59],
  [1.14, 103.66],
  [38.42, 14.97],
  [1.22, 104.58],
  [-0.27, -91.37],
  [41.27, 29.03],
  [53.45, -3],
  [3.17, 113.03],
  [29.86, 32.54],
  [31.2, 29.73],
  [41.15, 29.05],
  [4.77, 7.01],
  [46.37, 72.43],
  [3.93, 98.75],
  [36.84, 30.61],
  [36.78, 34.63],
  [-23.84, 151.27],
  [54.93, 73.35],
  [59.59, 23.17],
  [40.62, 18.15],
  [-34.19, 18.43],
  [39.32, 26.72],
  [51.41, 4.03],
  [-8.7, 116],
  [3.35, 6.44],
  [47.62, -122.5],
  [-34.59, -58.38],
  [55.48, 8.41],
  [47.56, -52.71],
  [-14.21, -169.55],
  [34.65, 127.88],
  [60.69, 17.21],
  [50.42, -0.4],
  [25.35, 55.37],
  [-33.02, -71.63],
  [52.97, 4.78],
  [0.03, 117.91],
  [-6.02, 106.92],
  [1.07, 103.67],
  [37.18, -88.23],
  [49.67, -127.5],
  [49.3, -3.88],
  [59.33, 18.08],
  [30.04, 47.96],
  [5.33, 103.15],
  [25.98, 54.88],
  [21.93, 91.38],
  [0.25, 117.58],
  [67.28, 14.38],
  [46.07, -73.03],
  [41.16, 29.05],
  [47.19, 39.69],
  [39.17, 23.48],
  [-5.85, 13.05],
  [56.51, 20.75],
  [11.28, 49.18],
  [-12.05, -77.14],
  [40, 26.25],
  [43.56, 10.31],
  [4.59, 114.18],
  [4.4, 7.83],
  [4, 100],
  [44.65, -63.58],
  [4.05, 9.7],
  [40.65, 27.5],
  [38.25, 20.65],
  [53.36, 7.19],
  [40.97, 28.94],
  [48.97, 140.27],
  [-12.02, -77.19],
  [-32.73, -60.73],
  [41, 29.02],
  [51.37, 4.22],
  [49.3, -123.09],
  [35.89, -5.56],
  [33.32, 128.32],
  [51.8, 4.02],
  [10.68, 122.94],
  [40.78, 29.61],
  [48.83, -123.32],
  [34.16, 127.91],
  [37.94, 23.64],
  [52.97, 4.78],
  [47.17, 39.58],
  [53.23, 6.53],
  [-41.28, 174.78],
  [39.35, 22.95],
  [52.25, -128.3],
  [46.7, -71.4],
  [59.73, 5.37],
  [5.68, 106.58],
  [35.94, -89.69],
  [41.3, 36.34],
  [53.55, 9.98],
  [32.42, 119.42],
  [29.94, -90.06],
  [29.85, -93.96],
  [46.4, 151.92],
  [50.68, 0.83],
  [40.95, 28.9],
  [37.94, 23.64],
  [22.29, 114.16],
  [-28.79, 32.04],
  [52.77, 0.2],
  [50.77, -1.32],
  [57.22, 5.65],
  [34.2, 135.13],
  [37.95, -121.32],
  [15.38, 109.36],
  [45.95, -73.22],
  [59.87, 30.23],
  [37.53, 23.82],
  [10.9, 106.84],
  [13.09, 80.29],
  [18.34, -64.95],
  [39.87, 25.05],
  [50.6, 0.57],
  [53.35, 7.2],
  [50.15, -5.06],
  [46.4, -72.38],
  [36.17, -5.38],
  [22.32, 91.82],
  [37.75, 23.43],
  [43.37, -8.41],
  [37.81, 23.48],
  [55.47, 8.43],
  [50.48, -2.48],
  [51.88, 4.28],
  [51.9, 3.52],
  [25.78, -80.19],
  [41.82, 140.68],
  [31.82, 34.65],
  [39.17, 23.48],
  [49.95, -2.85],
  [46.73, 38.28],
  [-32.73, -60.73],
  [39.53, 20.22],
  [37.92, 23.09],
  [46.5, -84.39],
  [55.01, 9.69],
  [47.56, -52.4],
  [56.41, 10.91],
  [49.83, -2.87],
  [3.9, 5.45],
  [16.98, 82.28],
  [56.41, 10.91],
  [30, 122.1],
  [6.29, 2.49],
  [50.08, -6.02],
  [29.94, -90],
  [53.74, -0.28],
  [59.87, 30.23],
  [53.9, 9.13],
  [54.53, 18.55],
  [-29.87, 31.03],
  [25.36, 56.37],
  [-33.86, 151.21],
  [6.27, 3.18],
  [43.33, -51.67],
  [-5.93, 106],
  [43.28, -79.85],
  [21.47, 39.17],
  [-32.64, -60.77],
  [45.35, 36.47],
  [14.58, 120.97],
  [44.14, 28.64],
  [38.38, 22.63],
  [59.97, 30.17],
  [37.94, 23.64],
  [51.48, 1.93],
  [42.4, -82.83],
  [33.83, 132.7],
  [45.62, -61.4],
  [-37.83, 144.92],
  [22.28, 91.72],
  [63.07, 8.23],
  [49.2, -123.9],
  [45.45, -54.74],
  [41.05, 39.66],
  [37.94, 23.64],
  [50.68, -1.95],
  [42.9, -79.23],
  [37.95, 21.15],
  [60.03, -77.28],
  [1.21, 103.57],
  [53.64, 5.08],
  [1.43, 104.69],
  [25.2, -42.98],
  [57.68, -2],
  [40.78, 29.61],
  [55.45, 10.57],
  [37.38, 23.23],
  [56.15, 10.22],
  [53.61, -130.98],
  [45.3, -83.42],
  [52.5, 5.43],
  [40.85, 14.28],
  [49.64, 0.16],
  [4.02, 7.05],
  [49.3, -122.93],
  [41.26, 29.37],
  [53.87, 10.67],
  [-26.9, -48.67],
  [48.35, -123.35],
  [-77.85, 166.67],
  [64.53, 40.5],
  [54.3, -130.35],
  [51.53, 7.06],
  [48.97, -125.22],
  [-32.91, 151.76],
  [48.47, -129.22],
  [25.14, 121.75],
  [68.97, 33.08],
  [59.43, 24.77],
  [48.77, -123.33],
  [4.33, 7.58],
  [54.05, -130.57],
  [38.73, -9.12],
  [16.94, 54.02],
  [1.12, 104.18],
  [49.64, -1.61],
  [54.97, 10.42],
  [41.25, 29.17],
  [49.32, -123.15],
  [-5.95, 105.98],
  [52.75, 4.43],
  [-33.63, 17.9],
  [50.15, -3.28],
  [41.75, -82.68],
  [40.22, 26.47],
  [-45.87, 170.52],
  [55.1, 14.69],
  [49.02, -123.15],
  [6.9, 122.07],
  [53.52, 8.15],
  [47.57, -59.12],
  [50.58, -5.85],
  [53.55, 9.98],
  [-7.3, 152.03],
  [74.57, 72.47],
  [35.12, 129.04],
  [28.15, -15.38],
  [46.96, -70.83],
  [36.5, 23.05],
  [38.63, 42.82],
  [54.21, -0.07],
  [54.35, -130.27],
  [5.81, 118.08],
  [48.33, -70.87],
  [40.98, 28.95],
  [34.98, 140.3],
  [49.29, -123.1],
  [47.78, -122.48],
  [36.95, 27],
  [43.4, -1.67],
  [54.32, 10.13],
  [50.95, 1.18],
  [40.03, 26.32],
  [-32.73, -60.73],
  [43.1, 131.89],
  [44.72, 136.25],
  [56.64, -2.46],
  [63.1, 8.1],
  [8.95, -79.57],
  [46.98, -70.8],
  [18.9, 72.98],
  [48.49, -124.67],
  [70.67, 23.67],
  [39.28, -76.61],
  [2.47, 104.43],
  [28.13, -15.43],
  [36.25, 23],
  [35.12, 129.04],
  [38.68, -9.42],
  [49.15, -123.57],
  [51.43, 6.75],
  [41, 28.96],
  [69.15, 46.7],
  [18.03, -63.05],
  [48.69, -123.41],
  [48.39, -4.47],
  [40.71, 28.96],
  [22.28, -73.22],
  [54.36, 9.88],
  [13.63, 42.58],
  [36.73, 27.72],
  [50.61, -1.07],
  [18.98, 124.75],
  [6.28, 3.38],
  [13.23, 57.71],
  [45.4, -73.55],
  [43.24, -79.26],
  [0.94, 105.11],
  [10.32, 123.75],
  [37, 22.12],
  [51.92, 3.7],
  [48.75, -123.08],
  [48.13, -69.73],
  [59.49, 10.32],
  [-8.2, 114.38],
  [46.28, 47.95],
  [38.76, 26.92],
  [51.04, 2.35],
  [6.42, 3.37],
  [12.55, -81.68],
  [51.38, 3.7],
  [54.32, 10.13],
  [58.31, -134.42],
  [-34.72, -57.83],
  [-14.33, 144.65],
  [21.34, -89.68],
  [12.17, -68.28],
  [48, -61.53],
  [54.32, -130.32],
  [62.4, 6.17],
  [51.3, 3.83],
  [4.44, 7.14],
  [2.13, 104.45],
  [45.55, -73.52],
  [70.13, 39.95],
  [46.5, -84.4],
  [38.03, 23.5],
  [59.4, 10.48],
  [2.83, 101.2],
  [51.95, 4.05],
  [45.48, -73.52],
  [58.18, -5.45],
  [54.96, -5.01],
  [50.71, -127.49],
  [54.36, 10.03],
  [43.87, -82.39],
  [45.34, 36.67],
  [-12.03, -77.19],
  [6.75, -11.37],
  [74.57, 72.47],
  [47.12, 39.41],
  [36.7, -4.42],
  [37.82, 24.9],
  [45.65, 13.8],
  [48.74, -123.14],
  [11.1, -74.93],
  [51.94, 3.75],
  [32.76, -91.16],
  [37.94, 23.64],
  [-5.87, 105.75],
  [62.48, 6.15],
  [54.09, 12.14],
  [54.2, -130.4],
  [39.53, 20.22],
  [53.7, -0.86],
  [22.38, -87.23],
  [41, 29.02],
  [51.28, 4.28],
  [53.9, 7.87],
  [1.27, 103.83],
  [6.32, 3.21],
  [50.6, -6.07],
  [3.95, 6.32],
  [38.18, 15.55],
  [51.9, 0.13],
  [46.82, -54.15],
  [38.78, 26.93],
  [53.63, 7.75],
  [-32.56, -58.18],
  [-35.18, -55.48],
  [44.55, 37.46],
  [32.82, 35.01],
  [49.4, -64.52],
  [14.58, 120.97],
  [45.17, 158.83],
  [46.27, -72.6],
  [57.08, 0.89],
  [-20.78, 115.53],
  [66.02, 12.62],
  [50.06, -125.23],
  [35.89, -5.32],
  [43.37, -8.41],
  [57.11, 23.88],
  [50.12, 8.67],
  [59.49, 10.32],
  [40.41, 29.09],
  [19.13, 71.17],
  [37.97, 23.57],
  [50.23, -1.8],
  [34.69, 11.03],
  [50.74, 1.34],
  [43.13, -80.33],
  [46.61, -71.99],
  [-6.11, 106.89],
  [41.75, -70.57],
  [30.47, -91.18],
  [22.59, 120.31],
  [60.78, 4.82],
  [1.08, 103.57],
  [51.78, -5.15],
  [54.68, -5.67],
  [38.76, 26.92],
  [69.67, 18.98],
  [53.9, 9.13],
  [54.12, -130.56],
  [35.12, 129.04],
  [50.7, -5.87],
  [55.59, 15.29],
  [35.44, 139.66],
  [45.25, 36.5],
  [47.55, -52.7],
  [48.27, -64.7],
  [-20.6, 117.18],
  [22.58, 114.65],
  [46.03, -73.12],
  [-0.5, 117.15],
  [37.73, -25.67],
  [53.55, 8.58],
  [40.96, 28.89],
  [50.56, -6.24],
  [64.14, -21.89],
  [50.5, -0.83],
  [55.23, 11.75],
  [-34.97, -54.95],
  [1.07, 103.7],
  [37.97, 23.57],
  [40, -75.03],
  [47.3, -70.52],
  [55.82, 10.05],
  [35.01, 138.5],
  [37.95, 23.64],
  [45.42, 141.7],
  [55.1, 10.23],
  [53.89, 9.15],
  [46.5, -84.39],
  [3, 116.33],
  [49.13, -123.85],
  [-34.05, 17.22],
  [59.97, 30.17],
  [41.55, 28.92],
  [52.02, 3.02],
  [46.72, -71.38],
  [45.57, -73.5],
  [51.4, 3.09],
  [64.53, 40.5],
  [44.74, 37.79],
  [36.79, 34.63],
  [49.22, -123.11],
  [50.9, -1.41],
  [49.34, -123.44],
  [53.74, 5.82],
  [27.91, 34.33],
  [-35.06, -57.14],
  [37.32, 26.54],
  [41, 28.96],
  [36.14, -5.37],
  [35.03, 138.5],
  [60.34, 22.06],
  [24.07, -82.72],
  [47.19, 39.69],
  [-27.41, 153.16],
  [70.98, 25.98],
  [59.43, 10.66],
  [55.87, 12.81],
  [48.32, 14.3],
  [49.93, -4.34],
  [1.44, 104.53],
  [44.3, 8.48],
  [9.5, 118.5],
  [46.03, -83.93],
  [41.15, 29.03],
  [51.4, 3.15],
  [36.3, 30.15],
  [31.25, 32.3],
  [22.32, 91.82],
  [-35.73, 174.35],
  [37.94, 23.64],
  [48.39, -4.47],
  [51.34, 3.86],
  [4.98, 8.32],
  [37.23, 15.19],
  [39.11, 26.56],
  [-5.99, 105.93],
  [47.12, 39.41],
  [28.64, -91.78],
  [49.12, -123.1],
  [53.89, 9.18],
  [49.8, -3.97],
  [42.17, -81.35],
  [41.28, 29.06],
  [40.15, 26.4],
  [51.57, 1.75],
  [55.94, -4.72],
  [-21.11, 149.22],
  [59.02, 5.6],
  [38.03, 23.5],
  [10.7, 122.57],
  [35.03, 136.87],
  [35.19, 33.93],
  [49.87, -1.37],
  [46.36, 48.04],
  [29.7, -91.22],
  [48.87, -123.63],
  [41.63, 41.65],
  [-0.5, 117.15],
  [-23.84, 151.27],
  [46.02, -122.83],
  [39.57, 2.63],
  [36.52, 27.67],
  [69.4, 86.17],
  [56.7, 8.22],
  [40.78, 29.61],
  [45.13, -74.45],
  [52.67, 4.03],
  [22.62, -78.67],
  [-35, 19.12],
  [-7.08, 112.66],
  [46.43, -72.25],
  [52.08, -10.53],
  [36.39, 25.43],
  [26.73, 33.93],
  [-2.93, -80.09],
  [69.65, 18.97],
  [40.26, 26.52],
  [45.3, -73.93],
  [39.83, 26.07],
  [53.87, 9.03],
  [45.15, 36.51],
  [-9.75, 122],
  [50.95, 1.06],
  [43.8, 29.01],
  [62.59, 6.24],
  [49.19, -122.91],
  [12.8, 45.03],
  [-19.26, 146.83],
  [36.3, 30.15],
  [31.88, 122.8],
  [50.21, -5.46],
  [-7.04, 112.67],
  [45.7, 47.68],
  [54.35, -130.28],
  [38.25, 21.74],
  [40.97, 28.91],
  [25.23, 56.52],
  [50.17, -2.75],
  [1.27, 103.83],
  [54.37, 10.12],
  [46.25, -72.77],
  [72.61, -79.24],
  [43.98, -63.45],
  [34.19, 137.37],
  [0.58, 57.14],
  [53.33, 8.48],
  [37.94, 23.64],
  [53.9, 9.13],
  [23.1, 113.23],
  [38.03, 23.5],
  [22.88, -109.91],
  [55.13, -1.51],
  [45.78, 47.55],
  [24.27, 118.29],
  [40.03, 26.07],
  [57.59, 9.97],
  [49.08, 140.27],
  [21.93, 91.38],
  [48.95, -126.57],
  [72.41, 46.89],
  [47.85, -69.75],
  [46.85, -70.98],
  [13.77, 120.97],
  [37.94, 23.64],
  [38.63, -9.82],
  [0.23, 130.52],
  [54.65, 11.35],
  [52.38, 1.8],
  [34.51, 134.29],
  [38.7, 1.45],
  [37.44, 24.94],
  [47.55, -122.53],
  [37.7, 23.33],
  [15.92, 52.34],
  [35.45, 139.81],
  [28.13, -15.43],
  [37.94, 23.64],
  [33.75, -78.13],
  [33.95, 130.95],
  [-18.13, 178.43],
  [41.37, -71.48],
  [62.73, 7.17],
  [37.54, 25.15],
  [42.8, 132.88],
  [30.04, 47.96],
  [24.46, 118.07],
  [45.25, -81.67],
  [53.59, -0.73],
  [45.83, 47.97],
  [50.71, -1.99],
  [56.72, 37.1],
  [9.97, 76.23],
  [70.67, 23.67],
  [49, -9],
  [10.18, -61.69],
  [-0.27, 109.88],
  [48.75, -122.5],
  [38.25, 21.74],
  [48.69, -123.41],
  [62.74, 16.93],
  [37.94, 23.64],
  [53.02, 158.63],
  [79.9, 18.08],
  [40.89, 29.19],
  [53.97, 8.5],
  [41.35, 2.17],
  [-0.5, 117.15],
  [29.85, -93.96],
  [55.8, 10.53],
  [36.13, 23],
  [52.95, 4.79],
  [49.57, -55.74],
  [60.15, 5.43],
  [43.75, -81.73],
  [64.53, 40.5],
  [6.3, 78.73],
  [34.32, 133.83],
  [40.34, 26.68],
  [36.3, 30.15],
  [53.88, 10.69],
  [45.34, 36.67],
  [40.41, 29.08],
  [64.17, -51.73],
  [54.26, -0.23],
  [54.32, 9.67],
  [54.53, 18.55],
  [18.47, -66.12],
  [-36.85, 174.78],
  [40.15, 26.4],
  [35.51, 139.89],
  [56.71, 10.24],
  [48.42, -5.88],
  [59.91, 30.23],
  [54.31, 13.11],
  [45.62, -73.5],
  [1.27, 103.83],
  [48.37, -5.47],
  [56.7, 8.22],
  [43.05, 131.97],
  [41.28, 31.42],
  [35.44, 139.66],
  [47.6, 41.48],
  [37.97, 23.57],
  [38.36, 22.67],
  [41, 28.96],
  [61.87, 5.18],
  [40.76, 29.46],
  [43.65, -8.07],
  [53.78, 7.9],
  [41.3, 36.34],
  [55.34, 5.69],
  [-21.11, -175.18],
  [45.55, 13.74],
  [21.47, 39.17],
  [49.2, -123.95],
  [-5.99, 106.9],
  [37.94, 23.64],
  [46.32, 48.97],
  [37.94, 23.64],
  [48.42, -123.38],
  [44.14, 28.64],
  [57.78, 154.62],
  [7.08, 171.13],
  [37.94, 23.64],
  [40.38, 9.7],
  [46.59, -72.02],
  [13.1, -59.63],
  [65.08, 11.62],
  [37.22, -89.46],
  [-5.83, 105.8],
  [40.02, 26.28],
  [63.44, 10.41],
  [49.38, -66.02],
  [48.87, -62.34],
  [39.53, 20.22],
  [29.2, -89.27],
  [59.91, 10.76],
  [64.53, 40.5],
  [55.08, 14.68],
  [59.22, 5.92],
  [31.5, 25.12],
  [46.05, -73.12],
  [-33.19, 151.7],
  [-23.84, 151.27],
  [36.84, -2.48],
  [38.03, 23.5],
  [60.1, 5.25],
  [58.2, -6.38],
  [-28.79, 32.04],
  [59.36, 1.57],
  [25.52, 119.78],
  [13.2, 120.35],
  [10.67, 122.95],
  [34.41, 134.27],
  [44.63, 33.57],
  [35.83, 10.65],
  [53.02, 158.63],
  [47.19, 39.69],
  [46.34, 36.67],
  [45.15, 36.51],
  [-35.07, 19.02],
  [40.85, 25.95],
  [50.42, -0.82],
  [62.28, -74.4],
  [55.8, 8.02],
  [54.09, 12.14],
  [29.17, -88.22],
  [40.45, 25.53],
  [16.1, 108.3],
  [68.97, 33.08],
  [41.5, -81.71],
  [34.52, 18.5],
  [59.37, -1.97],
  [67.28, 14.38],
  [62.48, 6.15],
  [53.32, 6.98],
  [53.83, 1.22],
  [-29.87, 31.03],
  [46.65, -71.92],
  [57.11, 23.88],
  [6.32, 3.4],
  [43.2, -67.49],
  [41.15, 29.05],
  [28.13, -15.43],
  [34.73, 10.77],
  [1.42, 104.68],
  [25.17, 56.37],
  [46.36, 48.04],
  [50.71, -1.99],
  [49.68, -123.17],
  [55.47, 8.43],
  [39.62, 19.95],
  [48.48, -68.51],
  [55.96, 12.02],
  [-2.54, 105.74],
  [49, -66.97],
  [0.22, 3.57],
  [54.49, 11.95],
  [5.22, -4],
  [57.4, 21.56],
  [10.4, -75.52],
  [44.74, 37.79],
  [51.53, -6],
  [70.66, 23.68],
  [28.48, -16.23],
  [24.97, 120],
  [45.34, 36.67],
  [36.17, 28],
  [63.44, 10.41],
  [21.93, 91.38],
  [-5.88, 105.98],
  [48.77, -123],
  [40.15, 26.4],
  [33.48, 11.12],
  [53.93, 9.21],
  [29.35, 34.95],
  [39.37, -9.38],
  [57.63, -1.39],
  [50, 8.04],
  [36.44, 28.23],
  [36.44, 28.23],
  [49.8, -3.63],
  [49.56, -54.44],
  [51.47, 0.25],
  [51.2, 1.6],
  [58.92, 6.07],
  [61.87, 5.2],
  [45.3, -73.93],
  [-22.35, -41.8],
  [20.42, 106.17],
  [41, 39.75],
  [31.2, 29.89],
  [3.5, 6.33],
  [6.93, 79.83],
  [3.35, 74.02],
  [11.18, -60.74],
  [40.96, 28.89],
  [39.62, 19.95],
  [38.02, 24],
  [1.28, 103.87],
  [55.8, 8.02],
  [22.32, 91.82],
  [-33.95, 26.65],
  [51.39, 4.17],
  [53.98, -10.4],
  [72.06, 128.47],
  [29.97, 32.55],
  [62.2, 5.58],
  [55.21, 11.25],
  [-32.06, 115.75],
  [50.21, -66.38],
  [15.83, 52.23],
  [3.95, 98.79],
  [38.53, -28.53],
  [35.5, 27.2],
  [44.46, -63.47],
  [42.23, -83.13],
  [37.94, 23.64],
  [37.96, 23.56],
  [-7.2, 112.73],
  [18.65, -91.85],
  [34.05, 135.35],
  [43.22, -79.2],
  [22.23, 114.13],
  [13.08, 100.88],
  [60.4, 5.32],
  [37.75, 23.43],
  [35.89, 14.51],
  [47.43, -70.35],
  [51.98, 4.12],
  [54.34, 130.32],
  [40.96, 28.89],
  [27.12, 56.06],
  [54.3, -130.33],
  [42.82, -79.25],
  [41, 28.96],
  [48.4, -69.28],
  [26.05, 50.65],
  [54.32, 10.13],
  [41, 28.96],
  [44.59, -80.95],
  [23.1, 113.23],
  [45.83, 47.97],
  [53.95, -3.59],
  [39.58, 19.87],
  [36.73, 27.69],
  [53.27, -133.03],
  [47.12, 39.41],
  [38.15, 24.62],
  [48.32, -69.25],
  [40.84, 29.29],
  [25.37, 55.38],
  [26.2, -91.43],
  [32.77, 22.65],
  [51.47, 155.1],
  [49.2, -123.12],
  [41.31, 19.45],
  [51.57, -9.12],
  [49.13, -4.63],
  [53.83, 4.73],
  [54.3, 10.13],
  [1.44, 103.9],
  [54.22, 9.6],
  [54.3, -130.35],
  [40.15, 26.4],
  [10.2, -64.78],
  [54, 7.5],
  [38.02, 24.82],
  [37.94, 23.64],
  [46.73, -92.15],
  [53.38, 0.82],
  [51.33, 3.85],
  [49.4, -54.86],
  [46.62, 142.77],
  [10.36, 107.03],
  [60.98, -148.05],
  [37.94, 23.64],
  [47.43, -70.33],
  [61.92, 5.12],
  [54.25, 9.62],
  [-5, 120],
  [49.48, 0.1],
  [37.94, 23.64],
  [54.47, 9.86],
  [34.72, 137.33],
  [10.26, 107.02],
  [39.35, 22.95],
  [12.58, 122.27],
  [44.74, 37.79],
  [-20.15, 57.48],
  [71.54, 136.65],
  [70.48, 22.15],
  [46.13, -122.93],
  [28.67, -96],
  [71.42, 31.79],
  [51.85, 2.1],
  [45.15, 29.65],
  [34.2, 135.13],
  [42.72, 34.43],
  [60.34, 28.72],
  [55.06, 10.62],
  [10.18, -64.77],
  [52.58, 5.8],
  [50.59, -5.45],
  [36.85, 28.28],
  [37.95, 23.62],
  [53.96, 10.86],
  [44.13, 28.79],
  [51.82, 4.65],
  [42.5, 27.47],
  [48.75, -62.82],
  [70.97, 25.95],
  [1, 4],
  [56.49, -5.47],
  [51.81, 4.88],
  [37.95, 21.15],
  [1.08, 104.03],
  [22.78, 70.07],
  [68.67, 15.91],
  [38.43, 27.15],
  [45.76, 47.6],
  [31.59, 30.97],
  [70.63, 29.72],
  [-20.85, 116.2],
  [1, -1.25],
  [39.62, 19.95],
  [-33.34, 115.65],
  [22.14, 91.72],
  [25.42, 55.45],
  [38.65, 23],
  [-47.76, -65.91],
  [39.5, 20.18],
  [6.44, 3.39],
  [35.34, 25.15],
  [25.4, 55.47],
  [40.97, 28.94],
  [43.33, 5.35],
  [49.28, -123.18],
  [35.15, -90.05],
  [58.3, -134.41],
  [54.32, 10.13],
  [-22.88, 14.47],
  [49.3, -123.12],
  [9.37, -13.72],
  [35.44, 129.44],
  [1.1, 103.91],
  [5.63, 0.01],
  [48.69, -123.41],
  [47.07, 39.08],
  [41.27, 29.02],
  [35.89, -5.32],
  [49.33, -123.85],
  [69.02, 34.33],
  [42.24, -8.73],
  [39.57, 2.63],
  [33.91, 130.93],
  [53.6, 0.02],
  [46.5, -84.32],
  [37.7, 123.18],
  [-20.16, 57.5],
  [1.07, 104.22],
  [43.57, 39.7],
  [36.84, 122.26],
  [74.52, 19.02],
  [36.83, 30.6],
  [51.6, 3.99],
  [45.54, -73.54],
  [45.13, -66],
  [45.95, -73.2],
  [45.34, -73.91],
  [59.77, 30.8],
  [38.03, 23.5],
  [33.32, 135.6],
  [36.98, 24.67],
  [22.29, 114.16],
  [75.23, 17.8],
  [37, 126.79],
  [59.88, 30.22],
  [38.82, 26.94],
  [45.22, -74.09],
  [36.92, 30.68],
  [62.37, 6.02],
  [44.68, -75.52],
  [49.29, -123.1],
  [1.23, 104.08],
  [48.31, -69.35],
  [39.1, 23.33],
  [4.58, 103.45],
  [70.63, 29.73],
  [53.58, 6.67],
  [-3.65, 39.88],
  [35.45, 139.68],
  [51.88, 5.45],
  [52.62, 4.62],
  [48.63, -69.13],
  [41.27, 29.07],
  [47.68, -122.42],
  [8.67, 109],
  [59.26, -3.71],
  [51.79, 3.35],
  [3.8, 98.72],
  [60.39, 25.66],
  [22.32, 91.82],
  [59.42, 10.47],
  [57.12, 8.58],
  [63.72, -68.5],
  [37.95, 21.15],
  [45.55, 36.82],
  [4.9, -1.68],
  [35.12, 129.04],
  [31.44, 32.44],
  [49.23, -124.82],
  [31.25, 32.3],
  [59.35, 10.58],
  [41, 28.96],
  [55.25, 14.87],
  [65.03, -14.22],
  [61.92, 5.12],
  [38.44, 27.16],
  [31.46, 31.77],
  [54.34, 9.96],
  [60, -42],
  [50.45, 0.18],
  [59.67, 28.3],
  [37.1, -35.25],
  [4.03, 7.52],
  [-4.05, 39.65],
  [36.44, 23.11],
  [46.04, 138.68],
  [36.84, -2.48],
  [49.47, 0.2],
  [-6.02, 106.9],
  [53.55, 9.98],
  [63.11, 7.73],
  [48.44, -123.44],
  [44.96, -66.89],
  [22.61, 120.26],
  [4.1, 6.93],
  [31.39, 121.98],
  [40.2, 26.45],
  [46.09, -73],
  [32.71, -117.17],
  [-30.37, -51.39],
  [53.89, 9.18],
  [53.67, 5.57],
  [-34.15, -52.73],
  [35.68, 140],
  [45.28, 37.37],
  [40.87, 29.33],
  [51.12, 6.86],
  [59.87, 30.23],
  [-4.07, 39.65],
  [40.93, 28.93],
  [39.15, 23.83],
  [7.12, 125.66],
  [47.12, 39.41],
  [51.8, 4.9],
  [66.5, 13],
  [-32.04, 115.7],
  [4.22, 7.98],
  [38.05, 24.83],
  [36.38, 22.93],
  [57.44, 10.54],
  [40.42, 29.1],
  [58.62, -3.53],
  [-4.67, 55.47],
  [55.46, 12.2],
  [-0.23, 117.56],
  [57.4, 21.56],
  [40.96, 28.89],
  [2.63, 104.72],
  [58.85, 5.74],
  [25.27, 55.29],
  [18.33, -64.92],
  [8.75, 167.82],
  [43.69, -7.6],
  [13.73, 121.03],
  [47.19, 39.69],
  [-23.23, -43.87],
  [40.97, 28.92],
  [70.98, 25.98],
  [50.3, 0.38],
  [31.26, 32.36],
  [16.77, 96.17],
  [36.74, 34.66],
  [48.8, -69.07],
  [46.48, -84.3],
  [42.5, 27.47],
  [38.03, 23.5],
  [35.44, 129.44],
  [54.88, 10.42],
  [23.1, 113.23],
  [43.87, -78.83],
  [1.13, 103.92],
  [74.88, 134.02],
  [58.48, -2.52],
  [40.97, 28.5],
  [40.62, 27.62],
  [53.02, 158.63],
  [11.95, 75.3],
  [48.93, -126.22],
  [28.13, -15.4],
  [53.33, 8.48],
  [60.47, 6.6],
  [40, 26.25],
  [46.97, -70.83],
  [46.24, -124.06],
  [-0.28, 117.7],
  [2.83, 104.5],
  [68.8, 16.54],
  [36.3, 30.15],
  [51.26, 4.39],
  [32.42, 119.42],
  [48.45, -125],
  [36.88, 27.28],
  [39.44, -0.33],
  [31.82, 34.65],
  [55.47, 8.43],
  [54.4, 11.8],
  [1.27, 103.83],
  [49.29, -124.13],
  [28.13, -15.43],
  [50.42, 0.48],
  [48.28, 15.73],
  [37.96, 23.56],
  [36.73, 27.69],
  [44.39, 48.1],
  [62.37, 6.03],
  [37.94, 23.64],
  [14.6, -61.06],
  [49.22, -123.9],
  [41.15, 29.03],
  [10.15, -64.84],
  [56.47, 53.8],
  [22.22, 91.72],
  [46.25, -72.63],
  [50.12, -5.82],
  [47.09, 39.24],
  [54.72, -5.73],
  [53.33, 8.48],
  [29.37, -94.88],
  [54.37, 10.15],
  [53.84, 9.4],
  [60.46, -0.27],
  [44.1, 36.57],
  [-19.92, 35.09],
  [40.78, 29.61],
  [45.8, 13.23],
  [49.43, -123.47],
  [37.97, 23.57],
  [57.44, 10.54],
  [24.53, 54.38],
  [37.95, 21.15],
  [46.58, 32.53],
  [-7.02, 113.87],
  [34.2, 132.35],
  [29.92, -90.09],
  [-41.29, 174],
  [49.57, -4.32],
  [45.03, 35.4],
  [38.91, 1.44],
  [-32.06, 115.75],
  [45.17, -66.08],
  [37.81, -122.33],
  [45.15, 36.51],
  [55.42, 13.82],
  [39.48, 20.27],
  [53.78, 4.85],
  [13.88, -90.71],
  [68.48, 16.28],
  [44.25, 8.43],
  [56.41, 10.91],
  [40.97, 28.93],
  [55.25, 9.79],
  [-32.06, 115.75],
  [60.2, 5.57],
  [48.04, -69.41],
  [56.71, 8.23],
  [37.5, 15.09],
  [2.83, 101.2],
  [50.57, 0.53],
  [47.37, -61.85],
  [48.13, -69.73],
  [40.93, 24.4],
  [3.7, 5.17],
  [35.37, 139.87],
  [49.29, -123.09],
  [50.53, -1.67],
  [49.12, -123.17],
  [1.44, 103.9],
  [4.42, 7.15],
  [25, -90],
  [40.77, 29.73],
  [36.16, -5.38],
  [50.32, -0.7],
  [59.82, 22.95],
  [-12.02, -77.19],
  [24.63, -76.18],
  [50.97, 1.86],
  [38.02, 24],
  [54.9, 12.08],
  [0.03, -50.97],
  [-33.9, 18.43],
  [49.3, -122.94],
  [41.27, 29.05],
  [53.91, -166.52],
  [22.59, 120.31],
  [43.4, 3.7],
  [1.36, 104.25],
  [40.95, 28.86],
  [48.83, -62],
  [57.68, -2],
  [61.77, 34.32],
  [48.39, -4.47],
  [45.51, -73.55],
  [40.1, 26.38],
  [58.8, -3.38],
  [30.32, -81.62],
  [60.13, -1.27],
  [45.34, 36.67],
  [58.34, 11.87],
  [35.5, -75.06],
  [12.42, -70.14],
  [1.12, 103.52],
  [57.7, 11.95],
  [40.41, 29.09],
  [48.5, -62.25],
  [42.39, -8.69],
  [5.55, 95.28],
  [56.05, -2.75],
  [22.29, 114.16],
  [43.88, -64.34],
  [49.28, -0.25],
  [55.4, -0.27],
  [53.45, -3],
  [37.7, 24.07],
  [53.33, 7.24],
  [47.22, -1.55],
  [35.34, 25.14],
  [-2.97, 107.19],
  [53.55, 8.58],
  [52.47, 4.67],
  [6.1, 125.17],
  [49.2, -123.91],
  [47.97, -63.05],
  [51.44, 3.59],
  [10.32, 123.92],
  [45.43, 12.37],
  [5.83, -55.17],
  [40.75, 13.9],
  [37.94, 23.64],
  [55.47, 8.43],
  [48.57, 44.15],
  [50.65, -5.7],
  [29.94, -90.33],
  [3.53, 6.78],
  [40.15, 26.4],
  [14.63, 120.23],
  [19.77, 109.15],
  [43.31, -3.03],
  [6.25, 2.52],
  [-32.22, -51.93],
  [-34.74, -57.85],
  [37.7, 24.07],
  [53.88, 9.13],
  [41.15, 29.05],
  [53.6, 0.02],
  [48.95, -57.93],
  [51.4, -57.13],
  [-34.98, 116.12],
  [14.83, 42.94],
  [53.58, 0.04],
  [63.32, 9.85],
  [36.84, 30.6],
  [54.8, 9.44],
  [37.47, 25.33],
  [42.24, -8.73],
  [37.94, 23.64],
  [21.83, 91.58],
  [48.34, -69.34],
  [49.15, -123.85],
  [53.55, 9.98],
  [68.68, 15.42],
  [50.33, -0.84],
  [60.85, 5.07],
  [39.35, 22.95],
  [37.75, 23.43],
  [60.16, 24.94],
  [10.33, -75.53],
  [50.9, -1.41],
  [57.59, 9.97],
  [25.23, 56.52],
  [49.31, -123.1],
  [-5.53, 138.13],
  [53.02, 158.63],
  [8.15, 123.85],
  [40.15, 26.4],
  [51.9, 4.48],
  [53.1, 8.76],
  [54.13, 8.86],
  [73.27, 46.58],
  [69.65, 18.96],
  [-43.61, 172.73],
  [35.2, 24.9],
  [38.38, 26.15],
  [41.28, 29.05],
  [36.75, 26.74],
  [38.16, 138.76],
  [53.88, 10.69],
  [40.75, 29.75],
  [48.9, 12.66],
  [52.6, 155.85],
  [36.95, 26.98],
  [53.9, 11.46],
  [36.42, 19.8],
  [-20.32, 118.58],
  [54.48, 13.58],
  [35.48, 135.37],
  [16.98, 132.28],
  [51.99, 3.7],
  [48.71, -123.24],
  [51.8, 4.65],
  [10, 123.5],
  [72.51, 25.3],
  [53.9, 9.13],
  [37.47, 25.33],
  [40.83, 135.92],
  [34.24, 133.35],
  [53.9, 9.13],
  [22.34, 114],
  [-51.15, -80.78],
  [37.97, 23.57],
  [54.32, 10.13],
  [44.74, 37.79],
  [50.71, -1.06],
  [29.87, 32.47],
  [47.11, 39.47],
  [28.94, -95.33],
  [50.35, -3.58],
  [40.78, 29.61],
  [51.6, 2.25],
  [37.97, 23.4],
  [46.63, 32.61],
  [50.22, -3.2],
  [58.78, 149.42],
  [55.35, -131.66],
  [50.9, -1.41],
  [40.42, 29.11],
  [62.37, 6.33],
  [51.9, 1.66],
  [46.43, -72.27],
  [38.25, 21.74],
  [10.53, 108.95],
  [5.87, 13.02],
  [29.3, -94.78],
  [53.45, -3],
  [5.08, 104.23],
  [33.12, 32.17],
  [59.77, 30.8],
  [42.5, 27.47],
  [44.11, 9.83],
  [4.22, 7.95],
  [50.78, -1.3],
  [52.98, 1.54],
  [-5.87, 106.08],
  [36.58, 27.83],
  [42.43, 18.71],
  [-23.93, -46.33],
  [67.52, 12.1],
  [40.78, 29.61],
  [38.22, 15.25],
  [57.5, -1.78],
  [53.9, -5.52],
  [-38.1, 144.88],
  [29.8, -93.33],
  [37, 126.79],
  [35.44, 139.66],
  [10.38, -61.53],
  [59.95, 4.67],
  [37.73, 24.23],
  [14.58, 120.97],
  [28.44, -15.15],
  [43.28, -79.79],
  [20.87, 106.67],
  [37.93, 23.63],
  [5.32, 6.47],
  [55.6, 12.48],
  [47.19, 39.69],
  [43.73, 135.26],
  [-20.16, 57.5],
  [48.83, -123.35],
  [34.65, 33.01],
  [44.5, -75.77],
  [64.47, 40.6],
  [49.19, -123.96],
  [9.41, -13.73],
  [-20.15, 57.48],
  [-20.68, 116.69],
  [62.65, 7.51],
  [-0.23, 117.58],
  [37.75, 23.43],
  [45.51, -73.55],
  [26.58, 52],
  [37.47, 25.33],
  [45.31, -73.93],
  [57.23, -5.66],
  [-7.15, 112.65],
  [22.23, 91.75],
  [39.83, 19.43],
  [46.51, -84.62],
  [53.55, 9.84],
  [-1.97, -55.74],
  [59.05, 9.72],
  [49.29, -123.07],
  [50.9, -1.43],
  [-37.83, 144.92],
  [37.96, 23.54],
  [38.16, 142.11],
  [36.5, 23.05],
  [52, 3.75],
  [45.39, 36.69],
  [49.03, -68.13],
  [44.82, 34.28],
  [25.07, 121.52],
  [49.65, -1.61],
  [38.3, 21.8],
  [3.28, 117.6],
  [39.17, 23.48],
  [38.57, 14.57],
  [-3.67, 128.79],
  [40.41, 29.09],
  [53.88, 9.2],
  [54.83, -5.12],
  [43.2, 27.92],
  [27.83, -96.99],
  [1.1, 103.73],
  [53.88, 9.13],
  [35.87, 14.5],
  [34.83, 126.1],
  [51.42, 4.02],
  [51.3, 4.3],
  [61.44, -120.36],
  [40.96, 28.89],
  [54.2, -130.37],
  [48.13, -69.43],
  [40.95, 28.77],
  [53.63, 6.17],
  [43.5, 16.45],
  [20.62, -87.07],
  [5.88, 95.32],
  [40.97, 28.68],
  [36.02, 32.82],
  [52.47, 4.67],
  [37.94, 23.64],
  [62.88, 8.49],
  [68.23, 14.57],
  [-7.77, 109.07],
  [14.78, 42.95],
  [76.88, 70.18],
  [63.68, 9.67],
  [54.93, 11.66],
  [22.19, 91.71],
  [48.31, -69.37],
  [59.25, 11.02],
  [39.5, 20.23],
  [36.77, 3.22],
  [6.33, 3.37],
  [35.34, 25.15],
  [49.23, -68.12],
  [36.12, -5.42],
  [37.95, -8.86],
  [13.3, 123.43],
  [54.91, -59.77],
  [18.55, -72.35],
  [43.1, 131.89],
  [51.94, 3.71],
  [58.97, 5.73],
  [49.89, -3.24],
  [54.32, 10.13],
  [60.08, 5.97],
  [16.13, 61.28],
  [49.58, -5.87],
  [29.92, -90.09],
  [41.92, 8.74],
  [57.72, 10.6],
  [46.27, -72.62],
  [48.13, -69.73],
  [57.69, -2],
  [34.83, 126.1],
  [33.83, 132.77],
  [-20.92, 55.3],
  [45.83, 47.97],
  [68.97, 33.08],
  [55.67, 12.63],
  [42.44, -80.02],
  [40.85, 29.17],
  [-40.77, 145.3],
  [23.13, -82.35],
  [41.99, 9.62],
  [55.27, -5.45],
  [30.28, -91.18],
  [45.3, 36.58],
  [46.67, 141.73],
  [49.01, -123.16],
  [47.25, -122.42],
  [44.83, -80.2],
  [53.55, 9.98],
  [14.58, 120.97],
  [69, 2],
  [59.45, 24.76],
  [43.4, 15.94],
  [45.38, -8.25],
  [40.15, 26.4],
  [53.58, 9.62],
  [-33.71, -59.45],
  [49.25, -124.81],
  [51.35, 2.72],
  [53.31, 7.28],
  [42.1, 141.68],
  [10.32, 123.92],
  [54.04, 9.31],
  [53.33, 7.17],
  [-38.35, 141.62],
  [25.23, 56.52],
  [-29.87, 31.03],
  [50.02, -125.22],
  [57.15, -2.07],
  [68.7, 15.43],
  [-17.53, -149.58],
  [53.53, 49.4],
  [63.93, 38.01],
  [53.9, 9.13],
  [59.41, 5.27],
  [29.97, 32.55],
  [40.64, 17.95],
  [46.4, -72.38],
  [61.6, 5.02],
  [50.05, -3.2],
  [45.42, 28.08],
  [22.6, 120.25],
  [-12.95, -38.5],
  [17.05, 82.4],
  [37.95, 21.15],
  [54.3, 48.35],
  [27.72, 121.2],
  [63.44, 10.4],
  [40.15, 26.4],
  [50.53, -0.12],
  [10.28, -64.71],
  [35.15, 14.42],
  [-23.93, -46.3],
  [57.72, 19.27],
  [60.34, -1.11],
  [29.9, 121.56],
  [44.42, 8.92],
  [53.92, 3.63],
  [54.33, -130.33],
  [52.47, 4.63],
  [34.98, 24.67],
  [43.1, 131.92],
  [51.43, 3.48],
  [50.8, -1.1],
  [25.52, -6.28],
  [37.94, 23.64],
  [44.63, -75.58],
  [1.27, 103.83],
  [41.27, 29.05],
  [46.42, -53.7],
  [55.27, 9.9],
  [51.43, 1.95],
  [45.43, 148.98],
  [21.02, 107.35],
  [51.9, 4.48],
  [61.87, 6.08],
  [47.55, -52.7],
  [53.88, 9.13],
  [68.43, 17.43],
  [4.65, 4],
  [46.36, 48.04],
  [30, 122.1],
  [38.44, 27.16],
  [-35.03, 117.9],
  [0.54, 117.64],
  [51.23, 2.92],
  [70.02, 20.83],
  [33.41, -91.07],
  [43.76, -65.32],
  [22.28, 91.73],
  [12.58, 122.27],
  [37.95, 23.62],
  [-40.07, 144.15],
  [10.53, 108.95],
  [61.92, 5.12],
  [48.18, -69.47],
  [40.4, -73.98],
  [-51.99, -57.99],
  [47.63, -52.92],
  [-34.57, -58.35],
  [51.33, 1.97],
  [57.44, 10.54],
  [51.48, 156.49],
  [46.73, -71.28],
  [1.21, 103.92],
  [57.03, 16.47],
  [37.47, 25.33],
  [29.74, -95.2],
  [25.23, 56.52],
  [44.35, 9.23],
  [5.8, 118.07],
  [-26.23, -48.63],
  [22.41, 113.77],
  [18.44, -93.19],
  [1.67, 103.6],
  [54.37, 0.08],
  [29.72, -81.08],
  [28.67, -96],
  [37.95, 23.62],
  [50.6, -127.08],
  [45.58, 13.7],
  [1.08, 103.58],
  [54.32, 10.13],
  [-33.96, 25.63],
  [40, 35.13],
  [53.87, 8.72],
  [36.7, 14.83],
  [4.03, 7.05],
  [62.37, 6.03],
  [48.57, 44.15],
  [58.2, -6.38],
  [-20.16, 57.5],
  [-2.95, 107.22],
  [40.98, 28.94],
  [45.22, -74.08],
  [50.18, -0.56],
  [-13.12, -38.55],
  [3.95, 6.72],
  [29.97, 32.55],
  [14.58, 120.97],
  [56.69, -6.09],
  [45.59, -73.51],
  [17.57, 120.38],
  [47.19, 39.69],
  [53.9, 9.13],
  [51.45, 1.98],
  [40.74, 13.94],
  [53.89, 9.15],
  [13.73, 121.02],
  [-33.88, 18.35],
  [53.31, 7.28],
  [54.72, 20.52],
  [67.56, -64.07],
  [10.41, 107.14],
  [-4.71, 135.94],
  [69.72, -91.35],
  [39.42, 26.24],
  [49.3, -123.1],
  [21.25, 88.53],
  [33.65, 130.35],
  [60.8, -48.23],
  [21.31, -157.86],
  [21.93, 91.38],
  [22.97, -43.21],
  [1.27, 103.83],
  [50.19, -66.37],
  [1.05, 103.65],
  [52.14, 3.64],
  [49.04, -5.4],
  [-41.47, -72.95],
  [41.28, 29.04],
  [-20.15, 57.48],
  [59.83, 26],
  [52.4, -6.95],
  [52.97, 4.78],
  [60.12, 20.3],
  [40.95, 28.89],
  [13.13, 123.73],
  [1.17, 103.45],
  [66.59, 13.36],
  [-29.87, 31.03],
  [62.48, 6.15],
  [55.47, 8.43],
  [37.55, 25.37],
  [6.82, -58.18],
  [63.12, 7.63],
  [1.68, 101.45],
  [37.86, 24.98],
  [55.75, 12.75],
  [47.61, -122.35],
  [54.32, 10.13],
  [49.24, -124.82],
  [36.8, 34.64],
  [49.18, -123.32],
  [62.48, 6.15],
  [33.95, 130.95],
  [53.9, 9.13],
  [4.17, 73.5],
  [-2.52, -80.09],
  [50.18, -4.68],
  [37.97, 23.57],
  [41, 28.96],
  [52.1, 4.27],
  [65.47, 12.21],
  [49.17, -122.92],
  [4, 9.13],
  [35.52, 23.64],
  [39.32, 26.72],
  [4.07, 6.93],
  [36.44, 28.23],
  [42.99, -82.42],
  [37.09, 25.15],
  [40.85, 25.95],
  [18.87, -86.68],
  [50.77, 0.78],
  [37.83, 120.03],
  [34.96, 136.64],
  [-20.68, 116.69],
  [46.5, -1.8],
  [41.03, 37.38],
  [68.97, 33.08],
  [13.08, 100.88],
  [10.63, 103.5],
  [58.14, 24.02],
  [7.56, 99.61],
  [40.78, 29.61],
  [13.08, 80.28],
  [70.98, 25.98],
  [51.28, 2.02],
  [50.79, -1.07],
  [53.55, 9.98],
  [-12.06, -77.14],
  [3.8, 6.65],
  [58, -178],
  [40.96, 28.89],
  [50.18, -2.68],
  [51.82, -14.85],
  [44.03, -64.7],
  [49.02, -123.15],
  [48.43, -123.2],
  [43.05, -79.22],
  [8.5, 117.42],
  [10, 75.89],
  [4.18, 73.43],
  [50.61, -1.95],
  [42.45, 11.12],
  [53.55, 8.58],
  [43.22, -79.21],
  [47.56, -52.71],
  [39.62, 19.95],
  [37.94, 23.64],
  [41.16, 29.05],
  [39.9, 26.13],
  [47.52, 40.8],
  [55.8, -4.87],
  [47.84, -52.88],
  [56.57, 4.75],
  [40.64, 22.92],
  [53.53, 8.53],
  [39.1, 117.17],
  [10.92, 124.42],
  [54.32, 10.13],
  [37.08, 25.32],
  [37.82, 126.47],
  [32.14, 19.97],
  [39.15, 23.83],
  [60.4, 5.02],
  [36.13, -5.44],
  [4.1, 6.97],
  [48.83, -67.57],
  [68.9, 15.08],
  [13.83, 121],
  [49.13, -20.47],
  [-20.32, 118.58],
  [9.78, 125.5],
  [56.06, -57.58],
  [50.08, 0.53],
  [35.89, -5.32],
  [54.37, 10.1],
  [21.47, 39.17],
  [50.33, 0.88],
  [26, 52],
  [55, -1.43],
  [48.98, -123.18],
  [53.55, 8.58],
  [6.29, 2.49],
  [35, 18],
  [60.2, 5.53],
  [55.71, 21.14],
  [47.55, -122.53],
  [53.55, 9.98],
  [59.45, 24.76],
  [-0.42, 117.15],
  [68.97, 15.63],
  [41.11, 37.34],
  [57.59, 9.97],
  [49.22, -68.15],
  [-2.58, -44.36],
  [59.4, 10.48],
  [38.98, 20.99],
  [40.92, 9.5],
  [62.01, -6.77],
  [-37.83, 144.92],
  [43.64, -79.37],
  [10.98, 106.98],
  [53.71, 0.81],
  [13.68, 100.5],
  [56.33, 44],
  [-5.7, 106.58],
  [58.92, 6.07],
  [-35.35, 173.53],
  [-4.72, -32.8],
  [40.9, 28.47],
  [32.88, 35.01],
  [35.89, -5.32],
  [46.25, -72.7],
  [40.78, 29.61],
  [40.77, 29.58],
  [0.98, 104.04],
  [40.92, 9.5],
  [34.47, 35.83],
  [8.58, -60.78],
  [22.27, -97.78],
  [38.76, 26.92],
  [31.21, 32.36],
  [40.96, 28.89],
  [44.99, -74.78],
  [37.8, -122.28],
  [40.68, 122.23],
  [38.88, 118.64],
  [46.4, -72.37],
  [48.12, -69.67],
  [51.5, -0.06],
  [3.95, 117.58],
  [49.28, -123.15],
  [48.9, -5.23],
  [51.26, 4.39],
  [34.48, -8.3],
  [37.55, 23.69],
  [-20.32, 118.58],
  [6.14, 1.29],
  [57.1, -5.75],
  [38.43, 27.15],
  [41.25, 29.17],
  [69.08, 15.95],
  [48.47, -68.52],
  [-3.69, 114.42],
  [33.75, -118.28],
  [37.97, 23.57],
  [60.16, -1.14],
  [49.28, -123.17],
  [-22.92, -43.2],
  [44.74, 37.79],
  [41.28, 29.74],
  [59.87, 30.23],
  [37.94, 23.64],
  [31.68, 121.13],
  [24.56, -81.8],
  [55.43, -5.6],
  [9.33, 108.87],
  [49.95, -2.98],
  [36, 134.42],
  [65, 6.93],
  [62.73, 7.17],
  [-46.42, -66.75],
  [54.23, -130.34],
  [56.72, -7.61],
  [37.5, 23.47],
  [29.57, -126.47],
  [54.32, -130.27],
  [54.37, 10.15],
  [50.58, -0.85],
  [70.25, 58],
  [40.02, 26.3],
  [52.64, 6.08],
  [3.88, -77.05],
  [44.3, 8.48],
  [62.73, 7.17],
  [50.6, -52.97],
  [49.19, -123.89],
  [54.88, 9.13],
  [52.24, -5.72],
  [37.67, -27.57],
  [42.93, 10.55],
  [66.2, -15.33],
  [50.55, -0.19],
  [56.33, -7.12],
  [52.54, 8.57],
  [26.08, -80.11],
  [48.39, -4.47],
  [47.09, 39.24],
  [41.16, 29.05],
  [36.88, 27.32],
  [41.15, 29.07],
  [51.9, -8.47],
  [46.5, -84.4],
  [49.9, -1.67],
  [26.73, 33.97],
  [43.58, 7.13],
  [-37.81, 144.96],
  [1.21, 104.03],
  [23.95, 38.22],
  [48.33, -4.52],
  [1.23, 103.67],
  [-33.93, -58.85],
  [51.9, 4.48],
  [50.02, -1.45],
  [61.05, -116.55],
  [36.52, 22.47],
  [-8.16, 114.44],
  [40.85, 14.28],
  [13.77, 109.23],
  [41.35, 2.17],
  [46.24, -123.43],
  [53.88, 9.06],
  [60.43, 4.9],
  [-7.18, 112.68],
  [4.03, 5.73],
  [54.7, -1.19],
  [13.75, 121.05],
  [53.58, 0.02],
  [41.57, -70.77],
  [25.84, 51.73],
  [34.76, 139.9],
  [50.93, -15.14],
  [32.65, 135.97],
  [48.53, -124.98],
  [59.3, 5.22],
  [40.41, 29.08],
  [59.82, 5.27],
  [56.7, 8.22],
  [22.64, 120.24],
  [51.45, 0.36],
  [45.36, 36.62],
  [43.18, -79.2],
  [37, 126.79],
  [33.95, 130.95],
  [40.02, 26.28],
  [40.72, 29.47],
  [40.78, 29.61],
  [51.07, 1.4],
  [49.28, -123.07],
  [53.99, -128.68],
  [25.23, 56.52],
  [39.83, 26.07],
  [52.97, 4.78],
  [53.55, 9.98],
  [41, 28.96],
  [50.72, -1.98],
  [51.35, 2.72],
  [37.82, 120.72],
  [51.61, 3.54],
  [-15.88, -145.9],
  [62.73, 7.17],
  [25.2, -42.98],
  [40.97, 28.95],
  [41.08, 29.04],
  [22.58, 88.35],
  [-1.74, 107.45],
  [43.1, 131.89],
  [45.34, 36.67],
  [47.17, 39.58],
  [43.1, 131.89],
  [53.38, 10.55],
  [8.81, -79.53],
  [-34.28, 17.88],
  [51.88, 4.27],
  [44.84, -87.38],
  [54.33, 9.73],
  [42.89, -79.25],
  [-2.98, 104.77],
  [52.97, 4.78],
  [34.62, 34.93],
  [6.33, 3.3],
  [47.63, -122.33],
  [40.97, 28.68],
  [60.75, 4.73],
  [53.92, 14.25],
  [25.14, 121.75],
  [-8.61, 122.22],
  [39.1, 117.17],
  [-20.15, 57.48],
  [52.13, -10.27],
  [53.62, -129.72],
  [50.6, -2.39],
  [49.83, -2.87],
  [53.55, 9.83],
  [49.8, -124.62],
  [49.13, -4.68],
  [58.02, 14.47],
  [53.33, 8.48],
  [46.4, -72.38],
  [53.9, 9.13],
  [47.12, 39.41],
  [-60.83, -61.41],
  [46.35, -72.51],
  [35.83, 10.65],
  [53.9, 9.13],
  [57, -77.77],
  [4.02, 6.8],
  [37.75, 23.43],
  [40.96, 28.89],
  [57.22, 11.37],
  [50.33, -1.63],
  [41.03, 37.38],
  [-2.53, -44.35],
  [39.2, 20.18],
  [49.27, -54.84],
  [51.58, 155.92],
  [45.55, -73.5],
  [35.45, 129.42],
  [52.06, -132.2],
  [40.6, 27.67],
  [69.23, 17.97],
  [49.04, -123.11],
  [52.07, 1.76],
  [69.58, 43.42],
  [60.82, 5.03],
  [54.34, -130.32],
  [49.77, 0.17],
  [-17.68, 178.85],
  [38.8, 22.82],
  [51.58, -3.9],
  [1.68, 101.45],
  [63.1, 7.87],
  [50.9, -1.41],
  [-5.76, 134.24],
  [31.25, 32.3],
  [35.52, 23.66],
  [48.27, -69.4],
  [51.88, 4.4],
  [60.76, -0.21],
  [25.42, 55.45],
  [47.18, -124.33],
  [37.27, -6.92],
  [-4.07, 39.68],
  [37.75, 23.43],
  [45.6, -61.37],
  [1.27, 104.14],
  [10.65, -61.52],
  [48.53, 13.69],
  [-0.24, 117.58],
  [53.9, 9.14],
  [40.97, 28.92],
  [51.32, 155.17],
  [33.27, 131.51],
  [-1.79, 109.96],
  [1.42, 104.58],
  [-4.33, 120.25],
  [49.3, -123.11],
  [60.41, 5.02],
  [-37.83, 144.92],
  [41.3, 36.34],
  [10.38, 107.12],
  [53.23, 6.53],
  [18.63, 60.51],
  [43.73, -7.85],
  [52.07, 47.77],
  [4.88, -1.69],
  [38.25, 21.74],
  [68.97, 33.08],
  [64.86, 11.24],
  [-38.71, 146.39],
  [40.41, 29.09],
  [54.05, 13.78],
  [60.13, -45.25],
  [7.18, 125.67],
  [22.78, 70.07],
  [50.5, 1.02],
  [36.8, 34.64],
  [44.45, 12.23],
  [48.72, -123.12],
  [49.66, -1.84],
  [10.15, 125.67],
  [54.32, 10.14],
  [43.35, -124.2],
  [55.75, 12.7],
  [-73.82, 173.47],
  [64.1, -58.79],
  [48.85, -67.55],
  [59.34, 22.6],
  [46.73, 38.28],
  [60.28, 28.73],
  [20.72, 107.15],
  [-3.68, 114.47],
  [9.25, -13.72],
  [44.63, 33.57],
  [54.33, -130.34],
  [10.19, -64.77],
  [36.72, 14.83],
  [37.58, -0.96],
  [30.19, 32.57],
  [64.03, 9.83],
  [9.42, -79.92],
  [35.58, 140.13],
  [45.3, 36.58],
  [53.55, 9.98],
  [17.94, 106.53],
  [27.8, -97.4],
  [49.88, -3.73],
  [57.5, -1.78],
  [48.63, -62.53],
  [37.95, 23.53],
  [29.92, -90.09],
  [3.76, 6.72],
  [36.8, 34.64],
  [52.6, -9.4],
  [41.16, 29.05],
  [35.97, -74.07],
  [38.02, 24],
  [50.62, 0.58],
  [33.77, 78.17],
  [61.47, -6.8],
  [22.85, 127.3],
  [-8.06, 159.51],
  [22.59, 120.31],
  [60.16, 24.94],
  [22.7, 70.07],
  [54.65, 8.35],
  [36.8, 34.64],
  [40.15, 26.4],
  [62.15, -74.7],
  [56.04, 12.61],
  [41.27, 29.32],
  [47.56, -52.71],
  [61.23, 7.1],
  [1.2, 104.02],
  [22.92, 120.17],
  [6.12, 81.1],
  [13.47, 50.23],
  [46.36, 48.04],
  [53.9, 9.13],
  [-8.13, 114.45],
  [49.17, -59.36],
  [37.22, 15.64],
  [-33.44, -60.05],
  [40.88, 29.19],
  [1.15, 103.52],
  [48.8, -71.22],
  [21.88, 91.76],
  [30.82, 32.32],
  [37.97, 23.5],
  [40.78, 29.61],
  [44.74, 37.79],
  [-33.63, -59.71],
  [60.1, 5.33],
  [47.92, -69.72],
  [-44.38, 171.25],
  [36, -5.6],
  [13.75, 121.05],
  [44.42, 8.92],
  [53.07, -128.55],
  [63.43, -20.27],
  [10.32, 75.52],
  [39.75, 140.07],
  [40.65, 27.47],
  [52.12, 3.68],
  [19.21, -96.14],
  [45.97, -73.21],
  [62.68, 7.1],
  [49.74, -6.33],
  [22.48, -97.88],
  [26.65, 119.52],
  [30.37, 32.28],
  [-13.55, -153.63],
  [-26.65, 15.15],
  [-26.23, -48.63],
  [1.27, 103.83],
  [39.56, -75.52],
  [52.47, 4.05],
  [58.93, -3.35],
  [50.42, -0.62],
  [-41.18, 146.35],
  [36.23, 33.98],
  [37.44, 24.94],
  [-8.17, 114.43],
  [22.78, 70.07],
  [3.8, 98.72],
  [-33.5, -60.01],
  [51.61, 3.54],
  [47.8, -86.92],
  [10.4, -75.52],
  [51.45, 3.58],
  [59.87, 30.23],
  [54.22, -132.98],
  [46.05, -73.07],
  [23.1, 113.23],
  [0.06, -50.98],
  [49.6, -4.17],
  [20.93, 107.3],
  [50.76, -1.53],
  [58.38, 24.48],
  [68.15, 12.93],
  [49.28, -123.1],
  [12.81, 74.83],
  [69.67, 18.75],
  [37.94, 23.64],
  [6.3, 3.33],
  [53.89, 9.15],
  [58.22, 22.52],
  [38.38, 26.16],
  [57.7, 11.92],
  [47.19, 39.69],
  [-20.16, 57.5],
  [40.84, 29.29],
  [50.79, 155.98],
  [52.12, 3.67],
  [66.02, 12.63],
  [60.78, 4.71],
  [39.22, 1.6],
  [44.82, -75.3],
  [-69.98, -94.89],
  [54.33, -130.28],
  [37.54, 25.16],
  [61.23, 4.97],
  [49.15, -123.04],
  [47.12, 39.41],
  [40.84, 29.29],
  [61.87, 6.07],
  [41.72, -87.45],
  [57.17, 11.73],
  [49.77, -65.33],
  [42.8, 132.88],
  [62.35, 5.82],
  [52.8, -97.62],
  [49.75, -3.69],
  [38.25, 21.74],
  [42.88, -79.23],
  [69.28, 15.07],
  [21.18, 110.4],
  [48.01, -4.93],
  [53.53, 8.57],
  [50.78, 0.06],
  [15.12, 108.8],
  [37.95, 21.15],
  [-35.03, 117.9],
  [31.25, 32.3],
  [36.57, 27.49],
  [-6.11, 106.89],
  [41, 28.96],
  [2.23, 109.08],
  [24.56, -81.8],
  [60.08, -41.95],
  [-6.3, 148.48],
  [53.31, -4.63],
  [48.57, 44.15],
  [54.02, -131.26],
  [51.4, 4.21],
  [-23.84, 151.27],
  [1.43, 125.18],
  [48.12, -122.75],
  [43.82, 149.04],
  [54.32, 10.13],
  [49.05, 8.33],
  [48.52, -122.62],
  [-4.07, 39.68],
  [31.21, 32.34],
  [25.23, 56.52],
  [59.68, -3.76],
  [33.52, 126.55],
  [43.4, 3.7],
  [55.36, 50],
  [48.28, -69.17],
  [62.63, 6.68],
  [28.55, 123.37],
  [39.17, 23.48],
  [23.03, 70.22],
  [49.04, 152.39],
  [1.42, 103.83],
  [9.36, -79.9],
  [25.78, -80.19],
  [34.28, 133.54],
  [68.42, 16],
  [1.07, 103.68],
  [58.27, -78.4],
  [36.23, 33.98],
  [54.62, -0.72],
  [-27.41, 153.16],
  [14.53, 49.13],
  [52.3, 3.54],
  [47.2, -58.6],
  [48.47, -68.52],
  [62.73, 7.17],
  [54.32, -130.98],
  [21.87, 91.8],
  [42.98, 47.5],
  [41.02, 29.98],
  [-32.58, 31.33],
  [45.52, -73.55],
  [22.59, 120.31],
  [41.35, 29.15],
  [48.38, -123.4],
  [62.8, 34.8],
  [46.03, 140.22],
  [49.38, -4.22],
  [51.45, 3.57],
  [28.15, -15.43],
  [1.11, 104.19],
  [56.41, 10.91],
  [50.27, -1.72],
  [37.44, 24.94],
  [56.95, 24.08],
  [53.7, -0.87],
  [-0.5, 117.15],
  [37.3, 26.58],
  [54.47, 9.04],
  [50.53, 0.22],
  [45.55, 13.74],
  [47.19, 39.69],
  [52.8, -128.42],
  [24.99, 55.06],
  [51.4, 3.57],
  [51.26, 1.78],
  [-67.6, 62.85],
  [48.94, -125.54],
  [45.22, 28.72],
  [47.07, 39.09],
  [52.14, 3.75],
  [57.76, 21.73],
  [25.23, 56.52],
  [45.23, -55.17],
  [49.18, -122.92],
  [36.84, 30.6],
  [50.03, -5.4],
  [-4.78, 11.83],
  [58.97, 5.73],
  [-24.15, -46.3],
  [41.15, 29.05],
  [48.02, -4.53],
  [22.22, 91.73],
  [53.07, 7.4],
  [33.1, 129.7],
  [50.44, 0.54],
  [54.45, -132.88],
  [56.57, 9.05],
  [48.5, -124.67],
  [40.88, 29.21],
  [50.02, -4.37],
  [53.88, 9.13],
  [47.25, -51.75],
  [54.63, 10.73],
  [34.81, 137.21],
  [41.36, 2.18],
  [-8.75, 116.06],
  [35.1, -75.97],
  [35.89, 14.51],
  [48.48, -129.83],
  [40.83, 29.23],
  [21.18, 110.4],
  [21.93, 91.38],
  [10.32, 123.92],
  [-4.17, 114.62],
  [52.1, 4.26],
  [6.82, -58.17],
  [22.18, 88.15],
  [26.05, -97.2],
  [-33.45, -60.04],
  [35.58, 140.13],
  [-27.41, 153.16],
  [60.05, 6.02],
  [56.42, 43.73],
  [41.06, 1.3],
  [29.31, -93.24],
  [65.75, 12.53],
  [47.12, 39.41],
  [60.05, 28.32],
  [55.1, 14.7],
  [28.33, -90.72],
  [41.27, 29.05],
  [41.67, 139.07],
  [39.58, 19.87],
  [45.34, 36.67],
  [48.38, -4.47],
  [41, 28.96],
  [49.07, -63.9],
  [41.98, 33.73],
  [34.49, 133.73],
  [40.03, 26.07],
  [30.47, -91.18],
  [45.93, -83.1],
  [42.59, -80],
  [14.55, 120.92],
  [41, 29],
  [36.84, 30.61],
  [34.6, 138.23],
  [1.69, 118.01],
  [25.23, 56.52],
  [10.7, 122.57],
  [58.97, -3.3],
  [60.8, -161.77],
  [43.76, -65.32],
  [59.92, 30.4],
  [60.05, -1.47],
  [25.84, 51.73],
  [41.28, 28.98],
  [47.18, -124.33],
  [38.03, 23.5],
  [40.56, 27.07],
  [32.08, -81.09],
  [59.72, 19.07],
  [44.02, -63.45],
  [59.74, 10.23],
  [49.78, 5.92],
  [54.72, 20.52],
  [48.12, -123.43],
  [53.57, 8.55],
  [53.17, 5.41],
  [37.02, 27.43],
  [4.27, 7.03],
  [53.55, 8.58],
  [37.94, 23.64],
  [54.47, 12.18],
  [51.5, -2.78],
  [50.15, -5.06],
  [43.55, 10.32],
  [54.31, 9.7],
  [40.85, 28.96],
  [44.74, 37.79],
  [54.37, 10.13],
  [42.8, 132.88],
  [53.18, 5.42],
  [-4.07, 39.68],
  [37, 22.08],
  [51.28, 1.6],
  [37.94, 23.64],
  [-7.27, 112.74],
  [68.65, -107.7],
  [3.92, 98.77],
  [40.1, 26.38],
  [51.41, 3.6],
  [53.48, -131.13],
  [49.15, -122.95],
  [-7.02, 113.87],
  [47.12, 39.41],
  [25.25, 56.6],
  [37.94, 23.64],
  [43.85, -82.35],
  [17.7, 83.3],
  [22.64, 120.25],
  [33.87, 130.82],
  [13.1, -59.62],
  [50.92, -129.1],
  [45.43, 12.33],
  [-23.82, 151.5],
  [41.63, -83.53],
  [51.42, 3.64],
  [36.52, -6.29],
  [10, -84.97],
  [48.65, -123.43],
  [37.94, 23.64],
  [50.55, -58.07],
  [41.29, 29],
  [9.12, -109.75],
  [31.68, 121.13],
  [35.34, 25.15],
  [-54.93, -67.62],
  [13.75, 121.05],
  [43.69, 7.29],
  [50.49, -0.07],
  [59.65, 4.92],
  [3.35, 117.57],
  [51.09, 1.57],
  [59.41, 10.61],
  [38.13, 13.36],
  [45.34, 36.67],
  [1.13, 103.63],
  [-23.93, -46.33],
  [50.12, -5.54],
  [-4.09, 114.68],
  [62.37, 6.03],
  [3.78, 6.82],
  [37.18, 23.92],
  [10.32, 123.95],
  [22.02, 88.08],
  [49.28, -123.08],
  [9.25, -79.9],
  [41.9, -82.87],
  [41, 28.97],
  [44.31, 9.23],
  [46.3, 47.97],
  [37.78, 20.9],
  [10.32, 123.92],
  [51.25, 1.7],
  [-33.57, 17.9],
  [15.2, 145.72],
  [-5.58, 120.45],
  [34.88, 128.72],
  [-39.07, 174.08],
  [53.9, 9.13],
  [38.05, 24.32],
  [62.37, 6.33],
  [43.48, -2.89],
  [48.69, -123.41],
  [-45.88, 170.52],
  [43.1, 131.89],
  [38.25, 21.74],
  [34.17, 133.33],
  [41.04, 29.01],
  [33, 125],
  [45.83, 47.97],
  [-4, 119.62],
  [-34.59, -58.38],
  [53.45, -3],
  [60.37, 5.16],
  [50.32, -0.95],
  [35.37, 24.48],
  [55.78, -9.41],
  [54.33, -130.33],
  [1.23, 103.65],
  [-20.17, 118.55],
  [44.85, -75.23],
  [55.06, 10.62],
  [61.17, 0.15],
  [31.99, 122.99],
  [46.36, 48.04],
  [40.78, 29.61],
  [-33.62, -59.7],
  [37.94, 23.64],
  [31.25, 32.3],
  [53.22, -128.81],
  [68.97, 33.08],
  [58.38, 12.33],
  [61.87, 6.07],
  [17.2, 120.45],
  [53.86, 8.71],
  [54.15, -4.47],
  [56.98, -5.3],
  [51.42, -3.13],
  [46.67, -71.85],
  [60.17, 18.48],
  [19.98, 72.77],
  [36.52, -6.29],
  [58.87, 9.42],
  [37.94, 23.64],
  [37.97, 23.57],
  [38.91, 1.44],
  [39.21, 9.09],
  [36.67, 36.18],
  [67.07, 13.79],
  [43.78, 33.72],
  [51.07, 1.81],
  [15.84, -87.95],
  [54.37, 10.15],
  [58.14, 8],
  [50.6, -2.37],
  [8.62, 123.7],
  [51.8, -128.28],
  [51.8, 3.34],
  [48.31, -69.38],
  [51.8, 4.65],
  [53.17, 5.41],
  [37.94, 23.64],
  [52.7, 2.7],
  [-37.65, 176.17],
  [51.33, 3.82],
  [41.92, 8.74],
  [-7.73, 109],
  [49.31, -123.19],
  [53.91, 9.17],
  [37.36, 7.07],
  [10.19, 123.94],
  [37.94, 23.64],
  [51.33, 3.82],
  [38.02, 23.54],
  [-22.03, 168.63],
  [44.13, 28.79],
  [54.23, -130.34],
  [57.67, 21.97],
  [41.65, -70.28],
  [49.01, -123.17],
  [30.63, 122.06],
  [-34.59, -58.38],
  [9.75, 10.03],
  [41.29, 29.03],
  [53.9, 9.13],
  [41.18, 29.05],
  [28.9, -89.42],
  [37.94, 23.64],
  [54.57, 11.93],
  [49.87, -3.12],
  [46.85, -71.06],
  [-17.5, -149.83],
  [50.78, 0.77],
  [60.93, 34.03],
  [56.92, 10.55],
  [54.37, 10.12],
  [50.72, -127.48],
  [-33.98, -59.19],
  [55.94, -4.72],
  [51.06, 1.79],
  [45.34, 36.67],
  [17.42, 120.48],
  [-32.95, 17.34],
  [30.33, 32.38],
  [34.47, 134.64],
  [3, 101.4],
  [56.98, -7.47],
  [-25.63, 45.47],
  [51.04, 2.35],
  [36.12, -5.43],
  [45.88, -73.26],
  [36.32, 29.22],
  [-20.7, 152.8],
  [22.82, 70.01],
  [52.46, 4.6],
  [53.53, 9.9],
  [55.76, 15.61],
  [56.15, 10.22],
  [49.21, -63.78],
  [40.15, 26.4],
  [4.42, 7.15],
  [49.67, -124.2],
  [30.65, 19.41],
  [52.93, 1.5],
  [57.77, -3],
  [50.08, -2.1],
  [10.27, -64.57],
  [34.69, 135.2],
  [50.48, -0.91],
  [40, 35.13],
  [55.23, 11.75],
  [70.87, 20.8],
  [40.83, 28.97],
  [49.28, -123.65],
  [52.42, 9.7],
  [49.28, -123.08],
  [40.83, 29.23],
  [22.32, 91.82],
  [54.17, -131.98],
  [43.58, 7.13],
  [74.7, 20.93],
  [36.44, 28.23],
  [76.5, 44.59],
  [49.42, -123.43],
  [60.34, 5.19],
  [56.69, -6.23],
  [37.12, 24.53],
  [-10.55, 142.15],
  [1.12, 103.59],
  [36.56, 28.47],
  [49.3, -123.07],
  [45.55, 13.74],
  [49.97, -125.18],
  [49.3, -123.12],
  [44.72, -92.75],
  [45.43, 12.33],
  [50.25, 152.7],
  [1.7, 101.49],
  [48.7, -125.18],
  [4.25, 5.58],
  [-4.07, 39.68],
  [41, 29.02],
  [5.63, 0.01],
  [56.95, 24.08],
  [38.38, 22.63],
  [37.97, 23.57],
  [40.65, -8.71],
  [-5.5, 105.28],
  [45.27, -66.07],
  [31.98, 119.99],
  [32.78, 12.45],
  [46.73, 38.28],
  [50.64, 0.57],
  [32.39, -64.33],
  [49.56, -54.48],
  [35.44, 139.66],
  [47.12, 39.41],
  [63.73, 9.6],
  [34.96, 136.64],
  [20.72, 107.18],
  [-23.93, -46.3],
  [60.16, -1.16],
  [27.97, -15.6],
  [39.53, 20.22],
  [49.3, -123.09],
  [52.25, 3.52],
  [46.95, -70.82],
  [45.58, -73.5],
  [3.63, 6.7],
  [49.58, -4.78],
  [53.63, 9.51],
  [40.66, 29.25],
  [21.47, 39.17],
  [-34.73, -57.8],
  [66.75, 13.54],
  [40.83, 29.25],
  [53.02, 158.63],
  [9.36, -79.9],
  [64.53, 40.5],
  [29.38, -14.95],
  [22.32, 91.82],
  [54.58, 12.32],
  [60.32, 5.25],
  [-8.48, 116.68],
  [45.07, 47.69],
  [64.53, 40.53],
  [6.32, 3.4],
  [9.5, -13.72],
  [7.17, 125.65],
  [33.27, 131.51],
  [22.29, 114.16],
  [69.1, 33.4],
  [55.5, 9.5],
  [1.27, 103.83],
  [46.3, 47.97],
  [45.36, 36.62],
  [52.97, 4.78],
  [37.07, 126.17],
  [38.02, 24.42],
  [34.69, 135.2],
  [47.95, 42.97],
  [41, 28.96],
  [36.72, 14.83],
  [48.57, -68.9],
  [4.03, 6.57],
  [53.02, 158.63],
  [66.18, 12.98],
  [38.37, 25.02],
  [41.35, 2.17],
  [54.32, 10.13],
  [49.4, -127.4],
  [60.11, 5.18],
  [40.96, 28.94],
  [69.32, 16.13],
  [59.87, 30.23],
  [53.33, 8.48],
  [61.22, 1.83],
  [21.93, 91.38],
  [53.02, 158.63],
  [56.68, 8.22],
  [37.62, 24.33],
  [49.15, -67.07],
  [41.3, 36.34],
  [70.85, 21.08],
  [40.56, 14.24],
  [34.68, 135.17],
  [54.72, 20.52],
  [10.32, 123.92],
  [54.69, -5.77],
  [39.58, 19.87],
  [-20.15, 57.48],
  [48.58, -68.5],
  [50.85, 0.97],
  [21.5, 72.5],
  [10.71, 103.49],
  [42.32, -80.69],
  [52.5, 4.33],
  [3.47, 5.57],
  [37.73, -25.67],
  [41, 28.96],
  [35.36, 25.12],
  [45.28, 37.37],
  [-4.07, 39.68],
  [22.79, 120.22],
  [46.32, 30.67],
  [-8.65, 115.22],
  [68.8, 47.28],
  [69.08, 15.95],
  [54.65, 19.9],
  [43.1, 131.89],
  [39.83, 26.07],
  [45.3, 36.58],
  [54.93, 10.25],
  [46.47, -72.25],
  [3.65, 6.13],
  [63.1, 21.62],
  [1.43, 125.18],
  [22.33, 114.12],
  [16.89, -24.99],
  [46.36, 48.04],
  [2.73, 9.76],
  [36.42, 25.45],
  [36.42, 25.45],
  [38.91, 1.45],
  [55.28, -5.41],
  [52.95, 153.97],
  [-5.88, 106.07],
  [39.35, 22.95],
  [46.67, 141.85],
  [1.13, 103.92],
  [47.12, 39.42],
  [1.7, 101.47],
  [40.87, 29.2],
  [40.9, 29.05],
  [-23.93, -46.33],
  [50.29, -1.09],
  [35.12, 129.04],
  [51.33, -3.63],
  [47.12, 39.41],
  [40.4, 29.07],
  [53.73, 7.42],
  [-20.68, 116.69],
  [-34.48, 24.42],
  [63.12, 7.75],
  [40.41, 29.09],
  [67.32, 14.38],
  [21.69, 72.38],
  [60.85, -115.73],
  [60.43, 22.22],
  [39.53, 20.22],
  [59.65, 23.07],
  [44.69, -75.53],
  [59.92, 5.28],
  [36.98, 26.98],
  [49.95, 1.07],
  [6.44, 3.39],
  [56.44, -58.48],
  [36.13, -5.42],
  [47.62, -70.13],
  [29.97, 32.55],
  [40.76, 29.93],
  [61.13, 21.49],
  [9.65, 123.85],
  [32.82, 35.01],
  [40.89, 29.19],
  [1.05, 103.6],
  [-44.45, -65.7],
  [55.6, 10.84],
  [37.33, -89.05],
  [40.68, 14.74],
  [56.67, -4.1],
  [60.18, -4.07],
  [44.63, -75.63],
  [50.58, -2.22],
  [16.17, 107.83],
  [14.39, 120.85],
  [59.75, 5.47],
  [49.92, -3.17],
  [56.15, 10.22],
  [30.04, 47.96],
  [-44.39, 171.26],
  [30.22, 123.09],
  [44.63, 33.57],
  [53.18, -10.28],
  [37.75, 23.43],
  [47.52, -52.98],
  [-7.77, 109.07],
  [39.77, -9.34],
  [46.62, 142.77],
  [54.85, 11.75],
  [10.15, -64.84],
  [17.67, 83.41],
  [35.44, 139.66],
  [1.12, 103.53],
  [40.82, 28.86],
  [40.68, 14.74],
  [58.97, 5.73],
  [-3.69, 114.42],
  [49.31, -123.27],
  [42.38, -80.15],
  [23.03, 70.22],
  [45.34, 36.67],
  [-23.93, -46.33],
  [52.17, 3.72],
  [6.9, 122.07],
  [35.89, 14.51],
  [51.33, 3.82],
  [37.75, 23.43],
  [49.18, -122.92],
  [37.94, 23.64],
  [52.2, -136.97],
  [51.93, 3.77],
  [59, -1.58],
  [45.22, -74.18],
  [53.98, 4.25],
  [50.02, -66.78],
  [49.3, -64.12],
  [56.46, 10.04],
  [46.45, -84.55],
  [51.23, 2.92],
  [40.69, 28.32],
  [38.93, 139.82],
  [18.68, -91.74],
  [36.65, 27.12],
  [6.44, 3.39],
  [3.82, 7.15],
  [-16.92, 145.77],
  [37.8, -122.39],
  [53.88, 14.27],
  [65.87, -23.48],
  [13.07, 43.13],
  [37.35, 23.47],
  [41, 28.96],
  [42.58, -8.82],
  [37.92, 23.6],
  [31.19, 32.3],
  [25.71, -79.97],
  [62.46, 6.2],
  [25.78, 55.93],
  [41.16, 29.05],
  [36, 28.5],
  [40.96, 28.89],
  [53.39, -3],
  [50.88, 0.99],
  [53.17, 5.41],
  [37.94, 23.64],
  [38.3, 26.23],
  [59.87, 30.23],
  [44.98, 147.65],
  [65.85, 24.15],
  [53.72, -0.64],
  [40.6, 18.85],
  [55.88, -4.89],
  [50.73, -127.49],
  [53.57, 8.56],
  [40.77, 29.43],
  [49.68, -123.17],
  [53.55, 9.98],
  [31.58, 130.57],
  [33.9, 129.7],
  [13.74, 120.94],
  [29.35, 47.93],
  [63.78, 21.6],
  [39.93, 26.16],
  [0.76, 104.15],
  [55.48, 8.35],
  [23.1, 113.23],
  [53.26, -132.02],
  [15.42, 73.8],
  [40.84, 29.29],
  [10.03, 108.97],
  [58.87, 9.42],
  [51.48, 0.83],
  [13.75, 121.05],
  [53.57, 8.53],
  [33.07, 12.89],
  [57.29, 11.52],
  [36.13, 23],
  [3.27, 4.52],
  [49.28, -123.08],
  [37, -7.93],
  [55.97, -4.77],
  [-2.45, -44.29],
  [47.88, -3.91],
  [37.94, 23.64],
  [60.43, 22.22],
  [40.96, 28.89],
  [-3.38, 114.24],
  [34.64, 135.42],
  [46.82, -71.2],
  [42.93, 10.55],
  [3.4, 1.35],
  [30.4, -91.22],
  [49.55, -55.73],
  [51.35, 4.24],
  [54.32, 10.13],
  [66.75, 13.57],
  [41.16, 29.05],
  [40.81, 28.8],
  [60.55, 5.18],
  [40.65, 27.67],
  [66.64, 41.09],
  [35.92, -5.35],
  [39.83, 3.13],
  [54.32, 10.13],
  [33.75, -118.28],
  [60.38, 25.67],
  [55.42, 10.38],
  [-39.09, -61.8],
  [35.12, 33.96],
  [-7.73, 109],
  [16.22, -119.23],
  [53.69, 5.85],
  [62.44, 6.19],
  [37.23, -20.74],
  [22.32, 91.82],
  [55.23, 12.85],
  [49.3, -123.08],
  [55.92, 11.82],
  [37.95, 23.64],
  [35.58, 140.13],
  [61.6, 5.03],
  [-4.33, 120.25],
  [1.28, 104.02],
  [37.25, 15.22],
  [57.23, -1.99],
  [51.8, 4.02],
  [54.32, -130.32],
  [41.11, 1.22],
  [53.9, 9.13],
  [47.23, 39.93],
  [50.11, -2.83],
  [59.91, 10.73],
  [54.12, 0.23],
  [34.7, 134.83],
  [33.63, 126.88],
  [54.12, -130.58],
  [1.1, 103.52],
  [8.01, 98.18],
  [21.93, 91.38],
  [3.28, 117.6],
  [27.74, -97.4],
  [37.97, 23.57],
  [40.56, 14.24],
  [54.23, -130.34],
  [60, 5.12],
  [32.33, -90.88],
  [40.96, 28.89],
  [3, 101.4],
  [59.8, 30.83],
  [62.37, 6.32],
  [30.3, 32.42],
  [37.94, 23.64],
  [36.2, 133.32],
  [3.46, 6.17],
  [22.62, 119.8],
  [40.1, 130.85],
  [35.89, -5.32],
  [-0.25, 117.57],
  [49.28, -123.11],
  [45.67, -82.92],
  [41.27, 29.05],
  [68.98, 16.66],
  [41.35, 2.17],
  [60.4, 5.32],
  [34.73, 119.45],
  [49.3, -123.21],
  [38.13, 13.36],
  [40.02, 26.28],
  [54.37, 10.15],
  [9.42, -13.72],
  [48.52, -122.62],
  [40.96, 28.89],
  [51, -127.57],
  [1.09, 104.19],
  [8.45, -13.47],
  [63.44, 10.4],
  [49.23, -68.12],
  [-3.97, 122.58],
  [41, 28.96],
  [55.62, -130.1],
  [10.31, 123.94],
  [53.86, 8.69],
  [49.13, -123.38],
  [37.94, 23.64],
  [5.18, 119.37],
  [63.2, 7.87],
  [46.02, -73.17],
  [22.68, 113.68],
  [43.65, -86.54],
  [55, 150],
  [48.22, -5.28],
  [-27.41, 153.16],
  [14.65, 120.95],
  [14.58, 120.97],
  [33.62, 130.41],
  [34.97, -39.18],
  [62.44, 6.19],
  [37.45, 25.49],
  [64.42, 10.91],
  [39.17, 23.48],
  [51.26, 4.39],
  [60.75, 4.73],
  [60.07, 38.03],
  [-0.31, 73.43],
  [-41.28, 174.78],
  [41.45, 31.77],
  [41.8, -83.22],
  [42, -80.62],
  [20.91, 107.28],
  [6.43, 3.37],
  [50.63, -1.58],
  [51.37, 2.53],
  [49.46, -2.53],
  [42.8, 132.88],
  [3.42, 5.6],
  [61.08, 6.58],
  [49.28, -123.1],
  [30.13, -90.94],
  [53.99, 8.3],
  [40.01, 26.26],
  [51.12, 1.7],
  [-34.16, -58.97],
  [59.63, 150.83],
  [45.88, -73.2],
  [4, -1.65],
  [54.32, 10.13],
  [48.4, -123.38],
  [51.65, -51.65],
  [53.46, -55.76],
  [45.35, 36.47],
  [-8.17, 114.43],
  [-16.73, -151.44],
  [38.73, 26.07],
  [36.42, 25.42],
  [62.37, 6.03],
  [43.47, -153.88],
  [-36.98, 174.99],
  [46.73, -71.27],
  [55.8, -4.87],
  [60.52, 6.72],
  [42.28, -83.14],
  [61.1, 5.51],
  [50.95, 1.17],
  [51.02, 1.48],
  [45.72, 13.25],
  [-32.06, 115.75],
  [53.93, -131.02],
  [52.98, 4.03],
  [59.13, 10.23],
  [45.02, -74.72],
  [59.87, 30.23],
  [69.65, 18.96],
  [23.4, 119.92],
  [60.2, 27.39],
  [53.62, 5.63],
  [-10.35, 150.98],
  [54.33, 10.17],
  [60.21, 5.59],
  [50.78, 0.88],
  [56.71, -6.27],
  [36.85, 27.23],
  [40.96, 28.89],
  [-8.73, 13.29],
  [37.63, 24.19],
  [50.66, 0.47],
  [46.41, -73.59],
  [1.33, 104.08],
  [-20.68, 116.69],
  [57.05, 9.94],
  [43.02, -82.42],
  [37.94, 23.64],
  [43.1, 131.89],
  [48.48, -68.52],
  [58.69, -3.05],
  [53.6, 0.01],
  [49.28, -123.2],
  [57.67, 21.97],
  [56.55, -61.68],
  [38.02, 24],
  [-0.3, 117.67],
  [38.24, 21.47],
  [51.83, 3.35],
  [41, 28.96],
  [47.12, 39.41],
  [1.27, 104.28],
  [70.98, 25.97],
  [47.83, 42.83],
  [58.62, -3.53],
  [48.39, -4.47],
  [64.69, -33.33],
  [40.41, 29.09],
  [5.81, 118.08],
  [40.15, 26.4],
  [13.12, 100.89],
  [44.93, -75.18],
  [62.47, 6.14],
  [53.48, 6.17],
  [6.02, 80.22],
  [42.8, 132.88],
  [49.5, -123.27],
  [42.8, 132.88],
  [54.32, 10.13],
  [-29.87, 31.03],
  [60.57, -11.45],
  [53.9, 9.13],
  [50.79, 0.06],
  [-3.67, 114.45],
  [47.17, 39.58],
  [53.88, 9.13],
  [53.55, 9.98],
  [46.19, -72.88],
  [-2.22, -79.88],
  [43.13, -79.2],
  [50.43, -0.65],
  [43.34, 5.34],
  [59.87, 30.23],
  [3.43, 7.06],
  [43.13, -79.2],
  [40.98, 28.88],
  [45.02, -66.93],
  [-23.58, 150.86],
  [62.2, 5.58],
  [59.35, 24.05],
  [20.29, -73.62],
  [35.58, 140.13],
  [62.73, 7.17],
  [59.46, 24.76],
  [36.9, 7.76],
  [45.8, 13.23],
  [57.05, -135.33],
  [22.59, 114.27],
  [48.5, -124.67],
  [70.66, 23.68],
  [46.35, 31.05],
  [35.66, 140.91],
  [-8.1, 114.42],
  [58.78, 9.37],
  [69.85, 39.42],
  [62.44, 6.27],
  [51.45, 3.58],
  [-11.67, 160.17],
  [-22.8, 43.21],
  [40.97, 28.68],
  [22.2, 88.2],
  [4.9, -1.66],
  [50.8, -1.3],
  [50.85, -127.43],
  [0.73, 104.13],
  [39.92, 142.1],
  [37.94, 23.64],
  [10.17, 107.03],
  [53.38, -3],
  [30, 122.1],
  [62, -49.67],
  [42.29, -83.08],
  [49.28, -123.07],
  [10.32, -75.53],
  [18.38, -64.93],
  [37.94, 21.15],
  [54.87, 10.82],
  [22.15, 91.73],
  [42.27, -83.1],
  [48.39, -4.47],
  [36.13, -5.44],
  [52.54, -128.78],
  [35, 139.87],
  [-2.21, -44.19],
  [-5.1, 119.42],
  [37.47, 25.33],
  [42.03, -82.6],
  [48.97, 140.27],
  [-12.02, -77.2],
  [60.79, 4.77],
  [46.95, -61.77],
  [3.14, 6.37],
  [9.69, 117.98],
  [44.82, 36.57],
  [30.7, 32.33],
  [6.44, 3.39],
  [-11.6, 130.82],
  [27, 51],
  [59.93, 5.31],
  [43.62, 13.51],
  [48.4, -89.17],
  [37.81, -122.33],
  [-11.55, -165.42],
  [29.75, -95.33],
  [46.27, -72.6],
  [37.94, 23.64],
  [52.46, 4.6],
  [56.46, 10.04],
  [29.92, 113.08],
  [25.17, 56.37],
  [46.81, -71.2],
  [41, 28.96],
  [44.14, 28.64],
  [2.84, 105.29],
  [50.29, -0.93],
  [46.06, -73.12],
  [49.97, -5.64],
  [38.76, 26.92],
  [54.39, 10.17],
  [54.37, 10.11],
  [40.77, 29.73],
  [37.5, 23.47],
  [29.86, 32.54],
  [3.92, 98.77],
  [68.7, 15.43],
  [37.28, 13.53],
  [55.44, 12.34],
  [51.74, -130.02],
  [46.45, -72.26],
  [15.55, 41.39],
  [40.83, 29.23],
  [66.02, 12.63],
  [38.64, 139.4],
  [59.87, 30.23],
  [1.27, 103.83],
  [54.32, 9.67],
  [51.21, 1.73],
  [-12.95, -38.56],
  [17.18, -61.8],
  [41.15, 29.07],
  [1.07, 104.17],
  [36.5, -10.2],
  [59.87, 30.23],
  [54.37, 10.98],
  [-32.15, 115.77],
  [36.84, 30.6],
  [59.33, 6.03],
  [37.81, 24.4],
  [37.75, 23.43],
  [50.03, -5.4],
  [45.09, 36.56],
  [36.95, 26.98],
  [58.57, 5.12],
  [53.42, -4.17],
  [68.97, 33.08],
  [43.2, -79.21],
  [-37.83, 144.92],
  [43.1, 131.89],
  [49.46, -2.54],
  [1.1, 103.53],
  [56.46, 10.04],
  [50.97, 1.86],
  [52.45, 4.03],
  [48.77, -123.23],
  [51.88, 5.45],
  [48.57, 44.15],
  [38.02, 22.73],
  [29.3, -94.8],
  [57.15, -2.07],
  [40.45, 27.13],
  [41.31, 19.45],
  [27.97, -82.48],
  [-4.97, 10.74],
  [35.89, 14.51],
  [53.9, 9.13],
  [15.78, 53.25],
  [45.03, 35.4],
  [60.43, 22.22],
  [47.55, -52.7],
  [50.15, -5.06],
  [50.75, 1.1],
  [37.94, 23.64],
  [29.75, -95.33],
  [24.48, 54.37],
  [49.48, -5.31],
  [35.79, -50.02],
  [52.55, 2.63],
  [49.24, -68.14],
  [53.61, 6.57],
  [38.23, 26.25],
  [69.66, 54.15],
  [26.72, -80.05],
  [59.7, 28.43],
  [49.57, -138.67],
  [50.02, -3.35],
  [14.2, 42.32],
  [10.32, 123.92],
  [53.55, 9.98],
  [56.07, 1.59],
  [41.71, 3.01],
  [41.45, 31.78],
  [1.27, 103.83],
  [51.52, 1.6],
  [58.72, -3.07],
  [33.86, 131.18],
  [53.55, 8.58],
  [46.58, -87.39],
  [41.45, 31.79],
  [22.32, 91.82],
  [49.16, -123.37],
  [42, 35.15],
  [42.92, 131.47],
  [37.94, 23.64],
  [61.65, 4.35],
  [22.59, 120.31],
  [43.73, 7.42],
  [40.92, 28.97],
  [49.85, -62.88],
  [-28.79, 32.04],
  [56.35, -7.72],
  [48.33, -70.88],
  [-8.17, 114.43],
  [43.28, -79.85],
  [54.09, 12.14],
  [-34.01, 1.2],
  [21.93, 91.38],
  [46.32, -72.53],
  [22.27, 91.7],
  [46.06, -73.1],
  [51.9, 4.48],
  [17.04, 82.44],
  [62.7, 5.2],
  [-33.75, 18.02],
  [16.33, 119.88],
  [53.52, 8.15],
  [54.32, 10.13],
  [58.62, -6.82],
  [37.94, 23.64],
  [48.92, -123.7],
  [43.4, -79.02],
  [37.75, 23.43],
  [-20.68, 116.69],
  [55.69, 10.68],
  [38.25, 21.74],
  [57.7, 11.94],
  [62.37, 6.07],
  [64.53, 40.5],
  [40.02, -123.15],
  [43.71, -82.17],
  [6.75, 3.63],
  [42.69, 8.66],
  [21.93, -76.91],
  [58.7, -2.98],
  [55.3, 10.78],
  [-18.15, 49.42],
  [6.93, 79.86],
  [57.32, 24.41],
  [10.75, 106.7],
  [3.97, 99.78],
  [40.01, 26.26],
  [45.25, -81.67],
  [40.96, 28.89],
  [13.32, -87.82],
  [58.09, 6.59],
  [33.37, 12.57],
  [50.54, -0.92],
  [36.28, 30.17],
  [41.12, 29.08],
  [41.12, 29.08],
  [40.23, 26.52],
  [47.8, -5.33],
  [33.87, 130.82],
  [51.47, 1.88],
  [40.64, 22.92],
  [38.76, 26.92],
  [14.25, 52.45],
  [8.48, 124.65],
  [51.55, 2.1],
  [49.15, -123.41],
  [40.98, 8.87],
  [46.58, -72.02],
  [57.85, 167.45],
  [50.73, 1.62],
  [19.21, -96.14],
  [7.83, 117.22],
  [-27.41, 153.16],
  [53.75, 7.48],
  [-17.83, 178.67],
  [49.49, 0.14],
  [47.6, -122.34],
  [37.15, 24.66],
  [55.36, -131.7],
  [50.43, 7.48],
  [54.72, 20.52],
  [-27.48, -58.83],
  [53.58, 0.04],
  [36.13, -5.35],
  [11.9, 101.12],
  [41.7, -83.46],
  [55.68, 146.65],
  [9.97, 76.23],
  [62.58, 6.93],
  [40.76, 24.58],
  [47.56, -52.7],
  [50.64, -0.59],
  [56.68, 8.22],
  [61.07, 5.5],
  [40.97, 28.68],
  [44.65, -63.58],
  [49.32, -123.08],
  [55.71, 9.55],
  [49.63, -0.4],
  [59.87, 30.23],
  [50.8, -0.23],
  [35.34, 25.15],
  [30.03, -90.47],
  [23.75, 117.57],
  [54.28, 9.67],
  [47.83, -69.83],
  [36.84, -2.48],
  [10.16, -64.8],
  [44.9, -75.18],
  [34.2, 135.13],
  [54.52, 18.82],
  [56.52, 20.93],
  [-7.85, 109.07],
  [63.45, 10.2],
  [38.87, 22.63],
  [67.83, 12.93],
  [52.45, 4.1],
  [68.7, 15.43],
  [42.23, -8.7],
  [53.9, 9.13],
  [31.05, 122.78],
  [42.9, -82.45],
  [50.72, -1.98],
  [17.49, -88.2],
  [43.09, -79.21],
  [41, 28.96],
  [40.15, 26.4],
  [42.9, -79.25],
  [13.53, 50.45],
  [66.2, 13],
  [29.97, 32.55],
  [10.41, 107.14],
  [50.83, -1.34],
  [-33.03, 27.92],
  [-7.2, 112.73],
  [50.47, -0.57],
  [53.88, 9.13],
  [51.95, 3.71],
  [39.17, 23.48],
  [47.37, -86.45],
  [32.75, -118.77],
  [38.82, 26.94],
  [48.69, -123.29],
  [50.28, -125.38],
  [45.27, 12.3],
  [52.52, 4.28],
  [-8.76, 116.06],
  [30.71, 32.34],
  [29.11, -90.21],
  [21.47, 39.17],
  [-29.7, 16.83],
  [45.95, -73.18],
  [47.56, -52.71],
  [37.94, 23.64],
  [58.78, 6.23],
  [49.85, -4.78],
  [40.15, 26.4],
  [54.34, -130.32],
  [49, -66.97],
  [57.7, 11.95],
  [57.58, -6.37],
  [49.48, -123.92],
  [57, -5.82],
  [50.45, -1.52],
  [31.2, 29.89],
  [42.27, -83.27],
  [62.72, -92],
  [-5.83, 105.8],
  [58.45, 5.99],
  [48.98, -123.13],
  [31.57, -91.42],
  [3.83, 5.4],
  [25.37, 55.38],
  [33.95, 130.95],
  [48.28, -69.08],
  [46.42, -52.05],
  [49.95, -55.6],
  [54.38, 10.17],
  [52.65, -5.03],
  [50.47, -5.73],
  [53.18, 4.85],
  [51.72, 2.57],
  [45.27, 36.42],
  [56.35, 2.51],
  [53.17, 4.57],
  [51.4, 3.06],
  [33.52, 126.55],
  [45.23, -74.09],
  [60.4, 5.32],
  [39.88, 26.04],
  [41.87, -83.07],
  [8.38, 76.99],
  [45.78, 47.55],
  [53.87, 8.71],
  [40.95, 28.9],
  [37.94, 23.64],
  [50.4, -0.77],
  [44.85, -87.35],
  [10.58, 107.03],
  [36.44, 28.23],
  [45.64, -73.48],
  [50.12, -125.35],
  [8.15, 57.43],
  [1.08, 103.7],
  [18.47, -69.88],
  [49.78, -60.73],
  [44.82, -82.51],
  [12.27, 109.18],
  [36.13, -5.44],
  [57, 10.82],
  [57.9, -6.8],
  [53.34, 7.2],
  [44.42, 8.92],
  [22.32, 91.82],
  [62.63, 7.07],
  [53.87, 8.7],
  [47.12, 39.41],
  [55.1, -1.47],
  [6.3, 3.34],
  [50.72, -1.98],
  [57.44, 10.54],
  [-18, 122.21],
  [51.68, 4.4],
  [46.28, -10],
  [49.15, -123.52],
  [56.72, 37.13],
  [38.76, 26.92],
  [51.5, 0.13],
  [-8.13, 121.87],
  [49.67, -123.17],
  [37.95, 26.82],
  [58.47, 151.56],
  [46.02, -83.5],
  [46.7, 71.53],
  [53.64, -11.98],
  [37.73, -25.67],
  [61.6, 5.03],
  [8.48, 124.65],
  [51.26, 4.39],
  [36.07, 14.22],
  [55.65, 20.58],
  [-33.19, 151.7],
  [38.76, 26.92],
  [50.94, 6.96],
  [51.35, 4.23],
  [43.45, -87.47],
  [47.07, -5.43],
  [50.57, 0.4],
  [53.53, 8.53],
  [25.42, 55.45],
  [3.05, 4.84],
  [-3.64, 110.14],
  [22.21, -97.85],
  [35.89, -5.32],
  [52.46, 4.6],
  [54.33, -130.34],
  [40.85, 14.28],
  [53.9, 9.13],
  [9.5, 118.5],
  [23.1, 113.23],
  [48.47, -68.52],
  [38.02, 23.58],
  [43.58, 39.73],
  [1.72, 105.83],
  [26.04, -78.41],
  [60.91, 34.17],
  [49, -123.17],
  [59.87, 30.23],
  [46.36, 48.04],
  [6.79, 99.65],
  [52.52, -128.33],
  [48.87, -68.56],
  [28.48, -16.23],
  [48.68, -123.4],
  [53.9, 9.13],
  [54.48, 13.59],
  [35.48, 23.62],
  [41.7, -83.48],
  [31.37, 121.56],
  [15.84, -87.95],
  [14.67, -17.35],
  [46.4, -72.37],
  [3, 5.95],
  [51.52, -55.45],
  [53.22, 7.45],
  [51.13, 1.32],
  [29.3, -94.8],
  [51.89, 4.34],
  [49.19, -122.91],
  [-7.07, 113.98],
  [54.32, 10.13],
  [54.45, 11.61],
  [36.75, 5.09],
  [45.83, -73.28],
  [50.6, -0.81],
  [6.96, 79.86],
  [47.02, -51.83],
  [50.83, -127.45],
  [45.5, -73.52],
  [46.64, -71.73],
  [54.21, 9.54],
  [37.61, 25.81],
  [40.62, 122],
  [41.12, 16.9],
  [69.67, 33.96],
  [12.85, 73.82],
  [46.36, 48.04],
  [54.48, 13.59],
  [49.47, 8.45],
  [43.67, -70.27],
  [54.23, -130.34],
  [50.08, -2.28],
  [47.63, -122.33],
  [22.32, 91.82],
  [43.02, -82.42],
  [29.33, 47.92],
  [47.57, -59.14],
  [41.28, 31.42],
  [34.8, 126.35],
  [53.53, 9.97],
  [49.17, -123.88],
  [36.42, 25.43],
  [53.88, 9.13],
  [40.42, 29.08],
  [49.12, -123.68],
  [32.71, -117.14],
  [47.55, -52.7],
  [53.48, 0.34],
  [60.99, 35.51],
  [35.12, 129.04],
  [41, 29.02],
  [22.11, 91.74],
  [31.98, 119.99],
  [58.97, 5.73],
  [57.88, 10.78],
  [29.95, -90.28],
  [37.97, 23.57],
  [29.68, -95],
  [10.63, 103.5],
  [65.97, 12.29],
  [46.32, 47.98],
  [-33.92, 18.43],
  [57.57, 39.87],
  [47.12, 39.42],
  [25.1, 66.72],
  [35.42, 26.45],
  [54.93, 10.72],
  [-17.67, 178.59],
  [59.7, 28.43],
  [60.21, 25.2],
  [40.77, 29.54],
  [38.03, 23.5],
  [56.03, 12.62],
  [-27.41, 153.16],
  [1.08, 103.73],
  [41.45, 29.07],
  [43.13, -79.2],
  [54.09, 12.14],
  [57.15, -2.07],
  [46.36, -165.06],
  [63.48, 9.1],
  [49.08, 140.27],
  [38.02, 23.58],
  [33.27, 131.51],
  [-20.15, 57.48],
  [42.98, -82.42],
  [18.33, -64.73],
  [45.3, 36.58],
  [50.61, -2.42],
  [48.8, -125.33],
  [-2.53, 105.73],
  [41.29, 36.33],
  [7.23, 100.58],
  [38.91, 1.44],
  [5.41, 100.33],
  [70.65, 23.67],
  [54.5, 13.86],
  [53.97, 6.19],
  [49.67, -64.2],
  [22.32, 91.82],
  [53.92, -166.62],
  [5.81, 118.08],
  [50.9, -1.41],
  [39.12, 23.75],
  [24.86, 51.7],
  [46.2, 47.87],
  [39.57, 140.05],
  [40.96, 27.51],
  [-36.83, 174.75],
  [51.29, 1.83],
  [-38.35, 141.61],
  [46.36, 48.04],
  [47.12, 39.41],
  [36.91, 27.27],
  [-23.84, 151.27],
  [60.55, -145.77],
  [60.45, 26.95],
  [69.65, 18.96],
  [43.36, -8.4],
  [54.73, -133.87],
  [33.61, -7.6],
  [49.86, -5.44],
  [39.53, 20.22],
  [54.32, 10.13],
  [35.02, 137.4],
  [47.21, 38.95],
  [40.78, 29.61],
  [36.44, 28.23],
  [53.43, 14.58],
  [60.07, 38],
  [69.65, 18.96],
  [46.72, -71.35],
  [68.94, 33.01],
  [41.52, -70.67],
  [51.88, 6],
  [59.93, 5.31],
  [40.97, 28.94],
  [5.22, 4.82],
  [34.52, 137.53],
  [47.07, -59.53],
  [-37.83, 144.92],
  [42.12, -86.49],
  [33.95, 130.95],
  [62.44, 6.19],
  [10.68, -63.25],
  [69.17, 14.75],
  [25.37, 55.38],
  [44.4, 34.03],
  [20.82, 70.03],
  [63.07, 8.23],
  [46.82, -71.2],
  [54.2, 9.53],
  [1, 4],
  [10.32, 107.7],
  [-19.83, 34.83],
  [-19.83, 34.83],
  [27.83, -97.07],
  [-34.75, -57.83],
  [40.84, 29.29],
  [61.28, -4.33],
  [11.68, 75.48],
  [33.95, 131.25],
  [41.98, -82.6],
  [56.01, 148.3],
  [60.83, 7.12],
  [29.97, 32.55],
  [55.17, 16.17],
  [30.05, -90.68],
  [13.08, 80.28],
  [40.96, 28.91],
  [33.87, 130.82],
  [20.87, -156.68],
  [25.78, 55.93],
  [35.51, 129.38],
  [55.02, -5.2],
  [46.8, -71.18],
  [29.82, -93.34],
  [-23.93, -46.33],
  [64.77, 40.37],
  [49.28, -122.85],
  [-1.24, 116.78],
  [35.45, 139.81],
  [53.08, 7.38],
  [46.02, -81.66],
  [33.3, 136.67],
  [57.63, 18.28],
  [50.37, -4.12],
  [49.35, -123.35],
  [66.05, -17.37],
  [27.93, -82.44],
  [-43.61, 172.73],
  [47.27, -122.38],
  [37.03, 27.44],
  [51.25, 6.77],
  [43.2, 27.92],
  [-4.07, 39.68],
  [22.32, 91.82],
  [46.44, -84.27],
  [53.9, 9.13],
  [-2.21, 108.05],
  [40.78, 29.6],
  [41, 28.96],
  [40.26, 122.09],
  [9.88, 123.53],
  [50.08, -3.52],
  [49.4, -140.22],
  [40.64, 22.92],
  [54.35, 10.17],
  [48.98, -5],
  [60.16, 24.94],
  [39.53, 20.22],
  [41.65, 41.66],
  [30.87, 32.3],
  [54.32, 13.1],
  [51.33, 3.2],
  [45.42, -73.5],
  [44.96, -74.96],
  [46.73, 38.28],
  [39.15, 23.83],
  [-12.05, -77.14],
  [57.2, 11.52],
  [7.33, 134.48],
  [36.03, 36.83],
  [48.32, -123.4],
  [29.7, 72.85],
  [57.01, -5.83],
  [36.2, -89.66],
  [62.38, 6.64],
  [57.63, 18.27],
  [41.12, 29.08],
  [52.97, 1.22],
  [-17.22, -145.65],
  [55.47, 4.4],
  [50.93, 0.77],
  [49.08, 140.27],
  [39.17, 23.48],
  [38.92, 121.65],
  [34.61, 138.48],
  [22.2, 113.55],
  [45.42, -73.67],
  [39.62, 19.95],
  [36.68, 36.18],
  [56.03, 12.67],
  [48.83, -64.44],
  [40.2, -6.18],
  [49.31, -5.86],
  [41.45, -70.56],
  [32.08, -81.09],
  [44.35, 28.68],
  [-4.07, 39.68],
  [50.02, -66.78],
  [68.42, 16],
  [39.75, 140.07],
  [37.94, 23.64],
  [48.15, -122.63],
  [54.98, 9.98],
  [-17.52, -149.77],
  [53.34, 7.18],
  [14.6, -61.06],
  [10.28, -64.71],
  [41.27, 29.07],
  [24.4, 118.42],
  [22.67, 69.93],
  [13.77, 109.23],
  [45.04, -66.92],
  [49.67, -124.92],
  [51.57, 1.95],
  [42.99, 132.31],
  [46.51, -84.35],
  [53.98, -1.65],
  [36.58, -4.55],
  [-4.54, 120.33],
  [38.97, -74.96],
  [56, -133],
  [50.72, -127.45],
  [1.15, 104.23],
  [57.26, 16.46],
  [-10.82, 142.77],
  [10.96, -74.77],
  [51.59, 3.25],
  [51.42, 1.95],
  [35.98, -5.3],
  [44.88, 37.3],
  [-2.57, -44.37],
  [-2.58, -44.36],
  [-33.5, -60.01],
  [40.84, 29.29],
  [6.3, 3.32],
  [37.94, 23.64],
  [54.32, 10.13],
  [12.66, 109.28],
  [4.69, 7.16],
  [41.8, -82.47],
  [39.11, 26.56],
  [59.87, 30.22],
  [50.33, -1.05],
  [37.95, 27.2],
  [40.2, 25.9],
  [46.8, -71.18],
  [54.53, 18.55],
  [-35.17, -55.56],
  [53.33, 8.48],
  [26.95, 120.25],
  [50.13, -125.38],
  [4.43, -1.72],
  [53.9, 9.13],
  [49.13, -123.19],
  [36.42, 25.45],
  [1.7, 101.47],
  [40.71, -74.01],
  [51.4, 4.18],
  [50.52, 0.4],
  [-24, -46.33],
  [43.1, 131.73],
  [11.99, 109.08],
  [32.01, 120.82],
  [64.53, 40.5],
  [-41.29, 174],
  [40.96, 28.89],
  [44.85, 37.08],
  [37.82, 24.9],
  [1.18, 103.95],
  [14.42, 120.5],
  [54.4, 11.8],
  [36.72, 27.68],
  [41, 28.96],
  [44.59, 37.92],
  [-23.82, 151.5],
  [67.28, 14.38],
  [61.18, 177.11],
  [-10.48, 105.63],
  [62.44, 6.27],
  [37.32, 23.15],
  [10.68, -61.66],
  [48.86, -123.31],
  [34.85, 119.7],
  [51.94, 3.77],
  [-2.64, 140.49],
  [37.95, 23.64],
  [41.2, 30.33],
  [60.17, 19.17],
  [55.85, 12.82],
  [40.03, 26.31],
  [46.04, -73.12],
  [51.6, -5.25],
  [31.38, 31.8],
  [45.68, -73.46],
  [40.96, 28.94],
  [59.3, -3.33],
  [4.37, 4.72],
  [47.19, 39.69],
  [51.9, 4.4],
  [37.95, 23.55],
  [49.93, -4.93],
  [53.52, 8.13],
  [38.85, 26.93],
  [29.91, -90.08],
  [40.96, 28.89],
  [38.36, 20.06],
  [21.02, 72.58],
  [37.49, 23.48],
  [40.96, 28.89],
  [45.34, 36.67],
  [47.63, -122.33],
  [40.95, 28.9],
  [-5.87, 13.03],
  [45.49, -73.52],
  [45.68, 47.67],
  [38.07, -122.23],
  [60.15, -1.14],
  [59.82, 5.26],
  [11.67, 92.72],
  [46.73, 38.28],
  [47.21, 38.95],
  [5.68, 115.81],
  [37.23, 15.19],
  [51.6, 3.99],
  [54.92, 11.35],
  [56.46, 10.04],
  [50.12, -5.54],
  [10.77, 106.72],
  [42.33, -83.03],
  [40, 135],
  [4.42, 7.15],
  [53.02, 158.63],
  [35.37, 24.48],
  [34.75, 127.75],
  [34.5, 130.37],
  [53.34, 0.98],
  [49.3, -123.26],
  [50.76, -1.53],
  [48.75, -123.1],
  [51.47, 3.7],
  [36.42, 25.45],
  [57.28, 23.67],
  [37.63, 26.63],
  [3.62, 4.75],
  [38.32, 26.25],
  [48.75, -122.5],
  [45.53, 47.73],
  [41.12, 29.08],
  [-41.28, 174.78],
  [53.36, 7.19],
  [55.68, 11.09],
  [40.96, 28.91],
  [-5.95, 106],
  [32.82, 35.01],
  [40.1, 26.38],
  [49.19, -122.92],
  [40.42, 26.68],
  [47.05, 142.05],
  [49.08, 140.27],
  [55.18, -130.1],
  [21.93, 91.38],
  [-20.15, 57.48],
  [49.48, 0.13],
  [42.15, 41.66],
  [31.63, 34.52],
  [22.32, 91.82],
  [32.79, -79.93],
  [40.97, 28.95],
  [22.58, 88.35],
  [53.4, 0.82],
  [54.92, 10.75],
  [41.3, 36.34],
  [38.92, 121.65],
  [44.77, -66.75],
  [54.33, -130.31],
  [59.45, 10.5],
  [51.92, 4.58],
  [22.17, 91.7],
  [51.33, 3.82],
  [38.38, 26.15],
  [11.28, 169.62],
  [45.84, -73.29],
  [-5.92, 105.89],
  [50.73, 156.32],
  [43.71, 135.25],
  [24.43, 119.13],
  [-19.92, -39.63],
  [37.75, 23.43],
  [-33.86, 151.21],
  [52.12, 3.67],
  [-35.17, -55.56],
  [6.57, 122.05],
  [50.36, -0.44],
  [49.02, -66.97],
  [49.99, 7.87],
  [48.25, -125.7],
  [49.57, -0.13],
  [51.9, 4.35],
  [45.45, 12.25],
  [-34.9, -56.27],
  [40.03, 26.07],
  [58.38, -1.39],
  [48.88, -123.4],
  [50.98, 4.39],
  [47.17, 39.58],
  [48.32, -123.46],
  [48.1, -69.55],
  [40.77, 29.44],
  [64.27, 7.18],
  [41.29, 36.36],
  [51.77, 6.4],
  [43.2, 27.92],
  [48.58, -68.77],
  [51.76, 1.8],
  [-5.93, 106],
  [1.36, 103.55],
  [38.82, 26.94],
  [40.93, 28.88],
  [49.2, -123.97],
  [40.7, -74.03],
  [50.92, -1.45],
  [70.67, 23.67],
  [46.95, -70.83],
  [40.77, 29.6],
  [31.2, 29.89],
  [43.1, 131.89],
  [58.5, 18.43],
  [46.28, -59.77],
  [37.63, 24.33],
  [57.7, 11.92],
  [34.13, 135.03],
  [41.45, 31.78],
  [1.13, 103.93],
  [53.02, 158.63],
  [62.12, -6.9],
  [40.93, 28.88],
  [34.01, 12.54],
  [24.28, 120.53],
  [22.32, 91.82],
  [68.97, 33.08],
  [51.27, 1.81],
  [49, -123.15],
  [10.27, 107.02],
  [44.55, -63.55],
  [-23.94, -46.31],
  [37.44, -89.44],
  [37.87, 24.42],
  [13.75, 121.05],
  [36.92, -75.72],
  [42.91, -79.25],
  [55.72, 21.11],
  [40.75, 28.55],
  [40.45, 27.13],
  [-35.18, 23.8],
  [38.76, 26.92],
  [-23.93, -46.33],
  [49.16, -123.04],
  [37.42, 130.98],
  [49.32, -123.18],
  [54, -128.68],
  [48.4, -70.82],
  [29.18, -89.26],
  [16.93, 54],
  [54.18, 7.89],
  [53.75, 7.85],
  [41.34, 28.97],
  [50.75, 0.05],
  [40.92, 9.5],
  [14.78, 42.95],
  [-2.17, -55.05],
  [38.37, 26.14],
  [46.73, 38.28],
  [59.55, 1.98],
  [53.89, 9.14],
  [40.48, 17.19],
  [49.54, -123.39],
  [36.68, 24.42],
  [58.62, -4.43],
  [46.2, -60.23],
  [46.21, 47.9],
  [41, 28.96],
  [-2.53, -57.57],
  [3.29, 6.36],
  [25.2, -90.02],
  [50.45, 4],
  [49.86, -3.21],
  [6.37, 99.78],
  [13.15, 123.75],
  [49.49, -0.14],
  [22.31, 91.81],
  [42.81, 10.32],
  [45.14, -79.2],
  [5.72, 80.73],
  [59.38, 5.27],
  [22.2, 113.55],
  [-46.58, 168.33],
  [26.6, 50.15],
  [40.44, 29.11],
  [51.13, 1.32],
  [50, 8.28],
  [60.06, 29.4],
  [53.88, 9.13],
  [47.28, -53.98],
  [8.02, 98.12],
  [-33.33, -60.22],
  [58.7, -4.85],
  [56.46, 10.04],
  [49.95, -5.6],
  [36.13, -5.42],
  [41, 28.96],
  [1.18, 103.68],
  [53.75, 6.36],
  [10.25, -64.6],
  [-28.79, 32.04],
  [40.96, 28.89],
  [51.3, 4.27],
  [37.02, 23.87],
  [45.15, 36.51],
  [41.84, -82.27],
  [-25.5, -48.52],
  [-5.32, 147.2],
  [57.27, 16.46],
  [68.23, 14.57],
  [34.5, 135.35],
  [-20.94, 54.99],
  [39.75, -75.5],
  [64.53, 40.5],
  [39.35, 22.95],
  [13.73, 109.25],
  [18.9, 72.87],
  [54.14, -4.47],
  [55.5, 14.78],
  [7.17, 125.65],
  [40.02, 26.28],
  [17.95, -102.16],
  [47.58, -59.14],
  [55.45, 8.4],
  [4.42, 7.15],
  [48.48, -68.52],
  [53.36, 7.19],
  [39.1, 117.17],
  [51.35, 3.86],
  [-1.33, 116.87],
  [9.4, -79.93],
  [-32.93, -60.62],
  [53.17, 5.37],
  [51.83, 3.35],
  [-8.76, 116.06],
  [-5.87, 105.75],
  [53.9, 9.13],
  [64.53, 40.5],
  [43.35, -8.38],
  [21.18, 110.4],
  [47.01, -70.55],
  [41.28, 31.42],
  [4.07, 6.3],
  [54.37, 10.14],
  [-18.13, 178.43],
  [31.06, 122.77],
  [48.62, -123.41],
  [37.97, 23.57],
  [53.35, 7.2],
  [43.82, -66.21],
  [40.85, 25.95],
  [40.95, 28.87],
  [48.52, -122.62],
  [54.32, 10.13],
  [49.08, -123.35],
  [69.61, 17.86],
  [5.49, 53.28],
  [1.17, 103.97],
  [33.77, -118.21],
  [18.7, -77.07],
  [23.98, 121.63],
  [46.36, 48.04],
  [53.9, 9.13],
  [-5.87, 105.75],
  [17.65, 83.4],
  [23.06, 120.09],
  [41.12, 29.08],
  [-33.85, 151.2],
  [48.46, -5.1],
  [36.35, 35.59],
  [55.27, 9.82],
  [58.38, -5.35],
  [55.71, 21.14],
  [12.58, 122.27],
  [29.85, -93.96],
  [37.03, 27.44],
  [51.29, 1.84],
  [32.71, 172.85],
  [49.33, -123.18],
  [41.18, 29.05],
  [15.83, -87.94],
  [40.03, 26.3],
  [39.93, 119.64],
  [1.27, 103.83],
  [1.17, 104.17],
  [37.94, 23.64],
  [54.32, -130.32],
  [41, 28.96],
  [5.82, 118.15],
  [44.05, 145.8],
  [50.4, 0.76],
  [1.5, 104.87],
  [40.98, 28.94],
  [-33.35, -60.1],
  [61.13, -146.35],
  [53.58, -3.45],
  [51.35, 3.86],
  [51.6, 3.99],
  [35.22, 26.12],
  [35.52, 129.38],
  [38.25, 21.74],
  [61.1, 28.27],
  [70.25, 21.28],
  [-31.31, 155.79],
  [69.65, 18.96],
  [49.31, 8.46],
  [53.9, 11.46],
  [45, 47.73],
  [41.48, 29.03],
  [36.13, 21.32],
  [68.97, 33.08],
  [50.63, -126.8],
  [55.42, 10.38],
  [63.43, -20.27],
  [43.77, 135.23],
  [20.5, 71.57],
  [49.74, 5.85],
  [5.07, 2.62],
  [45.51, -73.52],
  [40.95, 28.92],
  [40.78, 28.6],
  [38.59, 15.35],
  [10.15, -64.84],
  [70.24, 22.35],
  [10.53, 123.93],
  [12.55, 122.28],
  [38.13, 13.38],
  [-27.41, 153.16],
  [62.37, 6.42],
  [49.1, -123.3],
  [47.27, -49.66],
  [73.06, 68.37],
  [40.15, 26.4],
  [42.8, 132.88],
  [24.9, 118.58],
  [1.13, 103.92],
  [54.17, 12.08],
  [47.09, 39.24],
  [34.23, -77.95],
  [48.55, -62],
  [47.62, -57.62],
  [53.7, -0.87],
  [59.76, 19.31],
  [46.58, -72.03],
  [27.77, 48.87],
  [59.77, 30.8],
  [-5.53, 105.3],
  [50.66, -0.98],
  [45.52, -73.55],
  [41, 28.96],
  [22.13, 91.72],
  [42.3, -80.35],
  [50.56, 0.77],
  [34.73, 10.77],
  [51.09, 1.48],
  [69.97, 33.08],
  [46.53, 37.26],
  [41.07, 29.05],
  [49.36, -4.19],
  [37.95, 21.15],
  [40.78, 29.61],
  [56.03, 14.58],
  [63.86, 8.66],
  [54.32, 10.13],
  [35.27, -2.92],
  [-6.05, 106.89],
  [38.44, 24.71],
  [42.73, -82.48],
  [48.99, -68.05],
  [68.97, 33.08],
  [68.47, 14.77],
  [37.94, 23.64],
  [53.7, -0.87],
  [48.33, -72.87],
  [59.7, 28.43],
  [-0.23, 117.56],
  [61.09, -146.38],
  [44.74, 37.79],
  [43.56, 10.31],
  [23.85, -160.93],
  [37.94, 23.64],
  [-18.13, 178.43],
  [40.48, 17.19],
  [54.34, 9.92],
  [40.96, 28.89],
  [49.43, -123.47],
  [41.25, 36.43],
  [-33.75, 17.6],
  [66.17, -128.93],
  [15.67, -61.72],
  [-29.95, -71.33],
  [57.6, -7.13],
  [46.57, -72.14],
  [-43, -60],
  [49.32, -123.13],
  [70.24, 22.35],
  [48.39, -4.47],
  [44.65, -63.58],
  [40.93, 28.92],
  [34.4, 138.53],
  [49.3, -123.12],
  [36.88, 6.94],
  [45.33, -80.32],
  [-4.75, 115.88],
  [10.73, 121.94],
  [40.89, 29.19],
  [40.77, 29.54],
  [38.44, 27.16],
  [47.43, 70.4],
  [51.35, 4.29],
  [28.42, 48.5],
  [49.3, -123.07],
  [22.07, 88.22],
  [22.21, 91.72],
  [41.15, 29.07],
  [50.22, 1.72],
  [30.02, -15.53],
  [10.28, -64.7],
  [2.85, 117.38],
  [51.45, 3.58],
  [-33.19, 151.7],
  [43.25, 9.47],
  [43.13, -79.19],
  [27.97, -43.88],
  [53.7, -0.87],
  [13.6, 100.6],
  [40.87, 29.23],
  [50.47, -0.21],
  [46.8, -71.18],
  [47.57, -122.62],
  [53.55, 8.58],
  [55.98, 11.3],
  [52.58, 4.25],
  [41.15, 29.05],
  [59.99, 29.77],
  [48.19, 139.7],
  [37.47, 126.63],
  [51.43, 2.65],
  [46.73, 38.28],
  [39.83, 26.07],
  [41.49, 29.31],
  [1.47, 103.75],
  [22.67, 69.98],
  [44.86, -87.41],
  [41.05, 28.59],
  [41.97, -81.8],
  [47.19, 39.69],
  [1.08, 104.17],
  [65.12, 12.77],
  [51.35, 4.23],
  [58.64, -0.91],
  [47.57, -52.67],
  [-41.18, 146.35],
  [37.38, 23.23],
  [42.77, -82.48],
  [66.15, -18.9],
  [51.29, 4.26],
  [43.04, 131.98],
  [4.63, 3.24],
  [51.98, 1.42],
  [9.17, 123.5],
  [20.84, 107.13],
  [1.12, 103.74],
  [49.87, -4.03],
  [-1.22, 106.83],
  [37.8, -122.32],
  [39.21, 119],
  [42.78, -79.27],
  [49.19, -122.92],
  [59.99, 28.39],
  [34.43, 134.38],
  [-5.98, 105.98],
  [54.3, 10.13],
  [43.36, -8.25],
  [46.36, 48.04],
  [30.05, -90.85],
  [-33.48, -59.9],
  [63.44, 10.4],
  [22.52, 89.59],
  [59.87, 30.23],
  [66.33, 13],
  [46.78, -71.2],
  [38.97, -74.96],
  [47.02, -85.43],
  [-23.95, -46.28],
  [49.16, -123.04],
  [43.12, 5.92],
  [45.36, -83.49],
  [69.08, 15.95],
  [46.02, -122.87],
  [-3.72, 114.42],
  [52.67, 5.6],
  [51.14, 1.57],
  [22.32, 91.82],
  [40.96, 28.89],
  [44.97, -74.91],
  [41.18, 18.5],
  [50.9, -1.41],
  [51, 1.03],
  [49.43, -123.77],
  [45.34, 36.67],
  [43.47, -3.8],
  [55.42, 51.88],
  [20.48, -86.97],
  [54.37, 10.15],
  [41, 28.96],
  [55.22, -5.62],
  [35.12, 129.04],
  [55, 11.92],
  [8.8, 78.18],
  [58.45, -5.05],
  [58.97, -3.3],
  [45.68, -62.72],
  [37.37, -5.98],
  [48.42, -89.18],
  [35.96, 14.43],
  [-20.32, 118.58],
  [46.2, -60.25],
  [49, -123.12],
  [25.39, 56.55],
  [50.16, -2.59],
  [51.27, 1.47],
  [22.27, 113.78],
  [46.36, 48.04],
  [55.47, 10.53],
  [58.53, 22.23],
  [22.28, 91.73],
  [43.1, 131.89],
  [53.9, 9.13],
  [34.23, 135.12],
  [54.22, 8.48],
  [46.13, -122.93],
  [69.68, 18.94],
  [48.52, -125.78],
  [42.24, -8.73],
  [6.25, 3.2],
  [48.8, -123.24],
  [8.57, 81.23],
  [28.48, -16.22],
  [42.87, 131.38],
  [50.32, -0.9],
  [40.96, 28.89],
  [46.73, 38.28],
  [22.25, 91.75],
  [4.15, 6.97],
  [43.79, 34.27],
  [-20.85, 55.3],
  [51.93, 3.75],
  [41.54, 41.99],
  [40.84, 29.29],
  [49.3, -123.19],
  [32.82, 35.01],
  [62.48, 6.15],
  [47.47, -70.2],
  [53.37, 3.67],
  [41.12, 29.08],
  [54, -128.7],
  [40.85, 14.28],
  [-2.58, -44.36],
  [26.35, -78.73],
  [47.19, 39.69],
  [-40.98, 144.39],
  [49.6, -6.08],
  [41.45, 31.78],
  [49.12, -123.27],
  [48.37, -123.31],
  [53.9, 9.13],
  [59.87, 30.23],
  [-0.26, 117.57],
  [45.83, 47.97],
  [58.34, -6.86],
  [53.33, 8.48],
  [68.97, 33.08],
  [35.23, 22.63],
  [25.42, 55.45],
  [25.77, -80.18],
  [6.44, 3.39],
  [22.32, 91.82],
  [53.34, 3.76],
  [34.64, 135.42],
  [45.62, -73.5],
  [38.25, 20.5],
  [51.57, -5.14],
  [33.97, 130.88],
  [38.76, 26.92],
  [53.9, 9.13],
  [70.62, 29.72],
  [40.85, 25.95],
  [45.08, 36.48],
  [37.35, 23.47],
  [48.25, -69.17],
  [37.76, 26.97],
  [47.64, -61.5],
  [6.44, 3.39],
  [53.85, 8.98],
  [-27.41, 153.16],
  [49.18, -122.92],
  [53.5, 8.57],
  [-33.45, -60],
  [53.59, 9.61],
  [67.29, 14.4],
  [-6.95, 110.43],
  [33.29, 27.03],
  [45.48, -73.52],
  [62.47, 6.13],
  [34.54, -12.78],
  [60.14, 5.43],
  [1.4, 104.55],
  [53.53, 8.55],
  [48.51, -126.68],
  [50.85, 1.28],
  [42.33, -83.04],
  [59.88, 30.22],
  [37.7, 24.07],
  [36.13, 35.62],
  [51.34, 3.85],
  [6, -58.3],
  [40.15, 26.38],
  [39.28, -76.61],
  [54.15, -4.47],
  [43.62, 13.51],
  [30, 122.1],
  [38.07, 24.72],
  [45.5, -4.33],
  [34.55, -90.64],
  [43.02, -79.22],
  [-5, 110],
  [22.6, 120.27],
  [56.17, 3.43],
  [5.99, 125.14],
  [50.41, -1.13],
  [-27.41, 153.16],
  [64.53, 40.5],
  [56.52, 20.98],
  [41, 28.96],
  [51.18, 1.44],
  [35.5, 27.2],
  [10.29, -64.7],
  [47.78, -54.12],
  [54.33, -130.33],
  [35.58, 140.13],
  [48.43, -68.97],
  [19.62, 37.23],
  [36.92, -79.33],
  [41.12, 29.08],
  [1.52, 104.67],
  [43.1, 131.89],
  [54.33, -131.47],
  [41.38, 9.1],
  [55.22, 12.17],
  [38.7, 118.8],
  [40.42, 26.68],
  [54.8, 10.89],
  [50.83, 1.06],
  [25.07, 34.9],
  [45.15, 36.51],
  [2.5, 5.58],
  [-33.85, 151.23],
  [40.77, 29.58],
  [54.32, 10.13],
  [47.1, -62.8],
  [38.03, 23.5],
  [52.25, -6.33],
  [16.68, 96.53],
  [59.99, 29.77],
  [36.97, 24.72],
  [3.6, 5.6],
  [47.63, -52.92],
  [49.98, -5.7],
  [35.48, 23.63],
  [22.78, 70.12],
  [69.92, 20],
  [4.7, 7.16],
  [41.42, 29.02],
  [40.42, 29.12],
  [47.53, -57.83],
  [39.62, 19.95],
  [1.27, 104.22],
  [28.48, -16.22],
  [60.5, 32.78],
  [53.65, 7.06],
  [54.5, 11.23],
  [54.36, 10.16],
  [45.25, -81.67],
  [43.19, -79.2],
  [36.44, 28.23],
  [6.27, 3.22],
  [48.33, -123.43],
  [-20.32, 118.58],
  [37.75, 23.43],
  [52.57, 2.23],
  [41.45, 29.05],
  [54.37, 10.11],
  [4.74, -6.62],
  [41.12, 16.89],
  [38.73, 26.87],
  [-15.73, 68.8],
  [38.82, 26.94],
  [53.9, -24.17],
  [51.35, 3.77],
  [65.57, -22.15],
  [40.96, 28.89],
  [38.45, 23.6],
  [54.32, 10.13],
  [40.15, 26.4],
  [23.1, 113.23],
  [46.4, -84.24],
  [-26.88, -48.65],
  [51.9, 4.48],
  [24.9, 118.58],
  [40.71, -74.01],
  [37.95, 23.62],
  [35.12, 129.04],
  [50.45, -0.95],
  [40.97, 28.95],
  [8.83, -79.52],
  [-38.73, 178.01],
  [45.41, -73.67],
  [10.3, 123.9],
  [47.12, 39.41],
  [45.97, -62.75],
  [-5, 120],
  [22.2, 91.73],
  [40.01, 26.27],
  [50.39, -0.83],
  [44.63, -63.57],
  [35.15, -90.05],
  [38.45, 23.58],
  [-38.35, 141.61],
  [20.87, 106.67],
  [2.5, 120.35],
  [-4.23, -37.3],
  [50.47, -128.86],
  [23.1, 113.23],
  [-10.6, 142.25],
  [49.02, -123.15],
  [53.68, 7],
  [-6.9, 110.37],
  [42.1, 14.72],
  [51.32, 1.87],
  [28.1, 121.12],
  [51.82, 2.15],
  [40.15, 26.4],
  [57.69, -6.5],
  [36.31, 33.9],
  [51.18, 1.78],
  [49.35, -65.12],
  [10.27, -64.7],
  [40.65, 27.67],
  [57.69, 10.58],
  [34.6, 138.23],
  [33.61, -7.6],
  [62.47, 6.15],
  [45.71, -83.85],
  [54.32, 10.13],
  [37.73, -25.67],
  [38.25, 21.74],
  [1.04, 103.65],
  [39.12, 23.73],
  [-5.53, 150.15],
  [45.34, 36.67],
  [47.8, -54.02],
  [37.94, 23.64],
  [52.82, 1.79],
  [20.68, 107.2],
  [38.92, 118.51],
  [28.5, -13.86],
  [7.15, 125.65],
  [-33.1, -58.32],
  [55.83, -5.05],
  [25.8, 55.95],
  [46.06, -83.84],
  [9.87, 108.03],
  [45.17, -66.12],
  [54.14, -165.77],
  [34.86, 139.49],
  [50.37, -3.05],
  [18.17, -63.05],
  [59.61, -151.35],
  [21.93, 91.38],
  [34.73, 33.36],
  [66.44, 13.06],
  [45.62, -73.5],
  [70.65, 39.4],
  [55.7, 12.62],
  [50.4, -0.45],
  [51.45, 3.58],
  [37.94, 23.64],
  [2.48, 96.38],
  [18.9, 72.82],
  [46.97, -70.82],
  [34.69, 135.2],
  [36.8, 34.64],
  [51.43, 1.45],
  [53.98, 154.3],
  [63.44, 10.4],
  [43.56, 10.31],
  [50.26, -64.77],
  [22.42, 121.43],
  [55.02, -1.18],
  [54.37, 10.13],
  [-4.05, 121.58],
  [51.33, 3.82],
  [14.58, 120.97],
  [22.51, 120.26],
  [47.56, -52.71],
  [36.13, -5.44],
  [16.77, 96.17],
  [48.08, -6.4],
  [49.42, -127.23],
  [38.37, 22.68],
  [64.14, -21.89],
  [34.47, 35.83],
  [47.63, -122.33],
  [1.1, 104.19],
  [41.27, 29.05],
  [35.89, 14.51],
  [-12.02, -77.19],
  [37.96, 23.57],
  [53.38, -2.61],
  [61.65, 4.63],
  [3.8, 98.72],
  [49.64, -1.61],
  [37.44, 24.94],
  [49.93, -3.05],
  [54.24, -130.35],
  [-33.86, 151.21],
  [7.08, 171.13],
  [-0.43, 117.15],
  [50.7, -1.5],
  [45.23, -74.27],
  [51.45, 3.58],
  [54.68, 20.13],
  [42.78, 13.98],
  [-10.17, 123.57],
  [3.08, 6.03],
  [40.47, 17.23],
  [61.77, 6.12],
  [40.97, 28.95],
  [39.26, -32.5],
  [1.44, 104.53],
  [44.42, 8.92],
  [39.17, 23.48],
  [48.26, -69.12],
  [37.7, 24.07],
  [35.33, 139],
  [-34.95, 18.65],
  [34.35, 151.79],
  [1.1, 103.55],
  [40.64, 22.92],
  [34.16, 127.91],
  [40.15, 26.38],
  [63.43, 8.42],
  [53.02, 158.63],
  [48.47, -61.37],
  [63.71, 20.37],
  [38.13, 13.36],
  [38.26, -90.37],
  [49.3, -123.05],
  [55.47, 8.35],
  [46.73, 38.28],
  [41.57, 28.9],
  [27.94, -82.44],
  [45.58, -121.18],
  [59.72, 20.45],
  [39.75, 140.05],
  [29.92, -90.09],
  [36.8, 34.64],
  [34.06, 133.06],
  [58.7, 22.52],
  [-9.07, -78.59],
  [1.68, 101.45],
  [36.9, 7.76],
  [50.02, -66.78],
  [52.15, 3.55],
  [30.08, -94.09],
  [34.6, 138.23],
  [30.47, -91.2],
  [1.68, 101.45],
  [54.28, -130.87],
  [51.47, 0.27],
  [52.18, 156.14],
  [1.18, 103.45],
  [7.47, -81.78],
  [58.98, -2.95],
  [37.06, 25.6],
  [56.9, -6.5],
  [50.78, -1.27],
  [29.21, -68.52],
  [59.4, 166.25],
  [49.7, -1.64],
  [35.12, -21.26],
  [46.18, -123.83],
  [38.44, 27.16],
  [52.16, -128.13],
  [29.73, -93.88],
  [59.35, 17.82],
  [44.65, -63.58],
  [42.02, 29.51],
  [14.53, 49.13],
  [45.62, -73.5],
  [40.18, 26.36],
  [33.23, 134.83],
  [48.69, -123.41],
  [55.47, 8.43],
  [45.45, 36.86],
  [1.35, 104.23],
  [34.49, 133.73],
  [29.76, -95.09],
  [36.42, 35.85],
  [49.67, -54.18],
  [40.85, 14.28],
  [51.45, 3.62],
  [50.72, -1.98],
  [49.82, -5.47],
  [51.77, 3.29],
  [31.82, 34.65],
  [47.17, -85.92],
  [36.44, 28.23],
  [54.4, 11.97],
  [56.52, 10.22],
  [50.23, -1.47],
  [39.36, 20.16],
  [53.87, 10.67],
  [44.12, -82.68],
  [65.85, 24.15],
  [4.43, 7.45],
  [53.55, 8.58],
  [45.55, -73.53],
  [37.76, 26.97],
  [40.97, 28.93],
  [58.61, -5.66],
  [54.2, 9.53],
  [38.92, 19.32],
  [-27.15, -109.43],
  [59.87, 30.23],
  [25.78, -80.19],
  [42.95, -82.43],
  [43.97, -82.17],
  [40.97, 28.93],
  [37.62, 24.98],
  [36.12, -5.42],
  [44.74, 37.79],
  [32.38, 15.25],
  [9.3, -13.75],
  [50.98, 1.05],
  [46.4, -72.38],
  [58.73, -5.63],
  [69.05, 33.13],
  [40, 135],
  [14.78, 42.95],
  [55.7, 12.62],
  [31.25, 32.3],
  [14.58, 120.97],
  [-34.75, -57.83],
  [52.48, 4.56],
  [31.4, 130.52],
  [48.69, -123.41],
  [37.94, 23.64],
  [53.55, 9.81],
  [46.85, 31.97],
  [42.98, 144.37],
  [51.95, 7.98],
  [40.96, 28.89],
  [-31.52, -60.28],
  [-2.74, 111.73],
  [50.97, -127.77],
  [33.75, -118.28],
  [51.22, 1.73],
  [44.1, 9.86],
  [12.93, 74.81],
  [41.27, 29.03],
  [46.55, -72.13],
  [41.18, 29.05],
  [1.44, 103.9],
  [19.05, -104.33],
  [4, 9.4],
  [43.56, 10.31],
  [53.9, 9.13],
  [40.83, 29.25],
  [40.04, 26.32],
  [40.97, 28.93],
  [43.61, -77.96],
  [24.28, -87.87],
  [54.32, 10.13],
  [47.12, 39.35],
  [-2.13, 120.28],
  [36.84, -2.48],
  [64.53, 40.5],
  [39.83, 26.07],
  [52.4, 1.78],
  [49.64, -1.61],
  [13.32, 43.23],
  [48.24, -61.77],
  [49.13, -123.07],
  [45.78, 13.22],
  [63.68, 9.67],
  [3.62, 7.12],
  [-3.72, 114.42],
  [46.77, -59.28],
  [37.1, 137.03],
  [49.32, -123.13],
  [52.1, 4.25],
  [29.78, 122.08],
  [51.26, 4.39],
  [49.17, -123.87],
  [25.23, 56.52],
  [1.7, 101.5],
  [-33.02, -71.63],
  [35.2, 24.9],
  [37.44, 24.94],
  [47.32, -70.52],
  [51.25, 1.8],
  [57.15, -2.07],
  [49.3, -123.06],
  [58.2, -6.38],
  [42.64, 141.67],
  [46.25, -45.62],
  [-29.87, 31.03],
  [43.72, 15.78],
  [53.55, 8.58],
  [25.18, 56.36],
  [40.64, -74.07],
  [-5.87, 105.75],
  [42.52, -79.92],
  [46.83, 31.95],
  [59.99, 5.31],
  [49.12, -4.58],
  [49.23, -123.82],
  [40.15, 26.4],
  [3.13, 6.21],
  [53.07, 1.45],
  [40.64, 22.92],
  [63.52, 8.4],
  [53.63, -0.19],
  [60.85, 172.42],
  [10.19, -64.87],
  [37.95, 21.15],
  [43.19, 29.36],
  [40.84, 29.28],
  [36.3, 30.15],
  [10.2, 107.07],
  [41.27, 29.06],
  [52, 3.9],
  [46.4, -72.38],
  [35.98, 126.63],
  [16.28, 82.27],
  [71.55, 46.78],
  [51.3, -127.87],
  [45.55, 13.72],
  [51.25, 6.77],
  [50.37, -0.93],
  [54.2, -130.52],
  [1.27, 103.83],
  [54.09, 12.14],
  [41.12, 29.09],
  [50.47, -0.33],
  [57.95, 16.87],
  [-2.13, 120.28],
  [46.06, -122.88],
  [-14.3, -134.96],
  [48.28, -4.72],
  [48.74, -69.05],
  [44.6, 33.53],
  [13.77, 109.23],
  [20.87, 106.67],
  [35.44, 139.66],
  [55.71, 9.55],
  [46.55, -4.33],
  [-32.06, 115.75],
  [53.53, 0.28],
  [35.73, 141.08],
  [41.22, 29.22],
  [50.75, -1.13],
  [50.7, -0.22],
  [53.08, 7.37],
  [13.92, -90.82],
  [1.41, 104.06],
  [60.85, 5.07],
  [40.7, -74.02],
  [54.93, 10.25],
  [35.76, -14.56],
  [50, -4.5],
  [3.93, 7],
  [56.61, 10.35],
  [45.85, -73.28],
  [67.28, 14.38],
  [-34.47, 150.89],
  [35.48, 24.05],
  [50.62, -0.62],
  [37.96, 23.57],
  [12.05, -61.75],
  [37.94, 23.64],
  [50.76, 0.3],
  [58.8, -3.21],
  [59.98, 31.13],
  [62.47, 6.15],
  [43.1, 131.89],
  [41.18, 29.05],
  [40.64, 22.92],
  [36.97, -89.08],
  [51.52, -5.98],
  [54.63, 10.73],
  [46.36, 48.04],
  [51.26, 4.39],
  [34.69, 135.2],
  [50.68, -59.23],
  [35.08, 24.15],
  [47.48, -3.12],
  [46.36, 48.04],
  [1.27, 103.83],
  [49.19, -122.92],
  [45.09, 36.79],
  [53.55, 9.98],
  [44.74, 37.79],
  [-0.29, 117.66],
  [54.32, -130.32],
  [37.17, 24.2],
  [34.64, 135.42],
  [15.42, 73.8],
  [55.88, 9.13],
  [22.03, 91.78],
  [53.31, -4.63],
  [-33.92, 18.44],
  [3.37, 5.23],
  [41.27, 29.05],
  [49.28, -123.07],
  [3.43, 6.1],
  [61.4, 3.3],
  [43.1, 131.89],
  [56.53, 21.01],
  [44.14, 28.64],
  [46.57, -72.02],
  [58.06, 14.34],
  [60.16, 24.94],
  [16.8, -16.85],
  [41.5, -74.08],
  [42.4, -82.87],
  [11.19, -74.86],
  [43.1, 131.89],
  [40.97, 28.92],
  [54.65, 19.9],
  [-41.28, 174.78],
  [43.85, -78.82],
  [54.32, 10.13],
  [56.7, 8.22],
  [50.32, -0.75],
  [-20.54, 117.36],
  [12.97, 74.7],
  [13.77, 109.23],
  [66.35, 12.09],
  [-7.7, 130.93],
  [10.93, 108.1],
  [41.4, -70.62],
  [48.43, -71.06],
  [38.76, 26.92],
  [44.27, 8.43],
  [62.37, 6.03],
  [22.59, 120.31],
  [40.15, 26.4],
  [-0.27, 117.72],
  [53.9, 9.15],
  [18.47, -66.12],
  [46.36, 48.04],
  [54.32, 10.13],
  [40.68, 29.45],
  [41.33, 29.05],
  [-6.1, 106.89],
  [10.32, 123.92],
  [47.05, -59.16],
  [36.63, 23.48],
  [45.32, -73.9],
  [55.57, 10.08],
  [57.57, 39.87],
  [22.68, 113.68],
  [32.77, 132.4],
  [15.69, -88.62],
  [35.58, 140.13],
  [36.84, -2.48],
  [47.19, 29.01],
  [39.62, 19.95],
  [0.07, -50.98],
  [12.57, 109.47],
  [28.15, -15.4],
  [29.93, -90.05],
  [-20.68, 116.69],
  [51.82, 3.45],
  [29.75, 126],
  [51.14, 1.55],
  [49.13, -123.02],
  [48.33, -70.87],
  [46.63, 32.61],
  [20.92, 107.28],
  [34.73, 10.77],
  [35.58, 140.13],
  [37.27, 26.95],
  [35.66, 139.99],
  [40.82, 28.99],
  [35.72, 12.77],
  [42.8, 132.88],
  [69.65, 18.96],
  [64.53, 40.5],
  [40.96, 28.89],
  [35.15, -90.05],
  [22.25, 91.68],
  [38.25, 21.74],
  [53.17, 5.41],
  [54.72, 20.52],
  [53.55, 9.97],
  [12.53, 43.53],
  [3.79, 98.7],
  [54.15, 12.12],
  [-49.15, -74.45],
  [49.93, -64.95],
  [33.95, 131.25],
  [39.25, 26.66],
  [55.47, 148.23],
  [51.57, 1.83],
  [51.5, -55.48],
  [42.33, -70.95],
  [46.61, 31.01],
  [33.61, -7.6],
  [38.04, 27.03],
  [55.9, 10.25],
  [49.32, -123.14],
  [11.98, 74.35],
  [40.92, 24.42],
  [31.82, 34.65],
  [5.63, 0.01],
  [62.22, 135.83],
  [1.5, 1.26],
  [59.15, 37.83],
  [61.07, 28.27],
  [23.13, -82.35],
  [3.33, 7.02],
  [4.35, 3.83],
  [47.95, -125.25],
  [36.42, 22.37],
  [54.26, 9.62],
  [44.98, -74.77],
  [55, -58.38],
  [45.3, 47.75],
  [50.25, -1.42],
  [37.94, 23.64],
  [45.66, -73.48],
  [22.28, 91.72],
  [48.49, -68.52],
  [53.23, 6.22],
  [-39.07, 174.08],
  [37.35, 23.47],
  [47.56, -52.71],
  [42.93, 132.32],
  [47.63, -70.13],
  [44.74, 37.79],
  [61.08, 1.9],
  [60.72, 33.55],
  [35.32, 33.98],
  [6.98, 79.68],
  [50.4, -1.66],
  [-25.35, -42.86],
  [-20.85, 116.2],
  [42, 35.15],
  [47.63, -52.97],
  [48.72, -125.73],
  [48.41, -62.21],
  [22.57, 114.44],
  [62.62, 6.5],
  [-3.78, 102.25],
  [8.48, 124.65],
  [17.91, -62.87],
  [38.3, 21.8],
  [51.8, 4.9],
  [55.59, 15.29],
  [20.73, 79.49],
  [54.55, 14.75],
  [45.31, -73.93],
  [-23.93, -46.33],
  [40.87, 29.22],
  [1.05, 103.07],
  [47.85, -69.86],
  [51.16, -4.65],
  [1.22, 103.56],
  [50.53, -0.3],
  [43.88, 8.03],
  [40.95, 28.9],
  [11.65, 43.18],
  [44.42, 8.92],
  [45.58, -73.5],
  [-37.65, 176.17],
  [26.07, 119.3],
  [32.37, 15.23],
  [54.72, 20.52],
  [11.68, 75.48],
  [50.06, -5.88],
  [44.81, 47.82],
  [14.58, 120.97],
  [54.65, 19.9],
  [44.47, -63.48],
  [-21.29, 149.28],
  [40.89, 29.19],
  [40.65, 27.67],
  [36.3, 126.45],
  [41.62, 141.12],
  [44.98, -74.85],
  [48.42, -123.4],
  [38.53, 137.15],
  [42.37, -70.9],
  [5.93, 118.23],
  [69.65, 18.96],
  [22.78, 70.07],
  [53.88, 9.13],
  [52.4, 4.88],
  [35.44, 139.66],
  [40.28, 131.69],
  [22.78, 70.07],
  [53.32, 8.48],
  [54.32, 10.13],
  [13.08, 80.28],
  [51.83, 3.57],
  [25.25, 56.6],
  [38.92, 121.65],
  [37, 26.48],
  [43.4, 3.7],
  [46.32, -60.15],
  [15.83, -87.97],
  [60, 38],
  [60.25, -1.99],
  [30.9, -84.62],
  [50.28, -6.08],
  [60.76, 4.64],
  [47.12, 39.41],
  [35.34, 25.15],
  [37.22, 15.64],
  [48.84, -67.57],
  [-20.78, 115.53],
  [6.44, 3.39],
  [57, 160],
  [31.25, 121.5],
  [49.3, -123.08],
  [39.62, 19.95],
  [45.88, -53.94],
  [3.85, 6.67],
  [12.58, 122.27],
  [60.62, -1.1],
  [51.78, 4.63],
  [34.95, 24.47],
  [49.49, -9.37],
  [48.72, -123.42],
  [50.86, 0.95],
  [47.28, -55.9],
  [-22.37, -40.42],
  [43.1, 131.92],
  [58.08, -6.43],
  [22.21, 91.79],
  [51.77, 2.2],
  [22.27, 91.82],
  [51.57, -4.6],
  [12.87, 109.42],
  [53.87, 9.06],
  [49.28, -123.17],
  [49.48, 0.52],
  [22.2, 91.74],
  [40.97, 28.94],
  [52.53, 3.4],
  [7.61, 89.11],
  [8.13, 114.41],
  [-19.55, -89.27],
  [10.86, -64.06],
  [29.3, -94.8],
  [3.25, 5.17],
  [21.4, 72.15],
  [50.84, 1.03],
  [59.92, 26.18],
  [-2.88, 107.27],
  [40.01, 26.26],
  [-10.5, 142.23],
  [-25.49, -48.49],
  [60.38, 10.38],
  [55.5, 9.5],
  [48.39, -4.47],
  [68.23, 14.57],
  [49.82, 6.75],
  [49.3, -123.05],
  [-40, -76],
  [48.72, -69.02],
  [40.71, -74.01],
  [40.77, -74],
  [42.5, 27.47],
  [50.67, -1.27],
  [29.21, -89.29],
  [60.1, 19.92],
  [44.85, -87.35],
  [70.66, 23.68],
  [12.48, -70],
  [25.18, 119],
  [37.47, 25.33],
  [42.87, -79.23],
  [41.44, 29.02],
  [61.08, 34.85],
  [2.05, 104.98],
  [54.16, 12.11],
  [37.97, 23.57],
  [10.23, 66.27],
  [53.89, 9.18],
  [10.32, 123.92],
  [37.93, 23.63],
  [9.78, 125.48],
  [42.8, 132.88],
  [37, 126.79],
  [59.12, 6.1],
  [19.42, 127.67],
  [4.89, -1.75],
  [49.29, -123.17],
  [30.37, -91.23],
  [-8.3, 114.42],
  [37.97, 23.62],
  [49.67, -3.82],
  [46.31, -72.57],
  [51.62, 156.22],
  [41, 28.97],
  [53.53, 9.95],
  [63.4, 8.88],
  [1.12, 104.17],
  [51, 1.42],
  [-35.32, 23.48],
  [13.8, 55.85],
  [41, 28.96],
  [42.68, 9.45],
  [49.23, -68.14],
  [21.31, -157.86],
  [53.02, 158.63],
  [49.28, -123.11],
  [46.33, -72.53],
  [43.1, 131.89],
  [54.88, 9.13],
  [57.05, 10.06],
  [66.12, 12.85],
  [47.19, 39.69],
  [50, -65.78],
  [25.07, -77.32],
  [41.1, 29.07],
  [47.12, 39.41],
  [49.11, -123.16],
  [40.89, 29.19],
  [49.15, -123.03],
  [37.02, 22.11],
  [51.38, 4.03],
  [48.75, 44.5],
  [13.7, 100.57],
  [62.43, 6.18],
  [31.24, 16.35],
  [78.24, 13.83],
  [36.59, 36.19],
  [37.78, 20.9],
  [52.7, 2.7],
  [47.12, 39.41],
  [40.37, 28.88],
  [54.92, 11.35],
  [31.2, 29.89],
  [28.13, -15.43],
  [30.05, -90.85],
  [44.3, 8.48],
  [57.59, 9.97],
  [28.68, 121.43],
  [40.87, 29.33],
  [50.6, -127.08],
  [29.78, 150.34],
  [49.18, 122.9],
  [41, 28.96],
  [37.75, 23.43],
  [38.01, 24.87],
  [61.59, 4.95],
  [49.8, -3.42],
  [-37.52, 25.72],
  [-33.86, 151.21],
  [34.65, 33.01],
  [53.9, 9.13],
  [64.17, -51.72],
  [54.15, 9.37],
  [52.41, 4.75],
  [43.07, 131.85],
  [58.58, 4.9],
  [56.9, -9.68],
  [40.77, 28.88],
  [50.3, -1.1],
  [-2.65, -80.03],
  [50.73, -1.15],
  [33.95, 131.25],
  [55.72, 12.92],
  [59.91, 10.73],
  [44.12, 15.23],
  [38.19, 15.56],
  [49.74, -124.84],
  [45.34, 36.67],
  [63.1, 21.62],
  [40.15, 26.4],
  [54.09, 12.14],
  [-41.27, 174.79],
  [51.5, 2],
  [40.97, 28.94],
  [18.48, -64.39],
  [19.47, 129.6],
  [55.94, -4.72],
  [50.58, -59.14],
  [58.24, 6.66],
  [35.78, 14.83],
  [54.32, 10.13],
  [40.42, 26.68],
  [38.8, -77.05],
  [22.59, 120.31],
  [22.32, 91.82],
  [41.2, 29.12],
  [39.62, 19.95],
  [44.83, 75.31],
  [-6.87, 112.78],
  [38.03, 23.5],
  [6.32, 3.4],
  [41.25, 29.07],
  [53.63, 7.16],
  [10.69, 122.58],
  [55.33, -4.08],
  [28.42, -80.58],
  [54.03, -2.92],
  [34.17, 133.33],
  [55.94, -4.72],
  [48.85, -67.55],
  [43.67, -77.63],
  [38.35, 21.42],
  [9.5, 118.5],
  [37.97, 23.57],
  [40.78, 29.61],
  [47.57, -52.68],
  [47.12, 39.45],
  [40.64, 22.92],
  [53.41, 6.21],
  [13.75, 121.05],
  [31.13, 29.79],
  [50.43, -0.47],
  [9.35, -79.91],
  [37.98, 23.98],
  [53.6, 0.22],
  [-24.12, -46.32],
  [38.26, -85.75],
  [36.45, 28.25],
  [5.59, 5.38],
  [51.45, 3.58],
  [25, 120],
  [49.04, -123.11],
  [66.05, -129.1],
  [10.65, -61.52],
  [51.67, -5.28],
  [53.9, 9.14],
  [18.12, -94.4],
  [26.1, -80.12],
  [47.45, -70.22],
  [60.1, 5.25],
  [37.94, 23.64],
  [41.43, 131.32],
  [53.52, 0.32],
  [58.93, 11.17],
  [40.84, 29.29],
  [16.84, 112.35],
  [36.42, 25.43],
  [44.43, -63.47],
  [49.74, -4.3],
  [60.78, 5.28],
  [46.29, -123.46],
  [48.72, -122.5],
  [60.18, 5.24],
  [-7.2, 112.73],
  [18.98, 72.83],
  [38.76, 26.92],
  [43.03, -70.69],
  [41.35, 29.15],
  [62.6, 6.45],
  [29.3, -94.8],
  [30, 125],
  [38.08, 20.92],
  [47.57, -122.62],
  [55.72, 15.73],
  [-33.92, 18.43],
  [48.12, -4.31],
  [69.65, 18.96],
  [38.37, 22.68],
  [46.27, -72.62],
  [53.78, 7.22],
  [35.12, 129.04],
  [1.34, 104.29],
  [53.17, 5.41],
  [6.25, 2.5],
  [6.36, 119.89],
  [35.58, 140.13],
  [68.57, 14.92],
  [25.37, 55.38],
  [12, 113],
  [37.13, -8.53],
  [50.62, -126.77],
  [42.15, 41.66],
  [4.72, 101.42],
  [51.03, 2.35],
  [37.94, 23.64],
  [48.72, -123.37],
  [50.75, -1.15],
  [54.09, 12.14],
  [46.02, -73.18],
  [55.34, 10.99],
  [26.42, 56.48],
  [68.73, 16.85],
  [48.32, 14.3],
  [1.07, 103.62],
  [36.65, 13.87],
  [20.85, 106.68],
  [41.18, 29.05],
  [51.13, 1.34],
  [48.47, -125.25],
  [38.03, 134.34],
  [40.64, 22.92],
  [1.23, 103.59],
  [4.42, 7.15],
  [1.17, 103.83],
  [44.72, -92.75],
  [6.24, 16.11],
  [40.92, 24.42],
  [51.89, 4.31],
  [45.34, 36.67],
  [1.17, 103.39],
  [54.7, -1],
  [49.72, -2.2],
  [49.39, -123.28],
  [19.05, -104.33],
  [50.27, -1.36],
  [45.34, 36.67],
  [64.47, 40.6],
  [20.98, -97.33],
  [-20.16, 57.5],
  [59.87, 30.23],
  [48.92, -125.57],
  [10.96, -74.77],
  [54.32, 10.13],
  [30, 122.1],
  [60.34, 5.07],
  [65.62, -23.55],
  [-13.73, -172.17],
  [1.68, 101.48],
  [55.77, -4.88],
  [16.98, 82.3],
  [49.19, -124.82],
  [-7.2, 112.73],
  [16.77, 96.17],
  [52.94, 4.41],
  [57.84, -3.34],
  [57.2, -1.97],
  [-5.87, 105.75],
  [42.92, 131.47],
  [48.94, -2.4],
  [33.98, 28.37],
  [58.03, -7.25],
  [45.32, -73.92],
  [12.42, -62.05],
  [43.36, -8.4],
  [45.5, -73.53],
  [59.15, 37.83],
  [43.27, -79.84],
  [59.97, 30.17],
  [5.98, -55.2],
  [23.1, 113.23],
  [51.64, 1.37],
  [-5.92, 106],
  [19.17, 105.67],
  [35.58, 140.13],
  [0.65, 101.62],
  [48.41, -123.39],
  [22.27, 91.8],
  [61.17, 7.25],
  [36.83, 30.62],
  [53.62, 0.35],
  [48.85, -67.55],
  [54.56, 155.6],
  [34.6, 138.23],
  [10.22, -64.63],
  [-1.93, 108.14],
  [45.5, -73.67],
  [32.32, -64.83],
  [34.72, 136.93],
  [55.49, 9.58],
  [40.44, 29.11],
  [44.59, 37.92],
  [53.07, 4.35],
  [60.53, 5.26],
  [46.3, -72.57],
  [9.12, -79.72],
  [62.02, 129.73],
  [62.44, 6.27],
  [46.48, 84.29],
  [64.03, 9.61],
  [48, -62.65],
  [2.35, 104.37],
  [50.69, 0.66],
  [33.75, -118.28],
  [42.45, -62.25],
  [49.28, -122.97],
  [6.82, -58.18],
  [3.88, 7.08],
  [-44.38, 171.25],
  [36.63, 1.36],
  [-21.64, 115.11],
  [43.1, 131.89],
  [38.25, 21.74],
  [45.5, -73.53],
  [41.28, 29.04],
  [58, 20],
  [54.08, 13.38],
  [29.97, 32.55],
  [41, 28.96],
  [36.59, 36.19],
  [1.07, 103.66],
  [46.87, -70.95],
  [51.42, 1.45],
  [33.83, 132.7],
  [45.13, 36.69],
  [54.9, 155.9],
  [2.67, 98.94],
  [36.75, 27.73],
  [8.45, -13.47],
  [60.78, -148.67],
  [69.96, 19.62],
  [36.85, 28.28],
  [56.63, 8.32],
  [46.57, -72.12],
  [48.39, -4.47],
  [-33.63, -59.71],
  [50.61, -6.21],
  [38.85, 118.6],
  [34.35, 135.02],
  [44.62, 37.9],
  [1.27, 103.83],
  [54.61, -5.92],
  [49.08, 140.27],
  [54.93, 20.2],
  [51.47, -54.08],
  [8.98, -79.52],
  [37.03, 22.12],
  [42.24, -8.73],
  [49.23, -123.23],
  [36.85, 28.28],
  [37.38, 23.97],
  [41, 28.96],
  [42.98, -82.42],
  [51.42, -57.13],
  [49, -66.97],
  [37.5, 23.47],
  [42.88, 79.23],
  [53.9, 9.13],
  [32.82, -17],
  [54.01, -128.7],
  [-12.02, -77.19],
  [42.63, 18.12],
  [52.15, 3.68],
  [1.15, 103.45],
  [45.61, -73.5],
  [53.31, -4.63],
  [53.17, 50.17],
  [45.33, 28.85],
  [13.48, 50.03],
  [52, -4],
  [56.85, 11.8],
  [35.58, 140.13],
  [48.43, -61.85],
  [69.63, 18.95],
  [43.38, 4.82],
  [10.18, -64.85],
  [28.68, -17.77],
  [55.88, -4.89],
  [48.52, -68.59],
  [38.32, 22.14],
  [-33.93, 18.23],
  [41.64, -70.92],
  [60.63, 28.57],
  [41.22, 29.38],
  [27.93, -82.44],
  [64.86, 11.24],
  [1.25, 104.12],
  [53.25, 1.22],
  [30, 122.1],
  [41.17, 141.22],
  [10.65, -61.52],
  [30.1, -90.91],
  [10.33, -75.51],
  [33.9, 130.9],
  [10.32, 123.75],
  [37.97, 23.57],
  [51.41, 3.58],
  [53.86, 8.71],
  [44.58, -56.71],
  [51.37, 3.92],
  [69.73, 30.05],
  [40.85, 14.28],
  [1.25, 104.18],
  [45.28, -73.92],
  [36.72, 25.27],
  [38.2, 20.45],
  [41.12, 29.07],
  [48.22, -125.42],
  [40.92, 24.42],
  [32.98, 132.01],
  [47.42, -70.38],
  [-5.87, 106.02],
  [5.99, 116.08],
  [36.58, 36.18],
  [37.94, 23.64],
  [59.97, 30.17],
  [16.77, 96.17],
  [41.27, 31.4],
  [-0.95, 122.8],
  [55.94, -4.72],
  [19.1, 108.62],
  [6.45, 3.37],
  [41.15, 29.05],
  [33.27, 131.51],
  [25.78, -80.19],
  [50.18, -66.37],
  [49.75, 6.63],
  [54.69, -5.77],
  [42.75, 133.08],
  [54.09, 12.14],
  [56.53, 21.01],
  [40.41, 29.09],
  [46.06, -73.12],
  [45.22, -74.07],
  [32.08, -81.09],
  [56.7, 8.22],
  [41.02, 9.58],
  [57.5, -1.78],
  [47.61, -122.49],
  [40.88, 29.25],
  [59.71, -165.72],
  [9.9, 96.83],
  [37.94, 23.64],
  [34.35, 134.05],
  [68.97, 33.08],
  [41.28, 29.02],
  [25.14, 121.75],
  [13.71, 121.05],
  [40.78, 28.82],
  [48.32, -61.17],
  [40.4, 29.07],
  [36.97, 24.72],
  [49.31, -123.13],
  [56.9, -7.1],
  [43.5, 16.45],
  [14.58, 120.93],
  [-22.42, -39.95],
  [62.23, -75.66],
  [22.78, 119.6],
  [36.07, 125.78],
  [50.7, -1.5],
  [51.9, 4.48],
  [3.17, 113.03],
  [55.23, 12.85],
  [-35.03, -56.02],
  [5.28, 2.21],
  [50.15, -0.62],
  [-19.26, 146.83],
  [37.97, 23.57],
  [46.36, 48.04],
  [45.52, -73.52],
  [46.36, 48.04],
  [-8.17, 114.43],
  [-29.87, 31.03],
  [49.27, -123.17],
  [1.27, 104.03],
  [48.71, -61.93],
  [-28.05, 32.6],
  [21.67, 72.42],
  [50.85, 1.1],
  [61.8, -120.72],
  [50.81, 0.98],
  [38.44, 27.16],
  [47.09, 39.29],
  [57.58, -7.15],
  [60.15, 5.43],
  [49.59, -64.6],
  [49.94, -125],
  [-5.93, 105.98],
  [-34.47, 150.89],
  [4.89, -1.75],
  [51.46, 0.35],
  [-29.9, 31.27],
  [48.33, -70.87],
  [62.03, -6.83],
  [42.7, 9.45],
  [53.55, 9.98],
  [59.78, 5.52],
  [49.78, -124.18],
  [10.3, -75.53],
  [50.39, -4.18],
  [40.15, 26.4],
  [51.6, 2.17],
  [45.32, -73.92],
  [43.2, -79.2],
  [41.45, 31.78],
  [54.13, 8.86],
  [58.23, 12.18],
  [53.56, 9.81],
  [53.95, -3.06],
  [50.83, 0.83],
  [39.28, -76.61],
  [-5, 120],
  [42.82, -82.47],
  [60.77, 4.93],
  [49.65, -1.6],
  [44.88, 31.15],
  [54.17, 12.08],
  [40.97, 28.92],
  [-34.59, -58.38],
  [35.44, 129.44],
  [61.07, 36.45],
  [42.85, 133.08],
  [61.35, 5.07],
  [54.05, 13.78],
  [53.38, -4.17],
  [13.2, 80.4],
  [35.48, 129.4],
  [60.43, 22.22],
  [54.33, 10.13],
  [53.75, -0.3],
  [45.35, -73.89],
  [41.98, 35.13],
  [32.22, 119.41],
  [56.53, 21.01],
  [54.08, -3.73],
  [-8.52, 121.33],
  [-41.18, 146.35],
  [61.13, -146.35],
  [6.34, -10.8],
  [9.05, 97.06],
  [40.41, 29.09],
  [51.9, -8.47],
  [51.85, 146.82],
  [-8.57, 116.35],
  [46.5, -84.4],
  [46.48, -84.3],
  [-20.15, 57.48],
  [51.89, 4.4],
  [54.32, 10.13],
  [42.25, -83.1],
  [69.65, 18.96],
  [25.14, 121.75],
  [49.87, -64.58],
  [26.1, 122.03],
  [61.1, 5.5],
  [48.3, 125.12],
  [59.41, 5.27],
  [-0.25, 117.62],
  [52.75, 4.08],
  [40.15, 25.83],
  [40.87, 29.33],
  [32.82, 35.01],
  [44.14, 28.64],
  [35.13, 33.95],
  [22.32, 91.82],
  [54.84, -5.53],
  [51.87, -127.92],
  [48.1, -4.33],
  [42.45, 18.66],
  [37.15, -6.88],
  [34.49, 133.73],
  [10.41, 107.14],
  [40.95, 28.9],
  [46.4, -72.37],
  [22.58, 88.35],
  [63.43, 10.4],
  [44.14, 28.64],
  [22.17, 114.12],
  [42.88, -79.24],
  [43.57, 44.15],
  [46.83, -71.12],
  [48.95, -125.36],
  [37.94, 23.64],
  [34.01, 129.49],
  [35.69, 139.98],
  [37.5, 23.47],
  [45.2, -74.27],
  [48.39, -4.47],
  [36.47, 122.77],
  [33.9, 35.52],
  [28.48, -16.23],
  [47.19, 39.69],
  [18.42, -70.01],
  [53.67, 7.58],
  [45.1, 147.89],
  [2.37, 46.1],
  [4.05, 9.7],
  [54.05, 7.47],
  [54.32, 10.13],
  [50.23, -1.5],
  [41.15, 29.03],
  [47.79, 60.62],
  [41.8, -82.45],
  [-33.47, -59.95],
  [61.84, 20.99],
  [51.42, -57.15],
  [4.89, -1.75],
  [37.57, 23.95],
  [39.5, 24.03],
  [53.92, 8.72],
  [51.4, 2.58],
  [-20.15, 57.5],
  [45.34, 36.67],
  [49.31, -123.06],
  [5.83, -55.17],
  [42.28, -83.08],
  [45.25, -74.18],
  [45.87, 141.92],
  [40.02, 26.28],
  [44.68, -63.61],
  [31.38, 31.8],
  [51.36, 1.03],
  [47.77, -54.03],
  [22.77, 70],
  [-33.86, 151.21],
  [68.77, 17.18],
  [-4.03, 116.03],
  [30.4, 137.87],
  [6.8, -68.17],
  [5.52, 5.73],
  [51.13, 1.32],
  [46.28, -72.62],
  [3.97, 6.2],
  [40.8, 28.95],
  [32.92, 13.23],
  [54.6, 4.21],
  [62.17, 28.06],
  [-45.86, -67.48],
  [44.07, -76.72],
  [53.55, 9.98],
  [36.14, -5.35],
  [50.83, -130.03],
  [51.55, 7.32],
  [-34.72, 19.4],
  [51.45, 1.92],
  [46.2, 150.83],
  [27.97, -15.6],
  [1.68, 101.45],
  [10.37, 124.07],
  [54.92, 9.78],
  [40.45, 27.13],
  [10.41, 107.14],
  [-33.37, -60.11],
  [37.7, 24.07],
  [40.76, 29.76],
  [41, 39.75],
  [42.93, 10.55],
  [31.75, 121.11],
  [41, 9.62],
  [51.6, -5.25],
  [21.93, 91.38],
  [23.98, -81.82],
  [47.19, -70.59],
  [54.09, 7.89],
  [46.61, 31.01],
  [49.48, -124.13],
  [44.63, 33.57],
  [0.99, -79.65],
  [40.83, 8.37],
  [51.6, -55.85],
  [4.13, 5.4],
  [1.12, 104.19],
  [50.19, -2.53],
  [61.85, 6.07],
  [30.35, 32.38],
  [25.37, 55.38],
  [54.8, 9.44],
  [5.78, 118.84],
  [7.09, 79.65],
  [54.37, 10.17],
  [31.47, 131.12],
  [43.13, 131.9],
  [41.12, 29.08],
  [3, 101.4],
  [-34, 151.34],
  [-43.6, 172.78],
  [47.82, -62.42],
  [50.68, -1.95],
  [34.5, 135.3],
  [34.23, 137.13],
  [54.32, 10.13],
  [51.9, -8.47],
  [-20.15, 57.48],
  [34.35, 134.05],
  [63.11, 7.73],
  [53.54, 9.97],
  [22.32, 91.82],
  [10.13, 107.11],
  [49.52, -4],
  [51.33, 2.57],
  [41.37, 19.42],
  [58.34, -138.26],
  [40.4, 29.07],
  [63.32, 9.85],
  [64.53, 40.5],
  [50.83, -0.25],
  [48.12, -69.6],
  [46.36, 48.04],
  [64.14, -21.89],
  [49.04, -123.11],
  [41.26, 29.08],
  [12, 48],
  [36.95, 26.98],
  [51.23, -127.87],
  [18, -63.03],
  [48.85, -127.37],
  [54.16, 12.11],
  [46.02, -83.92],
  [-2.18, 107.05],
  [52.27, -128.68],
  [30.04, 47.96],
  [43.35, -79.01],
  [49.77, -3.41],
  [51.9, 4.48],
  [52.26, 2.02],
  [41.12, 29.09],
  [55.73, 5.55],
  [30.47, -91.18],
  [53.58, 6.95],
  [47.09, 39.24],
  [-32.18, 29.37],
  [36.42, 25.45],
  [-3.48, -4.52],
  [51.47, 1.6],
  [48.39, -89.22],
  [51.9, 4.48],
  [52.93, 1.69],
  [39.57, 2.63],
  [45.02, -74.72],
  [48.83, -64.44],
  [49.46, -123.93],
  [18.58, -72.53],
  [40.97, 28.68],
  [36.14, -5.35],
  [45.43, 12.33],
  [3.39, 6.37],
  [41.45, 29.28],
  [49.18, -23.21],
  [37.6, 25.13],
  [68.97, 33.08],
  [53.96, 8.62],
  [56.15, 10.22],
  [41, 39.73],
  [0.34, -50.62],
  [40.4, 27.3],
  [-41, -68],
  [21.2, 72.2],
  [55.83, -5.05],
  [62.47, 6.22],
  [49.84, -3.23],
  [1.21, 103.57],
  [60.04, 5.34],
  [44.71, -75.49],
  [40.23, 25.95],
  [55.95, 12.62],
  [5.22, -4.04],
  [52.82, 4.2],
  [46.44, -72.3],
  [48.32, -69.39],
  [55.46, 10.52],
  [-55.39, -65.91],
  [48.4, -89.22],
  [53.63, 5.04],
  [59.28, 5.3],
  [52.37, 9.72],
  [52.45, 4.58],
  [43.49, -79.61],
  [30, 122.1],
  [52.6, 155.58],
  [-20.13, 57.48],
  [54.38, -0.12],
  [53.73, 8.22],
  [45.15, 36.51],
  [-0.27, 117.6],
  [59.37, 143.26],
  [50.2, 0.2],
  [35.44, 139.66],
  [41.3, 36.34],
  [-6.55, 106.54],
  [57.05, -6.93],
  [41.27, 29.03],
  [45.4, -73.58],
  [49.28, -123.07],
  [37.25, 27.63],
  [40.03, 26.32],
  [-25.58, 32.88],
  [35.34, 25.15],
  [59.99, 29.77],
  [51.35, 4.29],
  [62.23, -6.58],
  [57.62, -3.94],
  [44.42, 8.92],
  [49.46, -2.53],
  [54.18, 9.46],
  [-23.84, 151.27],
  [40.4, 29.07],
  [24.35, 119.37],
  [60.6, 1.98],
  [58.2, -6.38],
  [40.76, 13.97],
  [33.87, 130.82],
  [53.31, -4.63],
  [55.08, 14.67],
  [51.23, 1.7],
  [54.72, 20.52],
  [-29.75, 31.2],
  [56.69, 8.22],
  [54.09, 12.14],
  [-20.78, 115.53],
  [29.71, 32.59],
  [56.4, -2.02],
  [35.64, 139.79],
  [51.46, 1.94],
  [49.59, -6.57],
  [-20.15, 57.48],
  [39.4, 23.4],
  [39.1, 26.56],
  [45.34, 36.67],
  [51.37, 6.17],
  [5.41, 100.33],
  [-3.7, 114.43],
  [51.7, 3.29],
  [12, 45.2],
  [41.12, 29.08],
  [42.8, 132.88],
  [55.45, 8.46],
  [38.9, 1.45],
  [50.1, -3.33],
  [18.05, -63.05],
  [53.35, -6.23],
  [36.76, 137.22],
  [-34.9, -56.27],
  [50.57, 5.45],
  [55.35, -131.66],
  [22.29, 114.16],
  [55.7, 12.62],
  [70.62, 29.7],
  [51.4, 3.62],
  [21.02, 107.37],
  [36.24, 33.89],
  [-33.5, -60.01],
  [63, 7],
  [33.56, 35.4],
  [39.2, 20.19],
  [44.92, -161.15],
  [41.12, 29.08],
  [46.05, 38.17],
  [55.48, 8.41],
  [58.9, 23.42],
  [21.93, 91.38],
  [50.28, -1.3],
  [36.7, -4.42],
  [-12.45, 130.84],
  [58.78, 149.42],
  [5.63, -54.41],
  [47.19, 39.69],
  [34.24, 132.54],
  [38.3, 21.8],
  [42.78, 132.87],
  [49.58, -65.88],
  [59.97, 30.17],
  [59.6, 5.77],
  [6.9, 122.07],
  [38.2, 20.48],
  [44.53, -59.48],
  [56.45, -5.38],
  [7.03, -58.45],
  [52.17, 3.88],
  [1.17, 103.45],
  [36.76, 137.22],
  [-5.98, 105.98],
  [62.08, 6.28],
  [22.32, 91.82],
  [58.66, 17.12],
  [38.75, 22.85],
  [-14.27, -170.68],
  [58.04, -5.88],
  [38.03, 23.5],
  [30.19, 47.89],
  [-51.23, -59.02],
  [64.53, 40.5],
  [36.2, 14.63],
  [49.33, -66.72],
  [60.63, 28.57],
  [36.8, 34.65],
  [36.14, -5.35],
  [64.14, -21.89],
  [50.73, 1.62],
  [69.4, 86.17],
  [54, 1.67],
  [49.05, 158.22],
  [41.12, 29.08],
  [8.38, 76.99],
  [50.85, 0.58],
  [45.92, -1.77],
  [48.75, 44.5],
  [41, 28.96],
  [-35.17, -56.52],
  [30.19, 47.89],
  [-14.27, -170.68],
  [-1, 100.35],
  [46.29, -123.46],
  [47.72, -69.9],
  [47.38, -61.86],
  [47.57, -59.13],
  [-41.27, 173.32],
  [55.78, -4.88],
  [9.17, 124.72],
  [1.17, 103.43],
  [20.7, 107.17],
  [39.28, -76.61],
  [37.84, 23.45],
  [45.42, 141.7],
  [55.67, 11.05],
  [49.56, -55.74],
  [51.44, 0.74],
  [12.8, 100.73],
  [40.96, 28.89],
  [45.5, -73.52],
  [49.78, -3.58],
  [37.47, 23.48],
  [49.07, -126.08],
  [45.95, -73.2],
  [19.67, 57.72],
  [51.65, -5.17],
  [54.37, 10.15],
  [49.9, -125.06],
  [56.48, 44.18],
  [51.17, -4.64],
  [37.95, 23.55],
  [39.17, 23.48],
  [39.87, 4.3],
  [50.32, -0.82],
  [42.9, -82.45],
  [68.8, 16.54],
  [51.42, -57.15],
  [49.37, -123.27],
  [-23.58, 150.86],
  [53.42, 0.72],
  [51.76, 2.59],
  [48.2, -123.57],
  [49.14, -6.37],
  [-24.23, 113.39],
  [-0.69, 119.73],
  [36.62, 28.15],
  [29.93, -89.99],
  [36.42, 25.45],
  [39.35, 26.54],
  [37.94, 23.64],
  [47.62, -70.14],
  [70.38, 31.1],
  [53.36, 7.19],
  [43.52, -9.98],
  [41.28, -70.1],
  [40.67, 143.58],
  [64.71, 40.52],
  [43.22, -79.22],
  [40.99, 28.96],
  [4.11, 7],
  [56.7, 10.38],
  [4, 5.48],
  [53.18, 4.85],
  [29.73, -95.08],
  [29.11, -90.21],
  [23.48, -83.12],
  [36.5, 27.83],
  [49.49, -124.15],
  [22.32, 91.82],
  [38.9, 22.62],
  [33.56, 129.87],
  [-20.68, 116.69],
  [18.07, -63.1],
  [61.92, -6.88],
  [24.9, 118.58],
  [49.88, -4],
  [38.82, 26.94],
  [4.11, 6.26],
  [53.58, 6.67],
  [-2.78, 122.8],
  [40.97, 28.95],
  [58.9, 17.95],
  [38.73, 26.87],
  [50.77, 0.7],
  [45.3, -73.92],
  [50.31, -2.07],
  [62.37, 6.03],
  [50.4, -57.63],
  [44.2, -76.75],
  [59.87, -2.4],
  [65, 25.47],
  [31.39, 121.98],
  [53.55, 9.98],
  [40.75, 29.82],
  [56.66, 12.85],
  [20.15, 110.27],
  [22.1, 91.75],
  [35.4, 130.72],
  [50.53, -0.03],
  [27.83, -96.99],
  [58.55, 8.33],
  [10.41, 107.14],
  [59.18, 10.95],
  [51.18, 1.67],
  [53.8, 8.9],
  [22.59, 120.31],
  [61.6, 5.98],
  [46.05, -73.12],
  [51.56, 3.43],
  [6.27, 3.22],
  [30.04, 47.96],
  [40.97, 28.93],
  [22.59, 120.31],
  [47.57, -122.62],
  [3.83, 6.77],
  [45.35, 36.62],
  [60.78, 4.72],
  [0.03, -50.97],
  [52.38, 4.88],
  [39.45, -0.33],
  [54.34, 10.18],
  [22.32, 91.82],
  [31.73, 121.1],
  [6.92, 122.08],
  [24.8, 66.98],
  [40.15, 26.4],
  [6.29, 3.26],
  [48.21, -69.22],
  [-41.27, 173.32],
  [-23.84, 151.27],
  [49.43, -5.43],
  [22.59, 120.31],
  [34.49, 133.73],
  [41, 28.96],
  [51.25, 1.7],
  [3.88, 9.5],
  [1.24, 103.96],
  [-6.98, 112.7],
  [46.45, -72.26],
  [58.14, 7.99],
  [61.08, 5.5],
  [40.66, 29.25],
  [49.66, -0.15],
  [52.13, -10.27],
  [-8.48, 119.82],
  [44.73, -75.47],
  [53.46, 6.82],
  [46.67, 142.75],
  [55.38, -131.72],
  [22.32, 91.82],
  [45.22, -74.03],
  [53.92, 14.25],
  [31.2, 29.89],
  [45.83, 47.97],
  [45.22, 12.28],
  [50.37, -4.12],
  [13.47, 52.87],
  [44.22, -76.45],
  [54.53, 10.48],
  [43.36, -8.4],
  [38.68, -9.4],
  [48.72, -69],
  [34.12, 135.13],
  [4.89, -1.75],
  [-4.07, 39.68],
  [19.13, 108.62],
  [53.6, 8.51],
  [50.2, -2.88],
  [53.4, 1.08],
  [50.64, 0.53],
  [49.23, -6.48],
  [38.75, 26.9],
  [25.43, 119.85],
  [40.89, 29.19],
  [28.13, -15.43],
  [3.27, 5.15],
  [40.98, 28.95],
  [59.35, 18.26],
  [50.5, 0.11],
  [53.55, 9.98],
  [42.93, 49.18],
  [63.02, 8.52],
  [-0.24, 117.57],
  [36.84, 30.6],
  [61.77, 34.32],
  [-20.13, 116.47],
  [37.5, 122.12],
  [24.28, 120.53],
  [41, 28.96],
  [31.2, 29.89],
  [55.28, 9.75],
  [46, 37],
  [53.63, 9.51],
  [63.65, -16.65],
  [22.59, 120.31],
  [62.37, 6.33],
  [36.52, -6.29],
  [40.99, 28.94],
  [43.05, 131.92],
  [-0.02, 109.34],
  [18.98, 72.83],
  [49.01, -123.16],
  [29.08, 116.28],
  [45.65, -73.47],
  [52.62, 3.49],
  [4.15, 6.93],
  [27.18, 126.25],
  [-19.84, -40.06],
  [53.33, 7.16],
  [46.53, -84.35],
  [59.07, 10.87],
  [22.59, 120.31],
  [73, 127],
  [25.48, 53.13],
  [35.69, 139.98],
  [54.32, 10.13],
  [50.73, 1.62],
  [66.18, -1.15],
  [74.91, 32.83],
  [51.49, 0.02],
  [55.1, 8.57],
  [59.88, 30.2],
  [46.73, -92.08],
  [53.84, 8.84],
  [-4.78, 11.83],
  [41, 28.96],
  [65.83, 13.18],
  [21.12, 113.32],
  [34.81, 139.27],
  [44.14, 28.64],
  [58.57, 23.5],
  [37.94, 23.64],
  [54.37, 10.15],
  [49.15, -123.17],
  [52.44, 3.99],
  [58.11, 7.04],
  [1.34, 104.29],
  [15.57, 91.97],
  [49.28, -123.07],
  [36.23, 33.98],
  [60.15, -1.14],
  [53.52, -131.27],
  [49.32, -4.3],
  [46.35, -72.51],
  [35.03, 136.87],
  [51.32, 1.55],
  [48.82, -5.42],
  [43, -82.4],
  [3.92, 98.77],
  [56.95, 10.4],
  [37.47, 25.33],
  [-8.3, 114.42],
  [52.43, 3.95],
  [45.83, 47.97],
  [54.94, 10.83],
  [45.34, 36.67],
  [37.94, 23.64],
  [-34.16, -58.97],
  [59.67, 28.3],
  [38.03, 23.5],
  [56.73, 11.8],
  [21.8, 91.7],
  [56.47, 53.8],
  [53.86, 8.71],
  [18.57, -72.4],
  [42.82, 10.33],
  [50.3, -125.41],
  [13.35, 49.49],
  [-33.07, -60.53],
  [69.23, 17.97],
  [-12, -77.2],
  [2.43, 103.83],
  [-3.44, 116.03],
  [20.92, 107.29],
  [41.97, -82.73],
  [40.77, 29.54],
  [51.26, 4.39],
  [31.45, 121.08],
  [40.15, 26.4],
  [46.36, 48.04],
  [53.58, 0.02],
  [60.76, 4.76],
  [37.94, 23.64],
  [58.67, 17.12],
  [46.26, -72.68],
  [46.36, 48.04],
  [44.82, -75.3],
  [53.9, 9.13],
  [61.02, 4.7],
  [49.3, -123.23],
  [40.15, 26.4],
  [1.27, 103.83],
  [41.63, -70.91],
  [32.72, -117.21],
  [47.12, 39.41],
  [-4.07, 39.68],
  [62.82, 6.88],
  [44.47, 12.25],
  [40.97, 28.93],
  [62.28, -74.4],
  [51.37, 1.92],
  [3.52, 7.12],
  [49.49, 0.14],
  [29.96, 32.59],
  [36.83, 30.62],
  [39.44, 1.96],
  [49.15, 142.05],
  [58.43, -3.08],
  [42.22, 83.08],
  [45.02, -74.72],
  [51.95, 1.26],
  [4.34, 7.1],
  [40.98, 28.93],
  [51, 5.24],
  [58.83, -4.85],
  [50.15, -5.06],
  [48.98, -123.32],
  [41.12, 29.08],
  [53.88, 9.14],
  [54.09, 12.14],
  [7.18, 122.67],
  [48.88, -123.31],
  [62.02, 129.73],
  [54.25, -131.65],
  [1.27, 103.83],
  [49.28, -0.25],
  [25.5, 55.5],
  [0.04, -51.05],
  [24.77, 67.34],
  [56.87, -8.02],
  [13.1, -59.62],
  [53.88, 9.13],
  [37.11, 25.37],
  [51.9, 4.48],
  [50.68, -1.02],
  [50.2, -1.88],
  [60.08, -149.35],
  [60.85, 5.07],
  [62.73, 7.17],
  [45.65, -73.48],
  [49.68, -65.98],
  [66.16, 12.85],
  [31.82, 34.65],
  [18.12, -65.42],
  [36.63, 29.1],
  [65.92, 12.43],
  [46.38, 154.45],
  [-7.43, 112.93],
  [-35.17, -56.99],
  [39.08, 26.75],
  [49.3, -122.87],
  [48.4, -123.36],
  [-20.78, 115.53],
  [58.68, -2.89],
  [40.97, 28.68],
  [38.73, -9.12],
  [57.27, -5.67],
  [50.53, -0.07],
  [40.83, 25.92],
  [5.55, 5.11],
  [54.68, 20.15],
  [51.53, 4.22],
  [54.18, 7.89],
  [28.13, -15.43],
  [55.87, -2.08],
  [46.48, -84.3],
  [49.32, -123.23],
  [41.03, 1.85],
  [51.45, 0.27],
  [-37.77, 173.87],
  [59.18, -5.18],
  [37.9, 23.54],
  [64.53, 40.5],
  [34.5, 125.58],
  [20.9, 107.28],
  [-41.28, 174.78],
  [49.31, -123.1],
  [45.78, 13.55],
  [4.22, 8.08],
  [-29.87, 31.03],
  [47, -70.78],
  [-20.16, 57.5],
  [34.75, 134.79],
  [49.29, -123.09],
  [35.44, 139.66],
  [38.82, 118.24],
  [48.33, -70.87],
  [10.32, 123.92],
  [39.53, 20.22],
  [41.18, 29.05],
  [54.85, -5.8],
  [37.95, 23.57],
  [49.29, -123.07],
  [10.18, -64.79],
  [45.83, 47.97],
  [1.4, 104.78],
  [49.4, -54.86],
  [54.32, 10.13],
  [64.12, -3],
  [37.88, -73.81],
  [54.53, 18.55],
  [61.22, -119.46],
  [22.59, 120.31],
  [53.53, 0.32],
  [40.84, 29.29],
  [41.68, 32.24],
  [53.87, 8.7],
  [31.24, 32.31],
  [44.93, -83.13],
  [52.87, 4.32],
  [50.38, -125.83],
  [1.17, 103.43],
  [-10.17, 123.57],
  [58.97, 5.73],
  [45.98, -85.05],
  [44.56, -83.33],
  [42.47, -80.2],
  [18.47, -66.12],
  [40.53, -7.33],
  [40.96, 28.95],
  [45.35, 141.02],
  [53.36, 7.19],
  [40.42, 29.08],
  [41.11, 1.22],
  [36.14, -6.07],
  [48.38, -123.3],
  [53.52, 4.73],
  [-33.15, 65.97],
  [-6.04, 106.89],
  [45.42, 28.08],
  [49.28, -123.03],
  [22.25, 91.68],
  [-33.26, 115.58],
  [30.22, 122.62],
  [34.78, 126.38],
  [54.7, -5.49],
  [18.65, -65.6],
  [9.36, -79.88],
  [53.36, 7.19],
  [44.74, 37.79],
  [53.55, 9.98],
  [52.33, 3.13],
  [37, 23.03],
  [-12.66, 141.87],
  [47.2, -70.57],
  [22.32, 91.82],
  [49.98, -5.75],
  [49.29, -123.09],
  [43.78, -66.13],
  [37.97, 23.57],
  [56.01, 8.13],
  [37.97, 23.57],
  [-21.64, 115.11],
  [49.73, -6.58],
  [40.97, 28.94],
  [1.37, 104.67],
  [69.08, 15.95],
  [-42.75, -65.02],
  [33.94, 132.68],
  [-7.78, 109.07],
  [41.12, 29.08],
  [-34.71, 9.67],
  [61.88, 5.1],
  [-34.16, -58.97],
  [45.4, -73.78],
  [51.18, 1.71],
  [43.31, -3.03],
  [59.27, 5.33],
  [37.8, 23.48],
  [11.58, 72.15],
  [45.64, -73.48],
  [22.14, 91.73],
  [-39.01, -61.86],
  [56.68, 8.22],
  [45.34, 36.67],
  [3.13, 97.45],
  [58.18, -6.37],
  [33.95, 130.95],
  [39.62, 19.95],
  [47.08, 39.2],
  [29.93, -87.88],
  [54.31, -130.36],
  [45.12, -74.45],
  [37.71, 23.68],
  [-17.68, 178.85],
  [47.79, -54.03],
  [33.96, 130.89],
  [40.84, 29.29],
  [37.94, 23.64],
  [47.55, -52.64],
  [39.17, 23.48],
  [49.31, -123.08],
  [40.96, 28.89],
  [35.12, 129.04],
  [48.71, -62.89],
  [51.17, 1.53],
  [45.83, 47.97],
  [29.61, -89.85],
  [43.67, -66.05],
  [-14.53, 40.67],
  [18.76, -91.79],
  [40.96, 28.92],
  [60.43, 22.22],
  [55.37, 13.15],
  [62.6, 6.45],
  [58.62, 16.25],
  [40.03, 26.25],
  [67.25, 15.42],
  [6.98, 79.68],
  [46.75, 36.78],
  [55.75, 0.95],
  [6.29, 2.49],
  [38.38, 26.15],
  [39.17, 23.48],
  [46.4, -72.38],
  [46.26, -72.7],
  [-6.03, 105.93],
  [10.18, -64.79],
  [5.42, 100.4],
  [-36.62, 21.53],
  [56.15, 10.22],
  [-5.92, 105.89],
  [32.73, 129.84],
  [44.67, -63.63],
  [62.99, 8.65],
  [49.3, -123.07],
  [39.87, 25.03],
  [40.92, 38.39],
  [40.15, 26.4],
  [40.52, -73.99],
  [43.8, 29.01],
  [39.84, 19.41],
  [53.93, -3.01],
  [65.09, 11.74],
  [-36.85, 174.78],
  [47.12, 39.41],
  [62.58, 6.22],
  [-39.97, 173.29],
  [66.75, 13.57],
  [62.01, -6.77],
  [39.8, 26],
  [48.92, -123.22],
  [36.84, 30.6],
  [53.43, 14.58],
  [48.62, -59.87],
  [68.8, 16.53],
  [39.17, 23.48],
  [44.18, -76.3],
  [39.62, 19.95],
  [61.84, -120.99],
  [38.25, 21.74],
  [54.18, 7.89],
  [40.87, 29.18],
  [53.67, -0.23],
  [17.5, -77],
  [10.15, -64.77],
  [13.1, 43.13],
  [62.05, 5.37],
  [-20.13, 57.48],
  [29.2, -89.27],
  [31.25, 121.5],
  [39.62, 19.95],
  [24.28, 120.53],
  [60.43, 6.53],
  [41.49, 28.93],
  [28.48, -16.22],
  [31.13, 29.78],
  [37.34, 23.93],
  [34.65, 33.01],
  [1.18, 103.63],
  [21.31, -157.86],
  [2.15, 111.34],
  [57.72, 10.6],
  [55.19, 11.17],
  [21.67, 72.28],
  [54.68, -130.84],
  [55.45, 12.2],
  [49.28, -123.07],
  [45.25, -81.67],
  [34.69, 135.2],
  [53.1, 8.76],
  [54.72, 20.52],
  [22.32, 91.82],
  [54.23, 9.61],
  [45.3, 36.52],
  [-36.85, 174.78],
  [50.84, 0.89],
  [34.65, 138.93],
  [53.88, 9.2],
  [50.05, -125.22],
  [60.11, 5.18],
  [53.45, -3],
  [30.04, 47.96],
  [-2.24, -79.88],
  [40.71, -74.01],
  [-20.15, 57.48],
  [46.36, 48.04],
  [45.31, -73.93],
  [14.57, 120.92],
  [49.7, -65.4],
  [44.65, -63.58],
  [-20.15, 57.48],
  [36.23, 33.98],
  [48.27, -69.1],
  [59.87, 30.23],
  [47.19, 39.69],
  [54.69, 20.21],
  [1.27, 103.83],
  [54.72, 20.52],
  [63.07, 8.22],
  [53.61, 5.57],
  [43.11, 131.92],
  [13.75, 121.05],
  [47.12, 39.45],
  [53.45, 5.63],
  [44.73, 37.8],
  [34.69, 135.2],
  [44.25, -67.02],
  [41.12, 29.08],
  [50.25, -1.38],
  [25.72, 119.35],
  [44.63, 33.57],
  [36.8, 34.63],
  [54.32, -130.32],
  [6.1, 125.17],
  [35.25, 23.75],
  [51.4, 3.72],
  [53.69, -0.7],
  [43.56, -5.7],
  [49.3, -123.1],
  [55.47, 8.4],
  [59.97, 30.17],
  [17.88, 72.62],
  [41, 28.96],
  [49.3, -123.07],
  [37.97, 21.17],
  [15.42, 73.8],
  [46.4, 48.02],
  [1.27, 103.83],
  [10.53, 123.99],
  [49.3, -123.09],
  [66.91, 41.63],
  [56.63, 9.8],
  [39.87, 25.05],
  [42.39, -8.69],
  [40.96, 28.89],
  [57.59, 9.96],
  [42.8, 132.88],
  [37.94, 23.58],
  [37.54, 25.16],
  [2.32, 101.67],
  [53.89, 9.15],
  [63.06, 7.66],
  [44.93, -83.13],
  [47.17, 39.58],
  [35.25, 23],
  [49.7, -3.82],
  [-8.35, 114.77],
  [42.25, 135.35],
  [1.44, 103.9],
  [50.56, 0.42],
  [19.47, 72.45],
  [16.13, 57.62],
  [44.61, 37.93],
  [51.85, 4.53],
  [29.75, -95.33],
  [55.47, 8.42],
  [30.76, 122.64],
  [48.97, 11.68],
  [43.56, 10.31],
  [21.05, 72.63],
  [10.41, 107.14],
  [34.69, 135.2],
  [42.68, -9.77],
  [36.72, 25.27],
  [49.28, -123.07],
  [44.87, -75.25],
  [54.29, 9.67],
  [59.2, 17.63],
  [56.53, -7.4],
  [51.88, 2.63],
  [2.23, 97.78],
  [40.15, -8.87],
  [69.87, 19.02],
  [39.45, -0.32],
  [28.33, -90.72],
  [59.3, 4.88],
  [37.98, 24.42],
  [19.52, 120.25],
  [54.34, -132.9],
  [40.76, 24.58],
  [-23.84, 151.27],
  [-39.48, 176.92],
  [-37.65, 176.17],
  [22.29, 114.16],
  [1.08, 104.03],
  [47.06, 37.5],
  [45.22, -82.28],
  [65.45, 12.21],
  [36.62, 27.83],
  [57.42, 11.23],
  [55.48, 9.58],
  [45.22, 12.28],
  [52.14, 3.6],
  [22.17, 142.68],
  [51.9, 4.35],
  [35.64, 139.79],
  [37.94, 23.64],
  [38.25, 21.74],
  [30.32, 32.39],
  [24.41, 118.05],
  [49.65, -4.47],
  [29.73, -93.88],
  [36.82, -2.47],
  [41.6, 29.23],
  [56.93, 19.64],
  [40.88, 29.21],
  [30.22, 123.09],
  [55.63, 12.69],
  [56.95, 24.08],
  [53.9, 9.13],
  [67.28, 14.38],
  [50.05, -5.07],
  [42.42, 18.77],
  [40.96, 28.89],
  [41, 28.96],
  [52.97, 4.78],
  [36.72, -4.43],
  [61.21, 6.57],
  [47.12, 39.41],
  [25.23, 56.52],
  [14.58, 120.97],
  [34.49, 133.73],
  [-0.27, 109.88],
  [44.65, -63.58],
  [45.78, 47.55],
  [24.99, 55.06],
  [28.48, -16.24],
  [4.12, 6.85],
  [54.31, -4.78],
  [45.13, 36.69],
  [36.59, 36.19],
  [59.15, 37.83],
  [59.82, 5.72],
  [32.32, -64.83],
  [39.35, 22.95],
  [1.27, 103.83],
  [-2.74, 111.73],
  [38.32, 26.3],
  [37.95, -8.87],
  [37.08, -167.56],
  [22.59, 120.31],
  [53.62, -0.7],
  [21.47, 39.17],
  [49.53, -66.52],
  [43.65, -77.75],
  [16.67, 112.33],
  [-5.57, 132.67],
  [-43.15, 147.85],
  [59.97, 30.17],
  [10.22, 123.75],
  [54.17, 12.08],
  [31.55, 32.35],
  [41.18, 9.38],
  [53.87, 8.7],
  [1.47, 103.75],
  [40.96, 28.89],
  [55.7, 12.62],
  [52.91, -5.28],
  [28.48, -16.23],
  [28.13, -15.43],
  [47.83, 42.83],
  [-37.83, 144.92],
  [1.27, 103.83],
  [49.28, -123.07],
  [56.83, 150.69],
  [53.9, 9.13],
  [50.77, 0.73],
  [36.89, 122.42],
  [57.05, 9.95],
  [69.08, 15.95],
  [50.28, -2.57],
  [1.24, 103.65],
  [33.27, 131.51],
  [1.2, 104.03],
  [-12.02, -77.18],
  [37.95, 21.15],
  [-5.51, 105.35],
  [48.39, -4.47],
  [46.71, -71.52],
  [49.3, -122.95],
  [23.53, 123.6],
  [40.96, 28.68],
  [29.55, -90.38],
  [56.47, 3.41],
  [43.13, 131.9],
  [60.09, 5.22],
  [58.63, 8.93],
  [56.95, 24.08],
  [53.02, 158.63],
  [29.93, 121.85],
  [40.41, 29.09],
  [9.82, 76.05],
  [46.94, 32.02],
  [47.63, -122.33],
  [54.48, 12.16],
  [10.32, 123.92],
  [56.7, 8.22],
  [50.22, -0.47],
  [40.53, 27.02],
  [-18.13, 178.43],
  [50.08, -5.5],
  [49.32, -67.6],
  [-10.57, 142.15],
  [51.26, 4.39],
  [-20.32, 118.58],
  [35.41, 139.67],
  [51.32, 156.38],
  [38.14, 24.1],
  [40.03, 26.29],
  [44.95, -75.05],
  [49.9, -3.3],
  [37.44, 24.94],
  [56.2, -7.06],
  [-34.9, -56.2],
  [49.3, -123.12],
  [34.96, 136.64],
  [9.36, -79.9],
  [53.87, 8.7],
  [51.83, 1.7],
  [51.5, 2],
  [22.98, 116.78],
  [35.64, 139.79],
  [37.94, 23.6],
  [22.32, 91.82],
  [47.63, -122.33],
  [50.02, -125.25],
  [39.53, 20.22],
  [38.25, 21.74],
  [45.17, 28.8],
  [40.12, 22.16],
  [60.86, 5.06],
  [68.97, 33.08],
  [20.87, 106.67],
  [33.27, 131.51],
  [41.28, 28.97],
  [47.12, 39.41],
  [62.17, 177],
  [21.87, 91.8],
  [53.12, 8.72],
  [47.78, -64.95],
  [45.02, -66.93],
  [45.44, 12.25],
  [-18.82, 118.15],
  [3.73, 6.78],
  [14.6, 12.83],
  [59.87, 30.23],
  [10.5, 65.84],
  [56.16, 15.58],
  [53.38, 5.04],
  [-33.97, 25.63],
  [22.32, 91.82],
  [37.08, 25.32],
  [44.74, 37.79],
  [51.31, 1.62],
  [52.81, 3.98],
  [41.12, 29.08],
  [1.27, 103.83],
  [70.6, 23.62],
  [35.4, 26.92],
  [1.58, 105],
  [29.3, -94.8],
  [58.45, 9.02],
  [51.3, 4.27],
  [-27.41, 153.16],
  [51.08, 1.28],
  [51.4, 0.55],
  [41.18, 29.05],
  [62.21, 5.36],
  [55.48, 9.71],
  [53.74, -0.28],
  [51.15, 1.45],
  [50.62, 1.1],
  [10.39, 104.58],
  [1.1, 103.53],
  [-34.88, -56.18],
  [-25.5, -48.52],
  [51.18, 1.75],
  [61.07, 28.24],
  [49.3, -65.69],
  [43.1, 131.89],
  [34.48, 135.39],
  [0.99, -79.65],
  [40.97, 28.92],
  [30.54, 47.83],
  [-2.37, -80.02],
  [50.14, 7.73],
  [50.97, 1.85],
  [50, -4],
  [39.83, 26.07],
  [36.87, 122.43],
  [1.35, 172.92],
  [-32.15, 133.64],
  [22.32, 91.82],
  [41, 28.96],
  [40.15, 26.4],
  [51.47, 0.3],
  [51.54, -127.7],
  [46.43, -56.5],
  [14, 65],
  [7.8, 78.97],
  [5.42, 100.33],
  [26.22, -79.16],
  [41.87, 149.25],
  [68.23, 14.54],
  [-33.86, 151.21],
  [58.77, 2.78],
  [41.27, 29.05],
  [57.51, -135.23],
  [1.27, 103.83],
  [45.32, -85.22],
  [40.98, 28.95],
  [36.75, 5.07],
  [3.78, 98.7],
  [-33.34, -60.16],
  [66.83, 14.67],
  [32.89, 13.19],
  [45.51, -73.55],
  [57.5, -4.23],
  [14.75, 50.97],
  [34.73, 119.45],
  [13.4, -87.42],
  [44.11, 9.83],
  [25.12, 66.65],
  [39.53, 20.22],
  [45.53, -73.52],
  [46.59, -129.4],
  [37.83, 140.95],
  [25.15, 121.4],
  [37.25, 27.63],
  [55.21, 11.24],
  [40.15, 26.4],
  [43.12, 5.92],
  [1.27, 103.83],
  [57.7, 93.27],
  [-27.41, 153.16],
  [43.62, 25.35],
  [63.64, 9.69],
  [-3.75, -38.51],
  [46.43, -72.35],
  [37.94, 23.64],
  [54.63, -8.43],
  [59.15, 37.83],
  [48.79, -125.99],
  [53.9, 9.13],
  [-4.07, 39.68],
  [50.66, 0.21],
  [41.26, 13.61],
  [59.44, 10.65],
  [18.61, -72.44],
  [1.25, 104.15],
  [50.62, 0.52],
  [40.84, 29.28],
  [14.59, 120.92],
  [58.46, 5.98],
  [4.13, 96.13],
  [40.96, 28.92],
  [47.12, 39.42],
  [29.3, -94.8],
  [41.15, 29.03],
  [42.75, -82.48],
  [47.56, -52.71],
  [57.44, 10.54],
  [49.3, -123.13],
  [42.1, 11.79],
  [53.17, 5.4],
  [24.28, 120.53],
  [38.75, 26],
  [53.9, 9.13],
  [10.25, 107.05],
  [54.57, 11.07],
  [51.03, 1.42],
  [40.97, 28.93],
  [37.1, 25.38],
  [26.65, 119.52],
  [37.82, 24.9],
  [62.1, 5.14],
  [53.9, 9.13],
  [63.44, 10.41],
  [36.52, -6.29],
  [52.93, 5.03],
  [49.29, -122.87],
  [-12.45, 130.84],
  [48.67, -62.28],
  [39.83, 26.07],
  [53.9, 9.13],
  [46.22, -72.78],
  [10.18, -64.79],
  [41.28, 28.98],
  [51.5, -0.07],
  [37.95, 23.62],
  [36.84, 30.6],
  [52.52, -4.66],
  [50.45, -3.42],
  [35.71, -0.64],
  [49.57, -6.59],
  [44.14, 28.64],
  [36.24, 23.11],
  [3.8, 98.72],
  [25.5, 55.33],
  [49.37, -66.35],
  [58.97, 5.73],
  [23.03, 70.22],
  [33.95, 130.97],
  [64.53, 40.5],
  [46.29, -60.26],
  [56.15, 10.22],
  [47.56, -52.71],
  [49.28, -122.98],
  [53.92, 8.5],
  [48.69, -123.41],
  [22.07, 91.8],
  [32.74, 129.78],
  [37.97, 23.57],
  [53.9, 6.82],
  [37.47, 126.63],
  [55.37, 148],
  [58.97, 5.73],
  [36.59, 36.19],
  [-23.93, -46.33],
  [42.78, -80.08],
  [40.65, 27.67],
  [71.51, 34.52],
  [-12.25, 43.75],
  [39.53, 20.22],
  [50.22, -5.45],
  [54.72, 20.52],
  [50.63, 0.53],
  [38.03, 23.5],
  [3.96, 6.65],
  [29.75, 122.14],
  [30.01, -90.73],
  [57.27, 11.1],
  [50.04, -66.79],
  [49.62, -66],
  [53.9, 9.13],
  [42.8, 132.88],
  [40.93, 28.85],
  [33.51, 16.77],
  [-7.9, 147.8],
  [53.55, 0.27],
  [37.94, 23.64],
  [34.49, 133.73],
  [4.22, 8.05],
  [43.32, -79.73],
  [40.85, 14.28],
  [48.41, -120.39],
  [49.29, -123.1],
  [-18.15, 49.42],
  [69.58, 35.57],
  [54.43, 8.62],
  [19.05, -104.33],
  [54.37, 10.15],
  [40.95, 28.66],
  [46.05, -73.08],
  [49.96, -4.81],
  [51.83, 3.57],
  [41.27, 29.02],
  [46.62, 142.77],
  [32.88, 35.07],
  [1.46, 104.61],
  [47.4, -61.55],
  [50.25, -1.64],
  [47.07, 39.09],
  [35.02, 139.44],
  [36.12, 22.95],
  [44.93, 47.76],
  [3.43, 50.45],
  [36.14, -5.35],
  [7.03, 125.65],
  [5.38, -0.02],
  [59.98, 30.17],
  [-6, 120.5],
  [51.71, -5.06],
  [45.41, -73.57],
  [22.32, 91.82],
  [49.22, 44],
  [3.98, 6.75],
  [30, 122.1],
  [38.32, 26.25],
  [49.3, -123.08],
  [39.57, 2.63],
  [59, -2.98],
  [68.16, 39.74],
  [68.97, 33.08],
  [67, -9],
  [46.77, -71.2],
  [16.89, -24.99],
  [2.02, 45.35],
  [53.88, 14.27],
  [47.1, 39.31],
  [51.43, 3.58],
  [48.86, 12.76],
  [40.77, 24.7],
  [-8.06, 117.94],
  [52.46, 4.6],
  [40.92, 24.42],
  [35.35, 119.87],
  [47.72, -3.36],
  [46.36, 48.04],
  [27.75, -96.92],
  [54.32, 10.13],
  [54.14, 7.93],
  [61.98, 5.13],
  [65, 12.25],
  [40.95, 28.9],
  [49.76, -123.09],
  [4.89, -1.75],
  [49.29, -123.08],
  [41, 28.96],
  [55.35, 10.35],
  [67.9, 13.04],
  [22.59, 120.31],
  [34.47, 35.83],
  [29.34, -26.4],
  [42.12, -66.9],
  [45.34, 36.67],
  [-2.7, 134.5],
  [51.86, 2],
  [42.83, -60.3],
  [-21.3, 13.68],
  [0.22, 104.17],
  [47.19, 39.69],
  [50.73, -127.47],
  [-16.48, -151.73],
  [51.93, 3.74],
  [54.78, 9.43],
  [58.22, 10],
  [57.42, -1.67],
  [51.45, 3.58],
  [43.42, -2.72],
  [49.15, -123.03],
  [56.46, 10.04],
  [58.97, 5.73],
  [22.03, 114.02],
  [50.47, 0.92],
  [37.94, 23.64],
  [47.48, -70.23],
  [47.87, -69.77],
  [32.64, -16.91],
  [29.3, -94.8],
  [52.47, 4.63],
  [60.12, 20.3],
  [40.16, 26.41],
  [36.44, 28.23],
  [31.45, 121.08],
  [50.73, 0.05],
  [20.22, 109.38],
  [53.42, 0.73],
  [42.8, 132.88],
  [51.3, 3.1],
  [-5.45, 122.6],
  [10.41, 107.14],
  [-6, 120.5],
  [36.78, 36.19],
  [43.52, -78.43],
  [47.12, 39.41],
  [47.56, -52.71],
  [47.48, -4.75],
  [-18.14, 178.41],
  [-35.17, -56.99],
  [18.53, -72.38],
  [33.37, 26.14],
  [53.55, 8.58],
  [47.1, 39.3],
  [44.14, 28.64],
  [53.03, 1.38],
  [59.4, -3.3],
  [40.15, 26.4],
  [35.22, 26.12],
  [26.37, 127.85],
  [10.29, 106.92],
  [38.02, 24],
  [1.24, 103.91],
  [40.15, -8.87],
  [54.47, 9.05],
  [54.26, -130.36],
  [42.5, 27.47],
  [54.26, 0.28],
  [43.63, 51.21],
  [60.45, 26.95],
  [53.75, 6.36],
  [41, 28.96],
  [54.47, 9.05],
  [41.45, 31.78],
  [51.47, 3.7],
  [34.92, 127.72],
  [36.3, 30.15],
  [23.56, 119.67],
  [60.15, 5.43],
  [39.83, 19.15],
  [48.93, -67.68],
  [-27.41, 153.16],
  [10.69, 122.59],
  [66.02, 12.62],
  [1.13, 103.92],
  [-6.11, 106.89],
  [-20.15, 57.48],
  [-6.02, 106.88],
  [36.68, 25.12],
  [1.18, 103.99],
  [-34.74, -57.85],
  [59.97, 5.33],
  [43.3, -89.72],
  [52.51, 13.42],
  [58.14, 8],
  [50.53, 0.35],
  [62.37, 6.03],
  [54.37, 10.15],
  [41, 29.02],
  [60.16, 24.94],
  [1.3, 103.72],
  [53.33, -78.72],
  [69.88, 19.85],
  [40.7, 29.05],
  [2.28, 83.82],
  [1.8, 103.95],
  [10.33, -75.51],
  [-29.87, 31.03],
  [9.41, -13.71],
  [55, -1.43],
  [53.55, 8.58],
  [40.96, 28.89],
  [-23.88, 151.38],
  [-33.86, 151.21],
  [-30.03, -51.22],
  [14.58, 120.82],
  [55.7, 12.62],
  [53.12, 4.27],
  [-3.33, 114.55],
  [34.05, 130.37],
  [38.03, 23.5],
  [11.07, 123.99],
  [59.91, 10.76],
  [59.02, 5.6],
  [-4.07, 39.68],
  [50.15, -5.06],
  [36.5, 23],
  [58.05, 14.33],
  [17.63, -63.26],
  [5.03, 53.48],
  [66.71, -24.86],
  [53.5, 49.42],
  [47.43, -49.22],
  [36.84, -2.48],
  [59.77, 5.52],
  [55.63, 12.99],
  [1.12, 103.52],
  [45.34, 36.67],
  [45.09, 36.56],
  [42.18, -67.13],
  [-8.57, 116.35],
  [54.8, 9.44],
  [14.02, 51.67],
  [53.35, 7.18],
  [13.97, 51.42],
  [60.12, 20.3],
  [8.15, 123.85],
  [8.48, -13.39],
  [39.67, -75.57],
  [41.15, 29.03],
  [69.1, 33.4],
  [36.77, 23.6],
  [33.93, 130.93],
  [52.25, 3.48],
  [39.92, 25.25],
  [53.43, -4.12],
  [15.18, 73.76],
  [-5.77, 112.67],
  [42.98, -82.4],
  [-37.65, 176.17],
  [45.32, -73.92],
  [31.25, 121.5],
  [36.68, 24.42],
  [60.15, -8.31],
  [59.35, 19.96],
  [-36.27, 21.2],
  [37.97, 23.57],
  [50, -3.21],
  [25.14, 121.75],
  [41, 28.96],
  [25.23, 56.52],
  [-0.29, 117.66],
  [25.83, -150.75],
  [48.85, -67.55],
  [61.77, 2.82],
  [47.19, 39.69],
  [26.08, 119.31],
  [10.27, 124.28],
  [37.94, 23.64],
  [-5.5, 114.43],
  [51.3, 4.27],
  [46.11, -122.96],
  [59.68, -4.73],
  [59.41, 5.27],
  [43.57, -5.7],
  [59.95, 19.73],
  [50.25, 152.7],
  [48.88, -123.31],
  [39.25, 23],
  [41.11, 37.34],
  [47.19, 39.69],
  [38.25, 21.74],
  [53.45, 6.83],
  [52.91, -128.52],
  [53.61, 5.57],
  [48.39, -4.47],
  [36.32, 19.19],
  [51.88, 1.65],
  [13.77, 109.23],
  [41.82, 140.68],
  [64.53, 40.5],
  [49.42, -65.05],
  [51.33, 2.57],
  [37.95, 23.62],
  [12.45, 48.27],
  [-23.84, 151.27],
  [49.52, 4.12],
  [36.95, 26.98],
  [-5.93, 106],
  [50.26, -128.63],
  [52.1, -130.97],
  [49.13, -123.24],
  [59.45, 24.76],
  [52.46, 4.6],
  [49.83, -4.37],
  [30, 122.1],
  [68.95, 33.02],
  [9.51, -13.71],
  [41.48, -70.62],
  [53.55, 9.98],
  [46.22, -8.27],
  [22.15, 91.73],
  [-37.65, 176.18],
  [-4.87, -36.35],
  [53.55, 8.58],
  [53.55, 8.55],
  [-17.17, 178.59],
  [52.47, 3.92],
  [65, 25.47],
  [-21.4, 114.09],
  [53.25, 7.92],
  [44.11, 9.83],
  [4.9, -1.65],
  [3.55, 125.5],
  [31.25, 32.3],
  [29.87, 32.47],
  [29.11, -90.21],
  [53.9, 9.13],
  [63.78, 21.6],
  [75, 40],
  [59.87, 30.23],
  [40.84, 29.29],
  [40.15, 26.4],
  [39.93, 119.64],
  [63.11, 7.87],
  [-20.15, 57.48],
  [49.46, -65.9],
  [-33.98, -59.19],
  [53.45, -3],
  [50.83, 156.75],
  [10.27, -64.7],
  [70.92, 24.16],
  [60.57, 5.23],
  [64.53, 40.5],
  [4.9, -1.7],
  [20.87, 106.67],
  [10.96, -74.77],
  [51.9, 4.36],
  [36.88, 27.32],
  [46.84, -71.22],
  [53.82, 8.12],
  [57.68, -2],
  [54.11, 9.33],
  [4.85, -52.25],
  [6.7, 121.97],
  [54.48, 13.58],
  [45.34, 36.67],
  [28.08, -17.1],
  [41.16, 29.05],
  [-34.28, 18.3],
  [51.04, 2.35],
  [-0.26, 117.7],
  [66.84, 13.29],
  [48.98, -123.1],
  [50.35, -3.58],
  [38.9, 118.1],
  [54.32, -130.32],
  [13.73, 121.04],
  [59.87, 30.23],
  [53.7, -0.69],
  [51.47, 1.85],
  [-43.61, 172.73],
  [58.9, 23.42],
  [54.35, 9.95],
  [41, 28.96],
  [36.03, 129.37],
  [41, 28.96],
  [50.48, -126.58],
  [38.87, 119.17],
  [-2.27, -79.9],
  [-23.93, -46.33],
  [33.63, 126.88],
  [53.7, 7.17],
  [54.32, 10.13],
  [60.64, 4.86],
  [48.67, -68.19],
  [36.85, 122.47],
  [50.29, -4.38],
  [49.13, -63.88],
  [14.78, 42.95],
  [1.17, 103.48],
  [34.69, 135.2],
  [37.97, 23.57],
  [36.8, 34.64],
  [15.82, 52.23],
  [24.83, 67],
  [-34.47, 150.89],
  [56.46, 10.04],
  [33.95, 130.95],
  [-34.47, 150.89],
  [51.89, 4.32],
  [48.73, -123.18],
  [56.58, 18.02],
  [60.55, 4.92],
  [43.58, 39.73],
  [51.08, 1.19],
  [49.03, 8.27],
  [38.3, 21.8],
  [39.23, 23],
  [44.07, -76.47],
  [-22.13, -39.97],
  [53.31, 7.28],
  [31.47, 32.33],
  [45.17, 36.51],
  [42.79, 132.87],
  [55.72, 11.72],
  [62.38, 6.04],
  [29.81, -93.35],
  [59.2, 5.92],
  [53.37, 3.67],
  [45.35, 28.8],
  [45.22, 29.75],
  [40.77, 14.03],
  [0.12, 4.5],
  [54.28, -0.4],
  [46.15, -8],
  [49.3, -123.07],
  [15.07, -83.09],
  [21.62, -158],
  [40.96, 28.89],
  [60.17, -1.16],
  [57.5, 9.47],
  [59.45, 24.76],
  [47.78, -54.02],
  [16.77, 96.17],
  [53.97, 7.36],
  [3.08, 6.2],
  [53.95, 8.58],
  [34.77, 137.27],
  [56.15, 10.22],
  [46.62, 142.77],
  [38.19, 15.56],
  [50.81, 30.85],
  [46.23, -72.78],
  [49.01, -123.13],
  [45.34, 36.67],
  [51.96, 1.31],
  [-6.11, 106.89],
  [16.23, -61.55],
  [35.12, 129.04],
  [26.13, 135.33],
  [44.4, 8.93],
  [1.19, 103.99],
  [0.53, 101.45],
  [37.6, -0.98],
  [47.3, -52.73],
  [21.93, 91.38],
  [3.9, 5.63],
  [47.01, -70.79],
  [37.4, 27.08],
  [41, 28.96],
  [38.02, 24.42],
  [42.95, -82.42],
  [34.48, 135.39],
  [48.83, -123.32],
  [6.14, 1.29],
  [-21.45, 113.82],
  [56.7, 8.22],
  [22.32, 91.82],
  [37.94, 23.64],
  [1.13, 103.93],
  [40.95, 28.92],
  [18.63, -73.23],
  [40.78, 29.61],
  [37.94, 23.64],
  [42.95, -9.18],
  [37.55, 126.58],
  [37.75, 23.43],
  [26.72, -80.05],
  [40.01, 26.1],
  [38.79, 26.9],
  [1.23, 103.97],
  [50.62, 0.29],
  [45.31, 36.5],
  [13, 121.42],
  [-12.32, -37.62],
  [37.47, 25.33],
  [63.78, 21.6],
  [49.2, -123.95],
  [32.82, 35.01],
  [37.36, 24.63],
  [2.88, 100.98],
  [-29.87, 31.03],
  [49.89, -3.27],
  [51.43, 6.75],
  [35.03, 136.87],
  [37.92, 25.23],
  [36.12, 22.72],
  [-46.42, -60.73],
  [53.05, 158.61],
  [59.87, 30.23],
  [53.5, 6.07],
  [38.32, 24.49],
  [44.74, 37.79],
  [40.77, 29.73],
  [46.89, -70.92],
  [50.23, -1.77],
  [40.83, 8.37],
  [22.2, 113.55],
  [3.43, 6.45],
  [45.55, 13.74],
  [60.18, -1.05],
  [51.4, 3.45],
  [49, -123.59],
  [-8.77, 7.7],
  [-34.85, 138.57],
  [37.94, 23.64],
  [4.42, 7.15],
  [46.33, -72.52],
  [55.64, -4.81],
  [53.1, 8.76],
  [52, 3.97],
  [27.77, 48.87],
  [55.41, 10.38],
  [1.09, 103.57],
  [48.85, -5.3],
  [39.35, 22.95],
  [17.17, 107.35],
  [57.22, 11.37],
  [48.52, -122.62],
  [32.39, -64.71],
  [31.83, 118.53],
  [44.98, -74.85],
  [31.25, 32.3],
  [46.7, -71.52],
  [51.5, 45.92],
  [31.25, 121.5],
  [10.32, 123.92],
  [-22.33, -40.07],
  [55.98, 11.3],
  [54.37, 10.08],
  [53.55, 9.98],
  [10.23, 107.05],
  [41.45, 36.55],
  [74.88, 134.02],
  [55, -1.43],
  [56.61, 10.34],
  [49.87, 8.33],
  [41.12, 29.08],
  [54.97, -1.36],
  [49.7, -5.1],
  [50.43, -0.75],
  [21.27, 91.71],
  [48.42, -123.38],
  [69.93, 20.02],
  [25.87, -58.37],
  [48.42, -89.22],
  [48.57, 44.15],
  [57.02, -1.49],
  [43.62, 5.62],
  [42.24, -8.73],
  [31.67, 34.57],
  [5.28, -4.01],
  [51.05, 1.37],
  [50.57, 137],
  [55.25, 11.03],
  [35.2, 24.9],
  [-0.29, 117.66],
  [-0.01, 109.3],
  [18.47, -66.12],
  [34.33, 132.47],
  [53.63, 8.44],
  [58, -6.23],
  [54.02, -4.8],
  [49, 12.15],
  [50.13, -5.87],
  [32.42, 119.42],
  [-8.28, 111.14],
  [48.65, -123.45],
  [38.32, 26.3],
  [7.81, 98.43],
  [46.73, -71.32],
  [35.71, -0.64],
  [43.53, 139.25],
  [38.22, 19.9],
  [43.63, 51.21],
  [54, -130.37],
  [36.44, 22.88],
  [19.33, 106.92],
  [37.87, 24.75],
  [37.23, 15.19],
  [-12.02, -77.18],
  [51.11, 1.58],
  [57.68, 10.65],
  [62.44, 6.27],
  [19.62, 37.23],
  [37.75, 23.43],
  [45.53, -73.52],
  [35.07, 130],
  [50, -6.07],
  [52.43, 4],
  [41.28, 31.42],
  [-19.26, 146.83],
  [19.05, -104.33],
  [41.63, -70.91],
  [44.74, 37.79],
  [-3.4, 126.67],
  [48.37, -123.38],
  [49.97, -3],
  [41.9, -83.05],
  [40.89, 29.19],
  [54.13, 13.73],
  [49.04, -123.11],
  [42.34, -82.97],
  [52.23, -5.33],
  [27.02, -90.4],
  [34.7, 33.34],
  [49.28, -122.08],
  [33.25, 131.86],
  [-27.41, 153.16],
  [25.27, 55.29],
  [1.52, 104.67],
  [11, 124.6],
  [40.84, 29.29],
  [31.25, 121.5],
  [61.23, -149.89],
  [10.85, 121.02],
  [54.98, 11.88],
  [40.4, 29.07],
  [56.1, 47.48],
  [36.4, 25.4],
  [51.33, 3.82],
  [-44.38, 171.25],
  [55.87, -5.43],
  [10.77, 106.72],
]
